import { heFetch as Ft, setLandingPageFetchConfig as ca } from "./libServices.js";
import { jsx as g, jsxs as C, Fragment as Re } from "react/jsx-runtime";
import * as _ from "react";
import S, { createElement as fe, isValidElement as st, cloneElement as Ht, Children as ga, Fragment as da, createContext as Yo, useContext as Wt, useCallback as ct, useState as F, useRef as Ge, useEffect as ke, useMemo as ua, forwardRef as Zo } from "react";
import * as ba from "react-dom";
import _a from "react-dom";
function ha(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var xt, io;
function fa() {
  return io || (io = 1, xt = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), xt;
}
var pa = fa();
const ma = /* @__PURE__ */ ha(pa);
var va = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function ro(t) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, o = t.match(/<\/?([^\s]+?)[/\s>]/);
  if (o && (e.name = o[1], (ma[o[1]] || t.charAt(t.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var l = t.indexOf("-->");
    return { type: "comment", comment: l !== -1 ? t.slice(4, l) : "" };
  }
  for (var a = new RegExp(va), n = null; (n = a.exec(t)) !== null; ) if (n[0].trim()) if (n[1]) {
    var r = n[1].trim(), i = [r, ""];
    r.indexOf("=") > -1 && (i = r.split("=")), e.attrs[i[0]] = i[1], a.lastIndex--;
  } else n[2] && (e.attrs[n[2]] = n[3].trim().substring(1, n[3].length - 1));
  return e;
}
var ya = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, ka = /^\s*$/, wa = /* @__PURE__ */ Object.create(null);
function Qo(t, e) {
  switch (e.type) {
    case "text":
      return t + e.content;
    case "tag":
      return t += "<" + e.name + (e.attrs ? function(o) {
        var l = [];
        for (var a in o) l.push(a + '="' + o[a] + '"');
        return l.length ? " " + l.join(" ") : "";
      }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(Qo, "") + "</" + e.name + ">";
    case "comment":
      return t + "<!--" + e.comment + "-->";
  }
}
var $a = { parse: function(t, e) {
  e || (e = {}), e.components || (e.components = wa);
  var o, l = [], a = [], n = -1, r = !1;
  if (t.indexOf("<") !== 0) {
    var i = t.indexOf("<");
    l.push({ type: "text", content: i === -1 ? t : t.substring(0, i) });
  }
  return t.replace(ya, function(c, s) {
    if (r) {
      if (c !== "</" + o.name + ">") return;
      r = !1;
    }
    var d, u = c.charAt(1) !== "/", b = c.startsWith("<!--"), f = s + c.length, p = t.charAt(f);
    if (b) {
      var h = ro(c);
      return n < 0 ? (l.push(h), l) : ((d = a[n]).children.push(h), l);
    }
    if (u && (n++, (o = ro(c)).type === "tag" && e.components[o.name] && (o.type = "component", r = !0), o.voidElement || r || !p || p === "<" || o.children.push({ type: "text", content: t.slice(f, t.indexOf("<", f)) }), n === 0 && l.push(o), (d = a[n - 1]) && d.children.push(o), a[n] = o), (!u || o.voidElement) && (n > -1 && (o.voidElement || o.name === c.slice(2, -1)) && (n--, o = n === -1 ? l : a[n]), !r && p !== "<" && p)) {
      d = n === -1 ? l : a[n].children;
      var v = t.indexOf("<", f), m = t.slice(f, v === -1 ? void 0 : v);
      ka.test(m) && (m = " "), (v > -1 && n + d.length >= 0 || m !== " ") && d.push({ type: "text", content: m });
    }
  }), l;
}, stringify: function(t) {
  return t.reduce(function(e, o) {
    return e + Qo("", o);
  }, "");
} };
const nt = (t, e, o, l) => {
  const a = [o, {
    code: e,
    ...l || {}
  }];
  if (t?.services?.logger?.forward)
    return t.services.logger.forward(a, "warn", "react-i18next::", !0);
  K(a[0]) && (a[0] = `react-i18next:: ${a[0]}`), t?.services?.logger?.warn ? t.services.logger.warn(...a) : console?.warn && console.warn(...a);
}, so = {}, Fe = (t, e, o, l) => {
  K(o) && so[o] || (K(o) && (so[o] = /* @__PURE__ */ new Date()), nt(t, e, o, l));
}, Xo = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const o = () => {
      setTimeout(() => {
        t.off("initialized", o);
      }, 0), e();
    };
    t.on("initialized", o);
  }
}, Lt = (t, e, o) => {
  t.loadNamespaces(e, Xo(t, o));
}, co = (t, e, o, l) => {
  if (K(o) && (o = [o]), t.options.preload && t.options.preload.indexOf(e) > -1) return Lt(t, o, l);
  o.forEach((a) => {
    t.options.ns.indexOf(a) < 0 && t.options.ns.push(a);
  }), t.loadLanguages(e, Xo(t, l));
}, xa = (t, e, o = {}) => !e.languages || !e.languages.length ? (Fe(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(t, {
  lng: o.lng,
  precheck: (l, a) => {
    if (o.bindI18n && o.bindI18n.indexOf("languageChanging") > -1 && l.services.backendConnector.backend && l.isLanguageChangingTo && !a(l.isLanguageChangingTo, t)) return !1;
  }
}), K = (t) => typeof t == "string", pe = (t) => typeof t == "object" && t !== null, ja = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, za = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Ca = (t) => za[t], Oa = (t) => t.replace(ja, Ca);
let Ea = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Oa
};
const el = () => Ea;
let Sa;
const Vt = () => Sa, jt = (t, e) => {
  if (!t) return !1;
  const o = t.props?.children ?? t.children;
  return e ? o.length > 0 : !!o;
}, zt = (t) => {
  if (!t) return [];
  const e = t.props?.children ?? t.children;
  return t.props?.i18nIsDynamicList ? Se(e) : e;
}, Da = (t) => Array.isArray(t) && t.every(st), Se = (t) => Array.isArray(t) ? t : [t], Na = (t, e) => {
  const o = {
    ...e
  };
  return o.props = Object.assign(t.props, e.props), o;
}, tl = (t, e, o, l) => {
  if (!t) return "";
  let a = "";
  const n = Se(t), r = e?.transSupportBasicHtmlNodes ? e.transKeepBasicHtmlNodesFor ?? [] : [];
  return n.forEach((i, c) => {
    if (K(i)) {
      a += `${i}`;
      return;
    }
    if (st(i)) {
      const {
        props: s,
        type: d
      } = i, u = Object.keys(s).length, b = r.indexOf(d) > -1, f = s.children;
      if (!f && b && !u) {
        a += `<${d}/>`;
        return;
      }
      if (!f && (!b || u) || s.i18nIsDynamicList) {
        a += `<${c}></${c}>`;
        return;
      }
      if (b && u === 1 && K(f)) {
        a += `<${d}>${f}</${d}>`;
        return;
      }
      const p = tl(f, e, o, l);
      a += `<${c}>${p}</${c}>`;
      return;
    }
    if (i === null) {
      nt(o, "TRANS_NULL_VALUE", "Passed in a null value as child", {
        i18nKey: l
      });
      return;
    }
    if (pe(i)) {
      const {
        format: s,
        ...d
      } = i, u = Object.keys(d);
      if (u.length === 1) {
        const b = s ? `${u[0]}, ${s}` : u[0];
        a += `{{${b}}}`;
        return;
      }
      nt(o, "TRANS_INVALID_OBJ", "Invalid child - Object should only have keys {{ value, format }} (format is optional).", {
        i18nKey: l,
        child: i
      });
      return;
    }
    nt(o, "TRANS_INVALID_VAR", "Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.", {
      i18nKey: l,
      child: i
    });
  }), a;
}, Ma = (t, e, o, l, a, n, r) => {
  if (o === "") return [];
  const i = a.transKeepBasicHtmlNodesFor || [], c = o && new RegExp(i.map((m) => `<${m}`).join("|")).test(o);
  if (!t && !e && !c && !r) return [o];
  const s = e ?? {}, d = (m) => {
    Se(m).forEach((y) => {
      K(y) || (jt(y) ? d(zt(y)) : pe(y) && !st(y) && Object.assign(s, y));
    });
  };
  d(t);
  const u = $a.parse(`<0>${o}</0>`), b = {
    ...s,
    ...n
  }, f = (m, w, y) => {
    const k = zt(m), x = h(k, w.children, y);
    return Da(k) && x.length === 0 || m.props?.i18nIsDynamicList ? k : x;
  }, p = (m, w, y, k, x) => {
    m.dummy ? (m.children = w, y.push(Ht(m, {
      key: k
    }, x ? void 0 : w))) : y.push(...ga.map([m], (j) => {
      const $ = {
        ...j.props
      };
      return delete $.i18nIsDynamicList, fe(j.type, {
        ...$,
        key: k,
        ref: j.props.ref ?? j.ref
      }, x ? null : w);
    }));
  }, h = (m, w, y) => {
    const k = Se(m);
    return Se(w).reduce((j, $, M) => {
      const N = $.children?.[0]?.content && l.services.interpolator.interpolate($.children[0].content, b, l.language);
      if ($.type === "tag") {
        let O = k[parseInt($.name, 10)];
        !O && e && (O = e[$.name]), y.length === 1 && !O && (O = y[0][$.name]), O || (O = {});
        const A = Object.keys($.attrs).length !== 0 ? Na({
          props: $.attrs
        }, O) : O, be = st(A), T = be && jt($, !0) && !$.voidElement, q = c && pe(A) && A.dummy && !be, Je = pe(e) && Object.hasOwnProperty.call(e, $.name);
        if (K(A)) {
          const E = l.services.interpolator.interpolate(A, b, l.language);
          j.push(E);
        } else if (jt(A) || T) {
          const E = f(A, $, y);
          p(A, E, j, M);
        } else if (q) {
          const E = h(k, $.children, y);
          p(A, E, j, M);
        } else if (Number.isNaN(parseFloat($.name)))
          if (Je) {
            const E = f(A, $, y);
            p(A, E, j, M, $.voidElement);
          } else if (a.transSupportBasicHtmlNodes && i.indexOf($.name) > -1)
            if ($.voidElement)
              j.push(fe($.name, {
                key: `${$.name}-${M}`
              }));
            else {
              const E = h(k, $.children, y);
              j.push(fe($.name, {
                key: `${$.name}-${M}`
              }, E));
            }
          else if ($.voidElement)
            j.push(`<${$.name} />`);
          else {
            const E = h(k, $.children, y);
            j.push(`<${$.name}>${E}</${$.name}>`);
          }
        else if (pe(A) && !be) {
          const E = $.children[0] ? N : null;
          E && j.push(E);
        } else
          p(A, N, j, M, $.children.length !== 1 || !N);
      } else if ($.type === "text") {
        const O = a.transWrapTextNodes, A = r ? a.unescape(l.services.interpolator.interpolate($.content, b, l.language)) : l.services.interpolator.interpolate($.content, b, l.language);
        O ? j.push(fe(O, {
          key: `${$.name}-${M}`
        }, A)) : j.push(A);
      }
      return j;
    }, []);
  }, v = h([{
    dummy: !0,
    children: t || []
  }], u, Se(t || []));
  return zt(v[0]);
}, ol = (t, e, o) => {
  const l = t.key || e, a = Ht(t, {
    key: l
  });
  if (!a.props || !a.props.children || o.indexOf(`${e}/>`) < 0 && o.indexOf(`${e} />`) < 0)
    return a;
  function n() {
    return fe(da, null, a);
  }
  return fe(n, {
    key: l
  });
}, Pa = (t, e) => t.map((o, l) => ol(o, l, e)), Aa = (t, e) => {
  const o = {};
  return Object.keys(t).forEach((l) => {
    Object.assign(o, {
      [l]: ol(t[l], l, e)
    });
  }), o;
}, La = (t, e, o, l) => t ? Array.isArray(t) ? Pa(t, e) : pe(t) ? Aa(t, e) : (Fe(o, "TRANS_INVALID_COMPONENTS", '<Trans /> "components" prop expects an object or array', {
  i18nKey: l
}), null) : null, Ta = (t) => !pe(t) || Array.isArray(t) ? !1 : Object.keys(t).reduce((e, o) => e && Number.isNaN(Number.parseFloat(o)), !0);
function qa({
  children: t,
  count: e,
  parent: o,
  i18nKey: l,
  context: a,
  tOptions: n = {},
  values: r,
  defaults: i,
  components: c,
  ns: s,
  i18n: d,
  t: u,
  shouldUnescape: b,
  ...f
}) {
  const p = d || Vt();
  if (!p)
    return Fe(p, "NO_I18NEXT_INSTANCE", "Trans: You need to pass in an i18next instance using i18nextReactModule", {
      i18nKey: l
    }), t;
  const h = u || p.t.bind(p) || ((q) => q), v = {
    ...el(),
    ...p.options?.react
  };
  let m = s || h.ns || p.options?.defaultNS;
  m = K(m) ? [m] : m || ["translation"];
  const w = tl(t, v, p, l), y = i || w || v.transEmptyNodeValue || l, {
    hashTransKey: k
  } = v, x = l || (k ? k(w || y) : w || y);
  p.options?.interpolation?.defaultVariables && (r = r && Object.keys(r).length > 0 ? {
    ...r,
    ...p.options.interpolation.defaultVariables
  } : {
    ...p.options.interpolation.defaultVariables
  });
  const j = r || e !== void 0 && !p.options?.interpolation?.alwaysFormat || !t ? n.interpolation : {
    interpolation: {
      ...n.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, $ = {
    ...n,
    context: a || n.context,
    count: e,
    ...r,
    ...j,
    defaultValue: y,
    ns: m
  }, M = x ? h(x, $) : y, N = La(c, M, p, l);
  let O = N || t, A = null;
  Ta(N) && (A = N, O = t);
  const be = Ma(O, A, M, p, v, $, b), T = o ?? v.defaultTransParent;
  return T ? fe(T, f, be) : be;
}
const Gt = Yo();
class Ia {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((o) => {
      this.usedNamespaces[o] || (this.usedNamespaces[o] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function Ba({
  children: t,
  count: e,
  parent: o,
  i18nKey: l,
  context: a,
  tOptions: n = {},
  values: r,
  defaults: i,
  components: c,
  ns: s,
  i18n: d,
  t: u,
  shouldUnescape: b,
  ...f
}) {
  const {
    i18n: p,
    defaultNS: h
  } = Wt(Gt) || {}, v = d || p || Vt(), m = u || v?.t.bind(v);
  return qa({
    children: t,
    count: e,
    parent: o,
    i18nKey: l,
    context: a,
    tOptions: n,
    values: r,
    defaults: i,
    components: c,
    ns: s || m?.ns || h || v?.options?.defaultNS,
    i18n: v,
    t: u,
    shouldUnescape: b,
    ...f
  });
}
const Ra = (t, e) => {
  const o = Ge();
  return ke(() => {
    o.current = t;
  }, [t, e]), o.current;
}, ll = (t, e, o, l) => t.getFixedT(e, o, l), Fa = (t, e, o, l) => ct(ll(t, e, o, l), [t, e, o, l]), ae = (t, e = {}) => {
  const {
    i18n: o
  } = e, {
    i18n: l,
    defaultNS: a
  } = Wt(Gt) || {}, n = o || l || Vt();
  if (n && !n.reportNamespaces && (n.reportNamespaces = new Ia()), !n) {
    Fe(n, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const k = (j, $) => K($) ? $ : pe($) && K($.defaultValue) ? $.defaultValue : Array.isArray(j) ? j[j.length - 1] : j, x = [k, {}, !1];
    return x.t = k, x.i18n = {}, x.ready = !1, x;
  }
  n.options.react?.wait && Fe(n, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const r = {
    ...el(),
    ...n.options.react,
    ...e
  }, {
    useSuspense: i,
    keyPrefix: c
  } = r;
  let s = t || a || n.options?.defaultNS;
  s = K(s) ? [s] : s || ["translation"], n.reportNamespaces.addUsedNamespaces?.(s);
  const d = (n.isInitialized || n.initializedStoreOnce) && s.every((k) => xa(k, n, r)), u = Fa(n, e.lng || null, r.nsMode === "fallback" ? s : s[0], c), b = () => u, f = () => ll(n, e.lng || null, r.nsMode === "fallback" ? s : s[0], c), [p, h] = F(b);
  let v = s.join();
  e.lng && (v = `${e.lng}${v}`);
  const m = Ra(v), w = Ge(!0);
  ke(() => {
    const {
      bindI18n: k,
      bindI18nStore: x
    } = r;
    w.current = !0, !d && !i && (e.lng ? co(n, e.lng, s, () => {
      w.current && h(f);
    }) : Lt(n, s, () => {
      w.current && h(f);
    })), d && m && m !== v && w.current && h(f);
    const j = () => {
      w.current && h(f);
    };
    return k && n?.on(k, j), x && n?.store.on(x, j), () => {
      w.current = !1, n && k && k?.split(" ").forEach(($) => n.off($, j)), x && n && x.split(" ").forEach(($) => n.store.off($, j));
    };
  }, [n, v]), ke(() => {
    w.current && d && h(b);
  }, [n, c, d]);
  const y = [p, n, d];
  if (y.t = p, y.i18n = n, y.ready = d, d || !d && !i) return y;
  throw new Promise((k) => {
    e.lng ? co(n, e.lng, s, () => k()) : Lt(n, s, () => k());
  });
};
function Ha({
  i18n: t,
  defaultNS: e,
  children: o
}) {
  const l = ua(() => ({
    i18n: t,
    defaultNS: e
  }), [t, e]);
  return fe(Gt.Provider, {
    value: l
  }, o);
}
const H = (t, e, o) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: l, ...a } = o || {}, n = (r) => {
    l && typeof l == "function" && r.startsWith("GTM-") && l(r);
  };
  window.dataLayer.push({
    event: t,
    event_data: e,
    ...a,
    eventCallback: n
  }), !window.google_tag_manager && o?.eventCallback && typeof o.eventCallback == "function" && o.eventCallback();
};
function al(t) {
  var e, o, l = "";
  if (typeof t == "string" || typeof t == "number") l += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var a = t.length;
    for (e = 0; e < a; e++) t[e] && (o = al(t[e])) && (l && (l += " "), l += o);
  } else for (o in t) t[o] && (l && (l += " "), l += o);
  return l;
}
function D() {
  for (var t, e, o = 0, l = "", a = arguments.length; o < a; o++) (t = arguments[o]) && (e = al(t)) && (l && (l += " "), l += e);
  return l;
}
const Wa = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Va = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Ga = Wa.map((t) => ({
  name: t,
  class: `icon-${t}`,
  paths: Va[t]
})), Ua = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Ka = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Ja(t = 0) {
  const e = [];
  for (let o = 0; o < t; o++)
    e[o] = `path${o + 1}`;
  return e.map((o) => /* @__PURE__ */ g("span", { className: o }, o));
}
const me = Zo(
  ({ name: t, size: e = "medium", color: o = "base", className: l = "", ...a }, n) => {
    const r = Ga.find((c) => c.name === t), i = D("icon", `ds-${r?.class}`, Ka[e], Ua[o], l);
    return /* @__PURE__ */ g("i", { className: i, ...a, ref: n, children: Ja(r?.paths) });
  }
);
me.displayName = "Icon";
const Ya = "_loader_1ksyv_29", Za = "_circle_1ksyv_41", xe = {
  loader: Ya,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Za,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Qa = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Xa = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function en({ onDark: t, size: e = "medium", color: o = "primary", className: l }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      className: D(
        xe.loader,
        xe[Qa[e]],
        xe[Xa[o]],
        t && xe["on-dark"],
        l
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ g("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ g("circle", { className: xe.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ C(
          "circle",
          {
            className: xe["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ g("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ g(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const tn = "_button_z1os6_29", on = "_disabled_z1os6_43", ln = "_loader_z1os6_263", se = {
  button: tn,
  disabled: on,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: ln,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, Y = Zo(
  ({
    text: t,
    color: e = "primary",
    size: o = "medium",
    isFullWidth: l = !1,
    icon: a,
    iconPosition: n = "left",
    isLoading: r = !1,
    iconSize: i = "medium",
    isContrasted: c = !1,
    disabled: s = !1,
    className: d,
    children: u,
    ...b
  }, f) => {
    const p = D(
      se.button,
      se[an[e]],
      se[nn[o]],
      l && se["is-full-width"],
      s && se.disabled,
      n === "right" && se["has-icon-right"],
      c && se["is-contrasted"],
      r && se["is-loading"],
      d
    ), h = /* @__PURE__ */ C(Re, { children: [
      r && /* @__PURE__ */ g(en, { className: se.loader, onDark: !0, size: "small" }),
      a && n === "left" && /* @__PURE__ */ g(me, { color: "inherit", size: i, name: a }),
      u ?? t,
      a && n === "right" && /* @__PURE__ */ g(me, { color: "inherit", size: i, name: a })
    ] });
    if (rn(b))
      return /* @__PURE__ */ g(
        "a",
        {
          ...b,
          href: s ? void 0 : b.href,
          className: p,
          target: b.target,
          ref: f,
          children: h
        }
      );
    if (sn(b))
      return /* @__PURE__ */ g(
        "button",
        {
          disabled: r || s,
          ...b,
          className: p,
          ref: f,
          children: h
        }
      );
  }
);
Y.displayName = "Button";
const an = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, nn = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function rn(t) {
  return "href" in t && typeof t.href == "string";
}
function sn(t) {
  return !("href" in t);
}
const cn = "_buttons_1obz3_29", go = {
  buttons: cn,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, gn = ({ children: t, flexGrowButtons: e }) => /* @__PURE__ */ g("div", { className: D(go.buttons, e && go["flex-grow-buttons"]), children: t }), uo = {
  MOBILE: 640,
  TABLET: 768
}, dn = "_text_1tduc_29", _e = {
  text: dn,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function P({
  children: t,
  dangerouslySetInnerHTML: e,
  isSmall: o,
  isUppercase: l,
  ellipsis: a,
  isSpan: n,
  className: r = "",
  color: i = "primary",
  isBold: c,
  size: s,
  title: d,
  center: u,
  ...b
}) {
  const f = D(
    _e.text,
    o && _e["is-small"],
    a && _e["is-ellipsis"],
    i && _e[`color-${i}`],
    c && _e["is-bold"],
    l && _e["is-uppercase"],
    s && _e[`size-${s}`],
    u && _e["is-center"],
    r
  ), p = n ? "span" : "div";
  return e ? /* @__PURE__ */ g(p, { className: f, dangerouslySetInnerHTML: e, ...b, title: d }) : /* @__PURE__ */ g(p, { className: f, ...b, children: t });
}
const un = "_title_1s6y9_29", bn = "_subtitle_1s6y9_106", ye = {
  "title-container": "_title-container_1s6y9_29",
  "color-inverted": "_color-inverted_1s6y9_32",
  "is-primary": "_is-primary_1s6y9_35",
  "is-secondary": "_is-secondary_1s6y9_38",
  "is-tertiary": "_is-tertiary_1s6y9_41",
  "is-success": "_is-success_1s6y9_44",
  "is-error": "_is-error_1s6y9_47",
  "is-eco-green": "_is-eco-green_1s6y9_50",
  title: un,
  "is-1": "_is-1_1s6y9_61",
  "is-impact": "_is-impact_1s6y9_70",
  "is-2": "_is-2_1s6y9_74",
  "is-3": "_is-3_1s6y9_84",
  "text-align-left": "_text-align-left_1s6y9_94",
  "text-align-right": "_text-align-right_1s6y9_97",
  "text-align-center": "_text-align-center_1s6y9_100",
  "text-align-justify": "_text-align-justify_1s6y9_103",
  subtitle: bn,
  "dialog-overlay-show": "_dialog-overlay-show_1s6y9_1",
  "dialog-content-show": "_dialog-content-show_1s6y9_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1s6y9_1"
}, _n = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function J({
  color: t = "default",
  children: e,
  level: o = 3,
  hasHeaderTag: l = !1,
  isImpact: a,
  subtitle: n,
  className: r = "",
  title: i,
  textAlign: c,
  ...s
}) {
  const d = `h${o}`, u = `${l ? d : "p"}`, b = D(
    ye.title,
    ye[`is-${o}`],
    a && ye["is-impact"],
    c && ye[`text-align-${c}`],
    r
  );
  return /* @__PURE__ */ C("div", { className: D(ye["title-container"], ye[_n[t]]), children: [
    /* @__PURE__ */ g(u, { className: b, ...s, title: i, children: e }),
    n && /* @__PURE__ */ g("p", { className: D(ye.subtitle), children: n })
  ] });
}
const Ze = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, hn = ({ alignSelf: t, justifySelf: e, children: o, isFullWidth: l, ...a }) => {
  const n = D(
    Ze["flex-children"],
    t && Ze[`align-self-${t}`],
    e && Ze[`justify-self-${e}`],
    l && Ze["is-full-width"]
  );
  return /* @__PURE__ */ g("div", { className: n, ...a, children: o });
}, fn = "_flex_1y1zn_29", pn = "_wrap_1y1zn_67", mn = "_nowrap_1y1zn_70", vn = "_shrink_1y1zn_88", G = {
  flex: fn,
  "flex-row": "_flex-row_1y1zn_34",
  "flex-column": "_flex-column_1y1zn_37",
  "justify-start": "_justify-start_1y1zn_40",
  "justify-end": "_justify-end_1y1zn_43",
  "justify-center": "_justify-center_1y1zn_46",
  "justify-space-between": "_justify-space-between_1y1zn_49",
  "justify-space-around": "_justify-space-around_1y1zn_52",
  "align-start": "_align-start_1y1zn_55",
  "align-end": "_align-end_1y1zn_58",
  "align-center": "_align-center_1y1zn_61",
  "align-stretch": "_align-stretch_1y1zn_64",
  wrap: pn,
  nowrap: mn,
  "wrap-reverse": "_wrap-reverse_1y1zn_73",
  "is-full-width": "_is-full-width_1y1zn_79",
  "is-full-height": "_is-full-height_1y1zn_82",
  "flex-grow": "_flex-grow_1y1zn_85",
  shrink: vn,
  "hide-on-mobile": "_hide-on-mobile_1y1zn_91",
  "is-scrollable": "_is-scrollable_1y1zn_99",
  "gap-0": "_gap-0_1y1zn_105",
  "gap-1": "_gap-1_1y1zn_108",
  "gap-2": "_gap-2_1y1zn_111",
  "gap-3": "_gap-3_1y1zn_114",
  "gap-4": "_gap-4_1y1zn_117",
  "gap-5": "_gap-5_1y1zn_120",
  "gap-6": "_gap-6_1y1zn_123",
  "gap-7": "_gap-7_1y1zn_126",
  "gap-8": "_gap-8_1y1zn_129",
  "gap-9": "_gap-9_1y1zn_132",
  "gap-10": "_gap-10_1y1zn_135",
  "gap-11": "_gap-11_1y1zn_138",
  "gap-12": "_gap-12_1y1zn_141",
  "gap-14": "_gap-14_1y1zn_144",
  "gap-16": "_gap-16_1y1zn_147",
  "gap-18": "_gap-18_1y1zn_150",
  "gap-20": "_gap-20_1y1zn_153",
  "gap-24": "_gap-24_1y1zn_156",
  "gap-28": "_gap-28_1y1zn_159",
  "gap-32": "_gap-32_1y1zn_162",
  "gap-36": "_gap-36_1y1zn_165",
  "gap-40": "_gap-40_1y1zn_168",
  "gap-44": "_gap-44_1y1zn_171",
  "gap-48": "_gap-48_1y1zn_174",
  "gap-52": "_gap-52_1y1zn_177",
  "gap-56": "_gap-56_1y1zn_180",
  "gap-60": "_gap-60_1y1zn_183",
  "gap-64": "_gap-64_1y1zn_186",
  "gap-72": "_gap-72_1y1zn_189",
  "gap-80": "_gap-80_1y1zn_192",
  "gap-96": "_gap-96_1y1zn_195",
  "no-margin": "_no-margin_1y1zn_198",
  "dialog-overlay-show": "_dialog-overlay-show_1y1zn_1",
  "dialog-content-show": "_dialog-content-show_1y1zn_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1y1zn_1"
};
function I({
  children: t,
  direction: e = "row",
  justifyContent: o = "start",
  alignItems: l = "start",
  flexWrap: a = "wrap",
  className: n = "",
  isFullWidth: r = !1,
  isFullHeight: i = !1,
  gap: c,
  style: s,
  noMargin: d = !1,
  flexGrow: u = !1,
  hideOnMobile: b = !1,
  shrink: f = !1,
  isScrollable: p = !1,
  ...h
}) {
  const v = D(
    G.flex,
    G[`flex-${e}`],
    G[`justify-${o}`],
    G[`align-${l}`],
    G[a],
    r && G["is-full-width"],
    i && G["is-full-height"],
    c && G[`gap-${c}`],
    d && G["no-margin"],
    u && G["flex-grow"],
    b && G["hide-on-mobile"],
    f && G.shrink,
    p && G["is-scrollable"],
    n
  );
  return /* @__PURE__ */ g("div", { className: v, ...h, style: s, children: t });
}
I.FlexChildren = hn;
function oe(t, e, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(l) {
    if (t?.(l), o === !1 || !l.defaultPrevented)
      return e?.(l);
  };
}
var Ne = globalThis?.document ? _.useLayoutEffect : () => {
}, yn = _[" useInsertionEffect ".trim().toString()] || Ne;
function ft({
  prop: t,
  defaultProp: e,
  onChange: o = () => {
  },
  caller: l
}) {
  const [a, n, r] = kn({
    defaultProp: e,
    onChange: o
  }), i = t !== void 0, c = i ? t : a;
  {
    const d = _.useRef(t !== void 0);
    _.useEffect(() => {
      const u = d.current;
      u !== i && console.warn(
        `${l} is changing from ${u ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = i;
    }, [i, l]);
  }
  const s = _.useCallback(
    (d) => {
      if (i) {
        const u = wn(d) ? d(t) : d;
        u !== t && r.current?.(u);
      } else
        n(d);
    },
    [i, t, n, r]
  );
  return [c, s];
}
function kn({
  defaultProp: t,
  onChange: e
}) {
  const [o, l] = _.useState(t), a = _.useRef(o), n = _.useRef(e);
  return yn(() => {
    n.current = e;
  }, [e]), _.useEffect(() => {
    a.current !== o && (n.current?.(o), a.current = o);
  }, [o, a]), [o, l, n];
}
function wn(t) {
  return typeof t == "function";
}
function bo(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function nl(...t) {
  return (e) => {
    let o = !1;
    const l = t.map((a) => {
      const n = bo(a, e);
      return !o && typeof n == "function" && (o = !0), n;
    });
    if (o)
      return () => {
        for (let a = 0; a < l.length; a++) {
          const n = l[a];
          typeof n == "function" ? n() : bo(t[a], null);
        }
      };
  };
}
function Z(...t) {
  return _.useCallback(nl(...t), t);
}
function $n(t, e) {
  const o = _.createContext(e), l = (n) => {
    const { children: r, ...i } = n, c = _.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ g(o.Provider, { value: c, children: r });
  };
  l.displayName = t + "Provider";
  function a(n) {
    const r = _.useContext(o);
    if (r) return r;
    if (e !== void 0) return e;
    throw new Error(`\`${n}\` must be used within \`${t}\``);
  }
  return [l, a];
}
function pt(t, e = []) {
  let o = [];
  function l(n, r) {
    const i = _.createContext(r), c = o.length;
    o = [...o, r];
    const s = (u) => {
      const { scope: b, children: f, ...p } = u, h = b?.[t]?.[c] || i, v = _.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ g(h.Provider, { value: v, children: f });
    };
    s.displayName = n + "Provider";
    function d(u, b) {
      const f = b?.[t]?.[c] || i, p = _.useContext(f);
      if (p) return p;
      if (r !== void 0) return r;
      throw new Error(`\`${u}\` must be used within \`${n}\``);
    }
    return [s, d];
  }
  const a = () => {
    const n = o.map((r) => _.createContext(r));
    return function(r) {
      const i = r?.[t] || n;
      return _.useMemo(
        () => ({ [`__scope${t}`]: { ...r, [t]: i } }),
        [r, i]
      );
    };
  };
  return a.scopeName = t, [l, xn(a, ...e)];
}
function xn(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const o = () => {
    const l = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(a) {
      const n = l.reduce((r, { useScope: i, scopeName: c }) => {
        const s = i(a)[`__scope${c}`];
        return { ...r, ...s };
      }, {});
      return _.useMemo(() => ({ [`__scope${e.scopeName}`]: n }), [n]);
    };
  };
  return o.scopeName = e.scopeName, o;
}
// @__NO_SIDE_EFFECTS__
function gt(t) {
  const e = /* @__PURE__ */ jn(t), o = _.forwardRef((l, a) => {
    const { children: n, ...r } = l, i = _.Children.toArray(n), c = i.find(Cn);
    if (c) {
      const s = c.props.children, d = i.map((u) => u === c ? _.Children.count(s) > 1 ? _.Children.only(null) : _.isValidElement(s) ? s.props.children : null : u);
      return /* @__PURE__ */ g(e, { ...r, ref: a, children: _.isValidElement(s) ? _.cloneElement(s, void 0, d) : null });
    }
    return /* @__PURE__ */ g(e, { ...r, ref: a, children: n });
  });
  return o.displayName = `${t}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function jn(t) {
  const e = _.forwardRef((o, l) => {
    const { children: a, ...n } = o;
    if (_.isValidElement(a)) {
      const r = En(a), i = On(n, a.props);
      return a.type !== _.Fragment && (i.ref = l ? nl(l, r) : r), _.cloneElement(a, i);
    }
    return _.Children.count(a) > 1 ? _.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var zn = Symbol("radix.slottable");
function Cn(t) {
  return _.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === zn;
}
function On(t, e) {
  const o = { ...e };
  for (const l in e) {
    const a = t[l], n = e[l];
    /^on[A-Z]/.test(l) ? a && n ? o[l] = (...r) => {
      const i = n(...r);
      return a(...r), i;
    } : a && (o[l] = a) : l === "style" ? o[l] = { ...a, ...n } : l === "className" && (o[l] = [a, n].filter(Boolean).join(" "));
  }
  return { ...t, ...o };
}
function En(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, o = e && "isReactWarning" in e && e.isReactWarning;
  return o ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, o = e && "isReactWarning" in e && e.isReactWarning, o ? t.props.ref : t.props.ref || t.ref);
}
var Sn = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], W = Sn.reduce((t, e) => {
  const o = /* @__PURE__ */ gt(`Primitive.${e}`), l = _.forwardRef((a, n) => {
    const { asChild: r, ...i } = a, c = r ? o : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(c, { ...i, ref: n });
  });
  return l.displayName = `Primitive.${e}`, { ...t, [e]: l };
}, {});
function Dn(t, e) {
  t && ba.flushSync(() => t.dispatchEvent(e));
}
var Nn = _.createContext(void 0);
function Mn(t) {
  const e = _.useContext(Nn);
  return t || e || "ltr";
}
function Pn(t) {
  const e = t + "CollectionProvider", [o, l] = pt(e), [a, n] = o(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), r = (h) => {
    const { scope: v, children: m } = h, w = S.useRef(null), y = S.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g(a, { scope: v, itemMap: y, collectionRef: w, children: m });
  };
  r.displayName = e;
  const i = t + "CollectionSlot", c = /* @__PURE__ */ gt(i), s = S.forwardRef(
    (h, v) => {
      const { scope: m, children: w } = h, y = n(i, m), k = Z(v, y.collectionRef);
      return /* @__PURE__ */ g(c, { ref: k, children: w });
    }
  );
  s.displayName = i;
  const d = t + "CollectionItemSlot", u = "data-radix-collection-item", b = /* @__PURE__ */ gt(d), f = S.forwardRef(
    (h, v) => {
      const { scope: m, children: w, ...y } = h, k = S.useRef(null), x = Z(v, k), j = n(d, m);
      return S.useEffect(() => (j.itemMap.set(k, { ref: k, ...y }), () => void j.itemMap.delete(k))), /* @__PURE__ */ g(b, { [u]: "", ref: x, children: w });
    }
  );
  f.displayName = d;
  function p(h) {
    const v = n(t + "CollectionConsumer", h);
    return S.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m) return [];
      const w = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (y, k) => w.indexOf(y.ref.current) - w.indexOf(k.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: r, Slot: s, ItemSlot: f },
    p,
    l
  ];
}
var An = _[" useId ".trim().toString()] || (() => {
}), Ln = 0;
function Ie(t) {
  const [e, o] = _.useState(An());
  return Ne(() => {
    o((l) => l ?? String(Ln++));
  }, [t]), e ? `radix-${e}` : "";
}
function Tn(t, e) {
  return _.useReducer((o, l) => e[o][l] ?? o, t);
}
var Ue = (t) => {
  const { present: e, children: o } = t, l = qn(e), a = typeof o == "function" ? o({ present: l.isPresent }) : _.Children.only(o), n = Z(l.ref, In(a));
  return typeof o == "function" || l.isPresent ? _.cloneElement(a, { ref: n }) : null;
};
Ue.displayName = "Presence";
function qn(t) {
  const [e, o] = _.useState(), l = _.useRef(null), a = _.useRef(t), n = _.useRef("none"), r = t ? "mounted" : "unmounted", [i, c] = Tn(r, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return _.useEffect(() => {
    const s = Qe(l.current);
    n.current = i === "mounted" ? s : "none";
  }, [i]), Ne(() => {
    const s = l.current, d = a.current;
    if (d !== t) {
      const u = n.current, b = Qe(s);
      t ? c("MOUNT") : b === "none" || s?.display === "none" ? c("UNMOUNT") : c(d && u !== b ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Ne(() => {
    if (e) {
      let s;
      const d = e.ownerDocument.defaultView ?? window, u = (f) => {
        const p = Qe(l.current).includes(CSS.escape(f.animationName));
        if (f.target === e && p && (c("ANIMATION_END"), !a.current)) {
          const h = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", s = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = h);
          });
        }
      }, b = (f) => {
        f.target === e && (n.current = Qe(l.current));
      };
      return e.addEventListener("animationstart", b), e.addEventListener("animationcancel", u), e.addEventListener("animationend", u), () => {
        d.clearTimeout(s), e.removeEventListener("animationstart", b), e.removeEventListener("animationcancel", u), e.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: _.useCallback((s) => {
      l.current = s ? getComputedStyle(s) : null, o(s);
    }, [])
  };
}
function Qe(t) {
  return t?.animationName || "none";
}
function In(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, o = e && "isReactWarning" in e && e.isReactWarning;
  return o ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, o = e && "isReactWarning" in e && e.isReactWarning, o ? t.props.ref : t.props.ref || t.ref);
}
function He(t) {
  const e = _.useRef(t);
  return _.useEffect(() => {
    e.current = t;
  }), _.useMemo(() => (...o) => e.current?.(...o), []);
}
function Bn() {
  const [t, e] = F({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return ke(() => {
    function o() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", o), o(), () => window.removeEventListener("resize", o);
  }, []), t;
}
function il() {
  const { width: t } = Bn();
  let e = "desktop";
  return t && t <= uo.MOBILE ? e = "mobile" : t && t <= uo.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop",
    isReady: typeof window < "u"
  };
}
function Rn(t, e = globalThis?.document) {
  const o = He(t);
  _.useEffect(() => {
    const l = (a) => {
      a.key === "Escape" && o(a);
    };
    return e.addEventListener("keydown", l, { capture: !0 }), () => e.removeEventListener("keydown", l, { capture: !0 });
  }, [o, e]);
}
var Fn = "DismissableLayer", Tt = "dismissableLayer.update", Hn = "dismissableLayer.pointerDownOutside", Wn = "dismissableLayer.focusOutside", _o, rl = _.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), sl = _.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: o = !1,
      onEscapeKeyDown: l,
      onPointerDownOutside: a,
      onFocusOutside: n,
      onInteractOutside: r,
      onDismiss: i,
      ...c
    } = t, s = _.useContext(rl), [d, u] = _.useState(null), b = d?.ownerDocument ?? globalThis?.document, [, f] = _.useState({}), p = Z(e, ($) => u($)), h = Array.from(s.layers), [v] = [...s.layersWithOutsidePointerEventsDisabled].slice(-1), m = h.indexOf(v), w = d ? h.indexOf(d) : -1, y = s.layersWithOutsidePointerEventsDisabled.size > 0, k = w >= m, x = Un(($) => {
      const M = $.target, N = [...s.branches].some((O) => O.contains(M));
      !k || N || (a?.($), r?.($), $.defaultPrevented || i?.());
    }, b), j = Kn(($) => {
      const M = $.target;
      [...s.branches].some((N) => N.contains(M)) || (n?.($), r?.($), $.defaultPrevented || i?.());
    }, b);
    return Rn(($) => {
      w === s.layers.size - 1 && (l?.($), !$.defaultPrevented && i && ($.preventDefault(), i()));
    }, b), _.useEffect(() => {
      if (d)
        return o && (s.layersWithOutsidePointerEventsDisabled.size === 0 && (_o = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), s.layersWithOutsidePointerEventsDisabled.add(d)), s.layers.add(d), ho(), () => {
          o && s.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = _o);
        };
    }, [d, b, o, s]), _.useEffect(() => () => {
      d && (s.layers.delete(d), s.layersWithOutsidePointerEventsDisabled.delete(d), ho());
    }, [d, s]), _.useEffect(() => {
      const $ = () => f({});
      return document.addEventListener(Tt, $), () => document.removeEventListener(Tt, $);
    }, []), /* @__PURE__ */ g(
      W.div,
      {
        ...c,
        ref: p,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: oe(t.onFocusCapture, j.onFocusCapture),
        onBlurCapture: oe(t.onBlurCapture, j.onBlurCapture),
        onPointerDownCapture: oe(
          t.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
sl.displayName = Fn;
var Vn = "DismissableLayerBranch", Gn = _.forwardRef((t, e) => {
  const o = _.useContext(rl), l = _.useRef(null), a = Z(e, l);
  return _.useEffect(() => {
    const n = l.current;
    if (n)
      return o.branches.add(n), () => {
        o.branches.delete(n);
      };
  }, [o.branches]), /* @__PURE__ */ g(W.div, { ...t, ref: a });
});
Gn.displayName = Vn;
function Un(t, e = globalThis?.document) {
  const o = He(t), l = _.useRef(!1), a = _.useRef(() => {
  });
  return _.useEffect(() => {
    const n = (i) => {
      if (i.target && !l.current) {
        let c = function() {
          cl(
            Hn,
            o,
            s,
            { discrete: !0 }
          );
        };
        const s = { originalEvent: i };
        i.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = c, e.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", a.current);
      l.current = !1;
    }, r = window.setTimeout(() => {
      e.addEventListener("pointerdown", n);
    }, 0);
    return () => {
      window.clearTimeout(r), e.removeEventListener("pointerdown", n), e.removeEventListener("click", a.current);
    };
  }, [e, o]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => l.current = !0
  };
}
function Kn(t, e = globalThis?.document) {
  const o = He(t), l = _.useRef(!1);
  return _.useEffect(() => {
    const a = (n) => {
      n.target && !l.current && cl(Wn, o, { originalEvent: n }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, o]), {
    onFocusCapture: () => l.current = !0,
    onBlurCapture: () => l.current = !1
  };
}
function ho() {
  const t = new CustomEvent(Tt);
  document.dispatchEvent(t);
}
function cl(t, e, o, { discrete: l }) {
  const a = o.originalEvent.target, n = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: o });
  e && a.addEventListener(t, e, { once: !0 }), l ? Dn(a, n) : a.dispatchEvent(n);
}
var Jn = "Portal", gl = _.forwardRef((t, e) => {
  const { container: o, ...l } = t, [a, n] = _.useState(!1);
  Ne(() => n(!0), []);
  const r = o || a && globalThis?.document?.body;
  return r ? _a.createPortal(/* @__PURE__ */ g(W.div, { ...l, ref: e }), r) : null;
});
gl.displayName = Jn;
var ee = function() {
  return ee = Object.assign || function(t) {
    for (var e, o = 1, l = arguments.length; o < l; o++) {
      e = arguments[o];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, ee.apply(this, arguments);
};
function dl(t, e) {
  var o = {};
  for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && e.indexOf(l) < 0 && (o[l] = t[l]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, l = Object.getOwnPropertySymbols(t); a < l.length; a++)
      e.indexOf(l[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, l[a]) && (o[l[a]] = t[l[a]]);
  return o;
}
function Yn(t, e, o) {
  for (var l = 0, a = e.length, n; l < a; l++)
    (n || !(l in e)) && (n || (n = Array.prototype.slice.call(e, 0, l)), n[l] = e[l]);
  return t.concat(n || Array.prototype.slice.call(e));
}
var Ct = "focusScope.autoFocusOnMount", Ot = "focusScope.autoFocusOnUnmount", fo = { bubbles: !1, cancelable: !0 }, Zn = "FocusScope", ul = _.forwardRef((t, e) => {
  const {
    loop: o = !1,
    trapped: l = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: n,
    ...r
  } = t, [i, c] = _.useState(null), s = He(a), d = He(n), u = _.useRef(null), b = Z(e, (h) => c(h)), f = _.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  _.useEffect(() => {
    if (l) {
      let h = function(y) {
        if (f.paused || !i) return;
        const k = y.target;
        i.contains(k) ? u.current = k : he(u.current, { select: !0 });
      }, v = function(y) {
        if (f.paused || !i) return;
        const k = y.relatedTarget;
        k !== null && (i.contains(k) || he(u.current, { select: !0 }));
      }, m = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && he(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const w = new MutationObserver(m);
      return i && w.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), w.disconnect();
      };
    }
  }, [l, i, f.paused]), _.useEffect(() => {
    if (i) {
      mo.add(f);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const v = new CustomEvent(Ct, fo);
        i.addEventListener(Ct, s), i.dispatchEvent(v), v.defaultPrevented || (Qn(li(bl(i)), { select: !0 }), document.activeElement === h && he(i));
      }
      return () => {
        i.removeEventListener(Ct, s), setTimeout(() => {
          const v = new CustomEvent(Ot, fo);
          i.addEventListener(Ot, d), i.dispatchEvent(v), v.defaultPrevented || he(h ?? document.body, { select: !0 }), i.removeEventListener(Ot, d), mo.remove(f);
        }, 0);
      };
    }
  }, [i, s, d, f]);
  const p = _.useCallback(
    (h) => {
      if (!o && !l || f.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, m = document.activeElement;
      if (v && m) {
        const w = h.currentTarget, [y, k] = Xn(w);
        y && k ? !h.shiftKey && m === k ? (h.preventDefault(), o && he(y, { select: !0 })) : h.shiftKey && m === y && (h.preventDefault(), o && he(k, { select: !0 })) : m === w && h.preventDefault();
      }
    },
    [o, l, f.paused]
  );
  return /* @__PURE__ */ g(W.div, { tabIndex: -1, ...r, ref: b, onKeyDown: p });
});
ul.displayName = Zn;
function Qn(t, { select: e = !1 } = {}) {
  const o = document.activeElement;
  for (const l of t)
    if (he(l, { select: e }), document.activeElement !== o) return;
}
function Xn(t) {
  const e = bl(t), o = po(e, t), l = po(e.reverse(), t);
  return [o, l];
}
function bl(t) {
  const e = [], o = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (l) => {
      const a = l.tagName === "INPUT" && l.type === "hidden";
      return l.disabled || l.hidden || a ? NodeFilter.FILTER_SKIP : l.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) e.push(o.currentNode);
  return e;
}
function po(t, e) {
  for (const o of t)
    if (!ei(o, { upTo: e })) return o;
}
function ei(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function ti(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function he(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const o = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== o && ti(t) && e && t.select();
  }
}
var mo = oi();
function oi() {
  let t = [];
  return {
    add(e) {
      const o = t[0];
      e !== o && o?.pause(), t = vo(t, e), t.unshift(e);
    },
    remove(e) {
      t = vo(t, e), t[0]?.resume();
    }
  };
}
function vo(t, e) {
  const o = [...t], l = o.indexOf(e);
  return l !== -1 && o.splice(l, 1), o;
}
function li(t) {
  return t.filter((e) => e.tagName !== "A");
}
var Et = 0;
function ai() {
  _.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? yo()), document.body.insertAdjacentElement("beforeend", t[1] ?? yo()), Et++, () => {
      Et === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Et--;
    };
  }, []);
}
function yo() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var it = "right-scroll-bar-position", rt = "width-before-scroll-bar", ni = "with-scroll-bars-hidden", ii = "--removed-body-scroll-bar-size";
function St(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function ri(t, e) {
  var o = F(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return o.value;
        },
        set current(l) {
          var a = o.value;
          a !== l && (o.value = l, o.callback(l, a));
        }
      }
    };
  })[0];
  return o.callback = e, o.facade;
}
var si = typeof window < "u" ? _.useLayoutEffect : _.useEffect, ko = /* @__PURE__ */ new WeakMap();
function ci(t, e) {
  var o = ri(null, function(l) {
    return t.forEach(function(a) {
      return St(a, l);
    });
  });
  return si(function() {
    var l = ko.get(o);
    if (l) {
      var a = new Set(l), n = new Set(t), r = o.current;
      a.forEach(function(i) {
        n.has(i) || St(i, null);
      }), n.forEach(function(i) {
        a.has(i) || St(i, r);
      });
    }
    ko.set(o, t);
  }, [t]), o;
}
function gi(t) {
  return t;
}
function di(t, e) {
  e === void 0 && (e = gi);
  var o = [], l = !1, a = {
    read: function() {
      if (l)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return o.length ? o[o.length - 1] : t;
    },
    useMedium: function(n) {
      var r = e(n, l);
      return o.push(r), function() {
        o = o.filter(function(i) {
          return i !== r;
        });
      };
    },
    assignSyncMedium: function(n) {
      for (l = !0; o.length; ) {
        var r = o;
        o = [], r.forEach(n);
      }
      o = {
        push: function(i) {
          return n(i);
        },
        filter: function() {
          return o;
        }
      };
    },
    assignMedium: function(n) {
      l = !0;
      var r = [];
      if (o.length) {
        var i = o;
        o = [], i.forEach(n), r = o;
      }
      var c = function() {
        var d = r;
        r = [], d.forEach(n);
      }, s = function() {
        return Promise.resolve().then(c);
      };
      s(), o = {
        push: function(d) {
          r.push(d), s();
        },
        filter: function(d) {
          return r = r.filter(d), o;
        }
      };
    }
  };
  return a;
}
function ui(t) {
  t === void 0 && (t = {});
  var e = di(null);
  return e.options = ee({ async: !0, ssr: !1 }, t), e;
}
var _l = function(t) {
  var e = t.sideCar, o = dl(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var l = e.read();
  if (!l)
    throw new Error("Sidecar medium not found");
  return _.createElement(l, ee({}, o));
};
_l.isSideCarExport = !0;
function bi(t, e) {
  return t.useMedium(e), _l;
}
var hl = ui(), Dt = function() {
}, mt = _.forwardRef(function(t, e) {
  var o = _.useRef(null), l = _.useState({
    onScrollCapture: Dt,
    onWheelCapture: Dt,
    onTouchMoveCapture: Dt
  }), a = l[0], n = l[1], r = t.forwardProps, i = t.children, c = t.className, s = t.removeScrollBar, d = t.enabled, u = t.shards, b = t.sideCar, f = t.noIsolation, p = t.inert, h = t.allowPinchZoom, v = t.as, m = v === void 0 ? "div" : v, w = t.gapMode, y = dl(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = b, x = ci([o, e]), j = ee(ee({}, y), a);
  return _.createElement(
    _.Fragment,
    null,
    d && _.createElement(k, { sideCar: hl, removeScrollBar: s, shards: u, noIsolation: f, inert: p, setCallbacks: n, allowPinchZoom: !!h, lockRef: o, gapMode: w }),
    r ? _.cloneElement(_.Children.only(i), ee(ee({}, j), { ref: x })) : _.createElement(m, ee({}, j, { className: c, ref: x }), i)
  );
});
mt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
mt.classNames = {
  fullWidth: rt,
  zeroRight: it
};
var _i = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function hi() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = _i();
  return e && t.setAttribute("nonce", e), t;
}
function fi(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function pi(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var mi = function() {
  var t = 0, e = null;
  return {
    add: function(o) {
      t == 0 && (e = hi()) && (fi(e, o), pi(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, vi = function() {
  var t = mi();
  return function(e, o) {
    _.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && o]);
  };
}, fl = function() {
  var t = vi(), e = function(o) {
    var l = o.styles, a = o.dynamic;
    return t(l, a), null;
  };
  return e;
}, yi = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Nt = function(t) {
  return parseInt(t || "", 10) || 0;
}, ki = function(t) {
  var e = window.getComputedStyle(document.body), o = e[t === "padding" ? "paddingLeft" : "marginLeft"], l = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Nt(o), Nt(l), Nt(a)];
}, wi = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return yi;
  var e = ki(t), o = document.documentElement.clientWidth, l = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, l - o + e[2] - e[0])
  };
}, $i = fl(), De = "data-scroll-locked", xi = function(t, e, o, l) {
  var a = t.left, n = t.top, r = t.right, i = t.gap;
  return o === void 0 && (o = "margin"), `
  .`.concat(ni, ` {
   overflow: hidden `).concat(l, `;
   padding-right: `).concat(i, "px ").concat(l, `;
  }
  body[`).concat(De, `] {
    overflow: hidden `).concat(l, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(l, ";"),
    o === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(n, `px;
    padding-right: `).concat(r, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(l, `;
    `),
    o === "padding" && "padding-right: ".concat(i, "px ").concat(l, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(it, ` {
    right: `).concat(i, "px ").concat(l, `;
  }
  
  .`).concat(rt, ` {
    margin-right: `).concat(i, "px ").concat(l, `;
  }
  
  .`).concat(it, " .").concat(it, ` {
    right: 0 `).concat(l, `;
  }
  
  .`).concat(rt, " .").concat(rt, ` {
    margin-right: 0 `).concat(l, `;
  }
  
  body[`).concat(De, `] {
    `).concat(ii, ": ").concat(i, `px;
  }
`);
}, wo = function() {
  var t = parseInt(document.body.getAttribute(De) || "0", 10);
  return isFinite(t) ? t : 0;
}, ji = function() {
  _.useEffect(function() {
    return document.body.setAttribute(De, (wo() + 1).toString()), function() {
      var t = wo() - 1;
      t <= 0 ? document.body.removeAttribute(De) : document.body.setAttribute(De, t.toString());
    };
  }, []);
}, zi = function(t) {
  var e = t.noRelative, o = t.noImportant, l = t.gapMode, a = l === void 0 ? "margin" : l;
  ji();
  var n = _.useMemo(function() {
    return wi(a);
  }, [a]);
  return _.createElement($i, { styles: xi(n, !e, a, o ? "" : "!important") });
}, qt = !1;
if (typeof window < "u")
  try {
    var Xe = Object.defineProperty({}, "passive", {
      get: function() {
        return qt = !0, !0;
      }
    });
    window.addEventListener("test", Xe, Xe), window.removeEventListener("test", Xe, Xe);
  } catch {
    qt = !1;
  }
var je = qt ? { passive: !1 } : !1, Ci = function(t) {
  return t.tagName === "TEXTAREA";
}, pl = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var o = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    o[e] !== "hidden" && // contains scroll inside self
    !(o.overflowY === o.overflowX && !Ci(t) && o[e] === "visible")
  );
}, Oi = function(t) {
  return pl(t, "overflowY");
}, Ei = function(t) {
  return pl(t, "overflowX");
}, $o = function(t, e) {
  var o = e.ownerDocument, l = e;
  do {
    typeof ShadowRoot < "u" && l instanceof ShadowRoot && (l = l.host);
    var a = ml(t, l);
    if (a) {
      var n = vl(t, l), r = n[1], i = n[2];
      if (r > i)
        return !0;
    }
    l = l.parentNode;
  } while (l && l !== o.body);
  return !1;
}, Si = function(t) {
  var e = t.scrollTop, o = t.scrollHeight, l = t.clientHeight;
  return [
    e,
    o,
    l
  ];
}, Di = function(t) {
  var e = t.scrollLeft, o = t.scrollWidth, l = t.clientWidth;
  return [
    e,
    o,
    l
  ];
}, ml = function(t, e) {
  return t === "v" ? Oi(e) : Ei(e);
}, vl = function(t, e) {
  return t === "v" ? Si(e) : Di(e);
}, Ni = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Mi = function(t, e, o, l, a) {
  var n = Ni(t, window.getComputedStyle(e).direction), r = n * l, i = o.target, c = e.contains(i), s = !1, d = r > 0, u = 0, b = 0;
  do {
    var f = vl(t, i), p = f[0], h = f[1], v = f[2], m = h - v - n * p;
    (p || m) && ml(t, i) && (u += m, b += p), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (e.contains(i) || e === i)
  );
  return (d && Math.abs(u) < 1 || !d && Math.abs(b) < 1) && (s = !0), s;
}, et = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, xo = function(t) {
  return [t.deltaX, t.deltaY];
}, jo = function(t) {
  return t && "current" in t ? t.current : t;
}, Pi = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, Ai = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Li = 0, ze = [];
function Ti(t) {
  var e = _.useRef([]), o = _.useRef([0, 0]), l = _.useRef(), a = _.useState(Li++)[0], n = _.useState(fl)[0], r = _.useRef(t);
  _.useEffect(function() {
    r.current = t;
  }, [t]), _.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var h = Yn([t.lockRef.current], (t.shards || []).map(jo)).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var i = _.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !r.current.allowPinchZoom;
    var m = et(h), w = o.current, y = "deltaX" in h ? h.deltaX : w[0] - m[0], k = "deltaY" in h ? h.deltaY : w[1] - m[1], x, j = h.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in h && $ === "h" && j.type === "range")
      return !1;
    var M = $o($, j);
    if (!M)
      return !0;
    if (M ? x = $ : (x = $ === "v" ? "h" : "v", M = $o($, j)), !M)
      return !1;
    if (!l.current && "changedTouches" in h && (y || k) && (l.current = x), !x)
      return !0;
    var N = l.current || x;
    return Mi(N, v, h, N === "h" ? y : k);
  }, []), c = _.useCallback(function(h) {
    var v = h;
    if (!(!ze.length || ze[ze.length - 1] !== n)) {
      var m = "deltaY" in v ? xo(v) : et(v), w = e.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && Pi(x.delta, m);
      })[0];
      if (w && w.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!w) {
        var y = (r.current.shards || []).map(jo).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), k = y.length > 0 ? i(v, y[0]) : !r.current.noIsolation;
        k && v.cancelable && v.preventDefault();
      }
    }
  }, []), s = _.useCallback(function(h, v, m, w) {
    var y = { name: h, delta: v, target: m, should: w, shadowParent: qi(m) };
    e.current.push(y), setTimeout(function() {
      e.current = e.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), d = _.useCallback(function(h) {
    o.current = et(h), l.current = void 0;
  }, []), u = _.useCallback(function(h) {
    s(h.type, xo(h), h.target, i(h, t.lockRef.current));
  }, []), b = _.useCallback(function(h) {
    s(h.type, et(h), h.target, i(h, t.lockRef.current));
  }, []);
  _.useEffect(function() {
    return ze.push(n), t.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", c, je), document.addEventListener("touchmove", c, je), document.addEventListener("touchstart", d, je), function() {
      ze = ze.filter(function(h) {
        return h !== n;
      }), document.removeEventListener("wheel", c, je), document.removeEventListener("touchmove", c, je), document.removeEventListener("touchstart", d, je);
    };
  }, []);
  var f = t.removeScrollBar, p = t.inert;
  return _.createElement(
    _.Fragment,
    null,
    p ? _.createElement(n, { styles: Ai(a) }) : null,
    f ? _.createElement(zi, { gapMode: t.gapMode }) : null
  );
}
function qi(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Ii = bi(hl, Ti);
var yl = _.forwardRef(function(t, e) {
  return _.createElement(mt, ee({}, t, { ref: e, sideCar: Ii }));
});
yl.classNames = mt.classNames;
var Bi = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Ce = /* @__PURE__ */ new WeakMap(), tt = /* @__PURE__ */ new WeakMap(), ot = {}, Mt = 0, kl = function(t) {
  return t && (t.host || kl(t.parentNode));
}, Ri = function(t, e) {
  return e.map(function(o) {
    if (t.contains(o))
      return o;
    var l = kl(o);
    return l && t.contains(l) ? l : (console.error("aria-hidden", o, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(o) {
    return !!o;
  });
}, Fi = function(t, e, o, l) {
  var a = Ri(e, Array.isArray(t) ? t : [t]);
  ot[o] || (ot[o] = /* @__PURE__ */ new WeakMap());
  var n = ot[o], r = [], i = /* @__PURE__ */ new Set(), c = new Set(a), s = function(u) {
    !u || i.has(u) || (i.add(u), s(u.parentNode));
  };
  a.forEach(s);
  var d = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(b) {
      if (i.has(b))
        d(b);
      else
        try {
          var f = b.getAttribute(l), p = f !== null && f !== "false", h = (Ce.get(b) || 0) + 1, v = (n.get(b) || 0) + 1;
          Ce.set(b, h), n.set(b, v), r.push(b), h === 1 && p && tt.set(b, !0), v === 1 && b.setAttribute(o, "true"), p || b.setAttribute(l, "true");
        } catch (m) {
          console.error("aria-hidden: cannot operate on ", b, m);
        }
    });
  };
  return d(e), i.clear(), Mt++, function() {
    r.forEach(function(u) {
      var b = Ce.get(u) - 1, f = n.get(u) - 1;
      Ce.set(u, b), n.set(u, f), b || (tt.has(u) || u.removeAttribute(l), tt.delete(u)), f || u.removeAttribute(o);
    }), Mt--, Mt || (Ce = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap(), tt = /* @__PURE__ */ new WeakMap(), ot = {});
  };
}, Hi = function(t, e, o) {
  o === void 0 && (o = "data-aria-hidden");
  var l = Array.from(Array.isArray(t) ? t : [t]), a = Bi(t);
  return a ? (l.push.apply(l, Array.from(a.querySelectorAll("[aria-live]"))), Fi(l, a, o, "aria-hidden")) : function() {
    return null;
  };
}, vt = "Dialog", [wl, GO] = pt(vt), [Wi, Q] = wl(vt), $l = (t) => {
  const {
    __scopeDialog: e,
    children: o,
    open: l,
    defaultOpen: a,
    onOpenChange: n,
    modal: r = !0
  } = t, i = _.useRef(null), c = _.useRef(null), [s, d] = ft({
    prop: l,
    defaultProp: a ?? !1,
    onChange: n,
    caller: vt
  });
  return /* @__PURE__ */ g(
    Wi,
    {
      scope: e,
      triggerRef: i,
      contentRef: c,
      contentId: Ie(),
      titleId: Ie(),
      descriptionId: Ie(),
      open: s,
      onOpenChange: d,
      onOpenToggle: _.useCallback(() => d((u) => !u), [d]),
      modal: r,
      children: o
    }
  );
};
$l.displayName = vt;
var xl = "DialogTrigger", jl = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, ...l } = t, a = Q(xl, o), n = Z(e, a.triggerRef);
    return /* @__PURE__ */ g(
      W.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Jt(a.open),
        ...l,
        ref: n,
        onClick: oe(t.onClick, a.onOpenToggle)
      }
    );
  }
);
jl.displayName = xl;
var Ut = "DialogPortal", [Vi, zl] = wl(Ut, {
  forceMount: void 0
}), Cl = (t) => {
  const { __scopeDialog: e, forceMount: o, children: l, container: a } = t, n = Q(Ut, e);
  return /* @__PURE__ */ g(Vi, { scope: e, forceMount: o, children: _.Children.map(l, (r) => /* @__PURE__ */ g(Ue, { present: o || n.open, children: /* @__PURE__ */ g(gl, { asChild: !0, container: a, children: r }) })) });
};
Cl.displayName = Ut;
var dt = "DialogOverlay", Ol = _.forwardRef(
  (t, e) => {
    const o = zl(dt, t.__scopeDialog), { forceMount: l = o.forceMount, ...a } = t, n = Q(dt, t.__scopeDialog);
    return n.modal ? /* @__PURE__ */ g(Ue, { present: l || n.open, children: /* @__PURE__ */ g(Ui, { ...a, ref: e }) }) : null;
  }
);
Ol.displayName = dt;
var Gi = /* @__PURE__ */ gt("DialogOverlay.RemoveScroll"), Ui = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, ...l } = t, a = Q(dt, o);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ g(yl, { as: Gi, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ g(
        W.div,
        {
          "data-state": Jt(a.open),
          ...l,
          ref: e,
          style: { pointerEvents: "auto", ...l.style }
        }
      ) })
    );
  }
), we = "DialogContent", El = _.forwardRef(
  (t, e) => {
    const o = zl(we, t.__scopeDialog), { forceMount: l = o.forceMount, ...a } = t, n = Q(we, t.__scopeDialog);
    return /* @__PURE__ */ g(Ue, { present: l || n.open, children: n.modal ? /* @__PURE__ */ g(Ki, { ...a, ref: e }) : /* @__PURE__ */ g(Ji, { ...a, ref: e }) });
  }
);
El.displayName = we;
var Ki = _.forwardRef(
  (t, e) => {
    const o = Q(we, t.__scopeDialog), l = _.useRef(null), a = Z(e, o.contentRef, l);
    return _.useEffect(() => {
      const n = l.current;
      if (n) return Hi(n);
    }, []), /* @__PURE__ */ g(
      Sl,
      {
        ...t,
        ref: a,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: oe(t.onCloseAutoFocus, (n) => {
          n.preventDefault(), o.triggerRef.current?.focus();
        }),
        onPointerDownOutside: oe(t.onPointerDownOutside, (n) => {
          const r = n.detail.originalEvent, i = r.button === 0 && r.ctrlKey === !0;
          (r.button === 2 || i) && n.preventDefault();
        }),
        onFocusOutside: oe(
          t.onFocusOutside,
          (n) => n.preventDefault()
        )
      }
    );
  }
), Ji = _.forwardRef(
  (t, e) => {
    const o = Q(we, t.__scopeDialog), l = _.useRef(!1), a = _.useRef(!1);
    return /* @__PURE__ */ g(
      Sl,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (n) => {
          t.onCloseAutoFocus?.(n), n.defaultPrevented || (l.current || o.triggerRef.current?.focus(), n.preventDefault()), l.current = !1, a.current = !1;
        },
        onInteractOutside: (n) => {
          t.onInteractOutside?.(n), n.defaultPrevented || (l.current = !0, n.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const r = n.target;
          o.triggerRef.current?.contains(r) && n.preventDefault(), n.detail.originalEvent.type === "focusin" && a.current && n.preventDefault();
        }
      }
    );
  }
), Sl = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, trapFocus: l, onOpenAutoFocus: a, onCloseAutoFocus: n, ...r } = t, i = Q(we, o), c = _.useRef(null), s = Z(e, c);
    return ai(), /* @__PURE__ */ C(Re, { children: [
      /* @__PURE__ */ g(
        ul,
        {
          asChild: !0,
          loop: !0,
          trapped: l,
          onMountAutoFocus: a,
          onUnmountAutoFocus: n,
          children: /* @__PURE__ */ g(
            sl,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Jt(i.open),
              ...r,
              ref: s,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(Re, { children: [
        /* @__PURE__ */ g(Yi, { titleId: i.titleId }),
        /* @__PURE__ */ g(Qi, { contentRef: c, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), Kt = "DialogTitle", Dl = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, ...l } = t, a = Q(Kt, o);
    return /* @__PURE__ */ g(W.h2, { id: a.titleId, ...l, ref: e });
  }
);
Dl.displayName = Kt;
var Nl = "DialogDescription", Ml = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, ...l } = t, a = Q(Nl, o);
    return /* @__PURE__ */ g(W.p, { id: a.descriptionId, ...l, ref: e });
  }
);
Ml.displayName = Nl;
var Pl = "DialogClose", Al = _.forwardRef(
  (t, e) => {
    const { __scopeDialog: o, ...l } = t, a = Q(Pl, o);
    return /* @__PURE__ */ g(
      W.button,
      {
        type: "button",
        ...l,
        ref: e,
        onClick: oe(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Al.displayName = Pl;
function Jt(t) {
  return t ? "open" : "closed";
}
var Ll = "DialogTitleWarning", [UO, Tl] = $n(Ll, {
  contentName: we,
  titleName: Kt,
  docsSlug: "dialog"
}), Yi = ({ titleId: t }) => {
  const e = Tl(Ll), o = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return _.useEffect(() => {
    t && (document.getElementById(t) || console.error(o));
  }, [o, t]), null;
}, Zi = "DialogDescriptionWarning", Qi = ({ contentRef: t, descriptionId: e }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Tl(Zi).contentName}}.`;
  return _.useEffect(() => {
    const l = t.current?.getAttribute("aria-describedby");
    e && l && (document.getElementById(e) || console.warn(o));
  }, [o, t, e]), null;
}, Xi = $l, er = jl, tr = Cl, or = Ol, lr = El, ar = Dl, nr = Ml, zo = Al;
const ir = "_link_n9jfs_29", Oe = {
  link: ir,
  "is-small": "_is-small_n9jfs_37",
  "is-primary": "_is-primary_n9jfs_41",
  "is-secondary": "_is-secondary_n9jfs_47",
  "is-inverted": "_is-inverted_n9jfs_53",
  "is-inherited": "_is-inherited_n9jfs_59",
  "is-underlined": "_is-underlined_n9jfs_65",
  "is-disabled": "_is-disabled_n9jfs_78",
  "link-external": "_link-external_n9jfs_87",
  "dialog-overlay-show": "_dialog-overlay-show_n9jfs_1",
  "dialog-content-show": "_dialog-content-show_n9jfs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_n9jfs_1"
}, rr = {
  primary: "is-primary",
  secondary: "is-secondary",
  inverted: "is-inverted",
  inherit: "is-inherited"
};
function ql({
  color: t = "primary",
  children: e,
  href: o,
  target: l,
  disabled: a,
  Component: n,
  isSmall: r,
  className: i,
  noUnderline: c = !1,
  external: s,
  ariaLabel: d,
  onClick: u,
  ...b
}) {
  const f = D(
    Oe.link,
    Oe[rr[t]],
    r && Oe["is-small"],
    a && Oe["is-disabled"],
    !c && Oe["is-underlined"],
    i
  ), p = /* @__PURE__ */ g("span", { className: f, ...b, children: e });
  if (n)
    return a ? p : /* @__PURE__ */ g(n, { onClick: u, className: f, href: o, target: l, "aria-label": d, ...b, children: e });
  if (!o)
    return a ? p : /* @__PURE__ */ g("button", { onClick: u, className: f, ...b, children: e });
  const h = /* @__PURE__ */ g(
    "a",
    {
      onClick: u,
      href: o,
      target: l,
      className: f,
      "aria-label": d,
      ...b,
      children: e
    }
  );
  return a ? p : s ? /* @__PURE__ */ C("span", { className: Oe["link-external"], children: [
    h,
    /* @__PURE__ */ g(me, { name: "new-tab", size: "large" })
  ] }) : h;
}
var yt = "Collapsible", [sr, Il] = pt(yt), [cr, Yt] = sr(yt), Bl = _.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: o,
      open: l,
      defaultOpen: a,
      disabled: n,
      onOpenChange: r,
      ...i
    } = t, [c, s] = ft({
      prop: l,
      defaultProp: a ?? !1,
      onChange: r,
      caller: yt
    });
    return /* @__PURE__ */ g(
      cr,
      {
        scope: o,
        disabled: n,
        contentId: Ie(),
        open: c,
        onOpenToggle: _.useCallback(() => s((d) => !d), [s]),
        children: /* @__PURE__ */ g(
          W.div,
          {
            "data-state": Qt(c),
            "data-disabled": n ? "" : void 0,
            ...i,
            ref: e
          }
        )
      }
    );
  }
);
Bl.displayName = yt;
var Rl = "CollapsibleTrigger", Fl = _.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: o, ...l } = t, a = Yt(Rl, o);
    return /* @__PURE__ */ g(
      W.button,
      {
        type: "button",
        "aria-controls": a.contentId,
        "aria-expanded": a.open || !1,
        "data-state": Qt(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        disabled: a.disabled,
        ...l,
        ref: e,
        onClick: oe(t.onClick, a.onOpenToggle)
      }
    );
  }
);
Fl.displayName = Rl;
var Zt = "CollapsibleContent", Hl = _.forwardRef(
  (t, e) => {
    const { forceMount: o, ...l } = t, a = Yt(Zt, t.__scopeCollapsible);
    return /* @__PURE__ */ g(Ue, { present: o || a.open, children: ({ present: n }) => /* @__PURE__ */ g(gr, { ...l, ref: e, present: n }) });
  }
);
Hl.displayName = Zt;
var gr = _.forwardRef((t, e) => {
  const { __scopeCollapsible: o, present: l, children: a, ...n } = t, r = Yt(Zt, o), [i, c] = _.useState(l), s = _.useRef(null), d = Z(e, s), u = _.useRef(0), b = u.current, f = _.useRef(0), p = f.current, h = r.open || i, v = _.useRef(h), m = _.useRef(void 0);
  return _.useEffect(() => {
    const w = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), Ne(() => {
    const w = s.current;
    if (w) {
      m.current = m.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const y = w.getBoundingClientRect();
      u.current = y.height, f.current = y.width, v.current || (w.style.transitionDuration = m.current.transitionDuration, w.style.animationName = m.current.animationName), c(l);
    }
  }, [r.open, l]), /* @__PURE__ */ g(
    W.div,
    {
      "data-state": Qt(r.open),
      "data-disabled": r.disabled ? "" : void 0,
      id: r.contentId,
      hidden: !h,
      ...n,
      ref: d,
      style: {
        "--radix-collapsible-content-height": b ? `${b}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: h && a
    }
  );
});
function Qt(t) {
  return t ? "open" : "closed";
}
var dr = Bl, ur = Fl, br = Hl, X = "Accordion", _r = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Xt, hr, fr] = Pn(X), [kt, KO] = pt(X, [
  fr,
  Il
]), eo = Il(), Wl = S.forwardRef(
  (t, e) => {
    const { type: o, ...l } = t, a = l, n = l;
    return /* @__PURE__ */ g(Xt.Provider, { scope: t.__scopeAccordion, children: o === "multiple" ? /* @__PURE__ */ g(yr, { ...n, ref: e }) : /* @__PURE__ */ g(vr, { ...a, ref: e }) });
  }
);
Wl.displayName = X;
var [Vl, pr] = kt(X), [Gl, mr] = kt(
  X,
  { collapsible: !1 }
), vr = S.forwardRef(
  (t, e) => {
    const {
      value: o,
      defaultValue: l,
      onValueChange: a = () => {
      },
      collapsible: n = !1,
      ...r
    } = t, [i, c] = ft({
      prop: o,
      defaultProp: l ?? "",
      onChange: a,
      caller: X
    });
    return /* @__PURE__ */ g(
      Vl,
      {
        scope: t.__scopeAccordion,
        value: S.useMemo(() => i ? [i] : [], [i]),
        onItemOpen: c,
        onItemClose: S.useCallback(() => n && c(""), [n, c]),
        children: /* @__PURE__ */ g(Gl, { scope: t.__scopeAccordion, collapsible: n, children: /* @__PURE__ */ g(Ul, { ...r, ref: e }) })
      }
    );
  }
), yr = S.forwardRef((t, e) => {
  const {
    value: o,
    defaultValue: l,
    onValueChange: a = () => {
    },
    ...n
  } = t, [r, i] = ft({
    prop: o,
    defaultProp: l ?? [],
    onChange: a,
    caller: X
  }), c = S.useCallback(
    (d) => i((u = []) => [...u, d]),
    [i]
  ), s = S.useCallback(
    (d) => i((u = []) => u.filter((b) => b !== d)),
    [i]
  );
  return /* @__PURE__ */ g(
    Vl,
    {
      scope: t.__scopeAccordion,
      value: r,
      onItemOpen: c,
      onItemClose: s,
      children: /* @__PURE__ */ g(Gl, { scope: t.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ g(Ul, { ...n, ref: e }) })
    }
  );
}), [kr, wt] = kt(X), Ul = S.forwardRef(
  (t, e) => {
    const { __scopeAccordion: o, disabled: l, dir: a, orientation: n = "vertical", ...r } = t, i = S.useRef(null), c = Z(i, e), s = hr(o), d = Mn(a) === "ltr", u = oe(t.onKeyDown, (b) => {
      if (!_r.includes(b.key)) return;
      const f = b.target, p = s().filter(($) => !$.ref.current?.disabled), h = p.findIndex(($) => $.ref.current === f), v = p.length;
      if (h === -1) return;
      b.preventDefault();
      let m = h;
      const w = 0, y = v - 1, k = () => {
        m = h + 1, m > y && (m = w);
      }, x = () => {
        m = h - 1, m < w && (m = y);
      };
      switch (b.key) {
        case "Home":
          m = w;
          break;
        case "End":
          m = y;
          break;
        case "ArrowRight":
          n === "horizontal" && (d ? k() : x());
          break;
        case "ArrowDown":
          n === "vertical" && k();
          break;
        case "ArrowLeft":
          n === "horizontal" && (d ? x() : k());
          break;
        case "ArrowUp":
          n === "vertical" && x();
          break;
      }
      const j = m % v;
      p[j].ref.current?.focus();
    });
    return /* @__PURE__ */ g(
      kr,
      {
        scope: o,
        disabled: l,
        direction: a,
        orientation: n,
        children: /* @__PURE__ */ g(Xt.Slot, { scope: o, children: /* @__PURE__ */ g(
          W.div,
          {
            ...r,
            "data-orientation": n,
            ref: c,
            onKeyDown: l ? void 0 : u
          }
        ) })
      }
    );
  }
), ut = "AccordionItem", [wr, to] = kt(ut), Kl = S.forwardRef(
  (t, e) => {
    const { __scopeAccordion: o, value: l, ...a } = t, n = wt(ut, o), r = pr(ut, o), i = eo(o), c = Ie(), s = l && r.value.includes(l) || !1, d = n.disabled || t.disabled;
    return /* @__PURE__ */ g(
      wr,
      {
        scope: o,
        open: s,
        disabled: d,
        triggerId: c,
        children: /* @__PURE__ */ g(
          dr,
          {
            "data-orientation": n.orientation,
            "data-state": ea(s),
            ...i,
            ...a,
            ref: e,
            disabled: d,
            open: s,
            onOpenChange: (u) => {
              u ? r.onItemOpen(l) : r.onItemClose(l);
            }
          }
        )
      }
    );
  }
);
Kl.displayName = ut;
var Jl = "AccordionHeader", Yl = S.forwardRef(
  (t, e) => {
    const { __scopeAccordion: o, ...l } = t, a = wt(X, o), n = to(Jl, o);
    return /* @__PURE__ */ g(
      W.h3,
      {
        "data-orientation": a.orientation,
        "data-state": ea(n.open),
        "data-disabled": n.disabled ? "" : void 0,
        ...l,
        ref: e
      }
    );
  }
);
Yl.displayName = Jl;
var It = "AccordionTrigger", Zl = S.forwardRef(
  (t, e) => {
    const { __scopeAccordion: o, ...l } = t, a = wt(X, o), n = to(It, o), r = mr(It, o), i = eo(o);
    return /* @__PURE__ */ g(Xt.ItemSlot, { scope: o, children: /* @__PURE__ */ g(
      ur,
      {
        "aria-disabled": n.open && !r.collapsible || void 0,
        "data-orientation": a.orientation,
        id: n.triggerId,
        ...i,
        ...l,
        ref: e
      }
    ) });
  }
);
Zl.displayName = It;
var Ql = "AccordionContent", Xl = S.forwardRef(
  (t, e) => {
    const { __scopeAccordion: o, ...l } = t, a = wt(X, o), n = to(Ql, o), r = eo(o);
    return /* @__PURE__ */ g(
      br,
      {
        role: "region",
        "aria-labelledby": n.triggerId,
        "data-orientation": a.orientation,
        ...r,
        ...l,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...t.style
        }
      }
    );
  }
);
Xl.displayName = Ql;
function ea(t) {
  return t ? "open" : "closed";
}
var $r = Wl, xr = Kl, jr = Yl, zr = Zl, Cr = Xl;
const Le = {
  "accordion-item": "_accordion-item_e3e0q_29",
  "accordion-header": "_accordion-header_e3e0q_38",
  "accordion-trigger": "_accordion-trigger_e3e0q_43",
  "accordion-content": "_accordion-content_e3e0q_63",
  "accordion-content-text": "_accordion-content-text_e3e0q_71"
};
function Or({ items: t, className: e = "", defaultValue: o, ...l }) {
  return /* @__PURE__ */ g($r, { type: "multiple", className: e, ...l, defaultValue: o, children: t?.map((a) => /* @__PURE__ */ C(xr, { className: Le["accordion-item"], value: a.value, children: [
    /* @__PURE__ */ g(jr, { className: Le["accordion-header"], children: /* @__PURE__ */ C(zr, { className: Le["accordion-trigger"], children: [
      a.title,
      /* @__PURE__ */ g(me, { name: "up-arrow" })
    ] }) }),
    /* @__PURE__ */ g(Cr, { className: Le["accordion-content"], children: /* @__PURE__ */ g("div", { className: Le["accordion-content-text"], children: a.content }) })
  ] }, a.value)) });
}
const Er = "_box_6yjql_29", Sr = "_small_6yjql_40", Dr = "_medium_6yjql_48", ce = {
  box: Er,
  "has-border": "_has-border_6yjql_37",
  small: Sr,
  medium: Dr,
  "has-actions": "_has-actions_6yjql_56",
  "full-height": "_full-height_6yjql_67",
  "full-width": "_full-width_6yjql_70",
  "is-primary": "_is-primary_6yjql_73",
  "is-secondary": "_is-secondary_6yjql_77",
  "is-tertiary": "_is-tertiary_6yjql_81",
  "is-clickable": "_is-clickable_6yjql_85",
  "is-square": "_is-square_6yjql_88",
  "is-centered": "_is-centered_6yjql_91",
  "box-actions": "_box-actions_6yjql_98",
  "dialog-overlay-show": "_dialog-overlay-show_6yjql_1",
  "dialog-content-show": "_dialog-content-show_6yjql_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_6yjql_1"
};
function Nr({
  children: t,
  size: e = "medium",
  color: o = "primary",
  className: l = "",
  isFullHeight: a,
  isFullWidth: n,
  border: r = !0,
  onClick: i,
  isCentered: c,
  isSquare: s,
  ...d
}) {
  const u = D(
    ce.box,
    ce[e],
    l,
    a && ce["full-height"],
    n && ce["full-width"],
    r && ce["has-border"],
    ce[Mr[o]],
    i && ce["is-clickable"],
    c && ce["is-centered"],
    s && ce["is-square"]
  );
  return /* @__PURE__ */ g(
    "div",
    {
      className: u,
      onClick: (b) => {
        i && (b.stopPropagation(), i());
      },
      onKeyDown: (b) => {
        i && b.key === "Enter" && (b.stopPropagation(), i());
      },
      ...i && {
        role: "button",
        tabIndex: 0
      },
      ...d,
      children: t
    }
  );
}
const Mr = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, Co = 640, Pt = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function $e({
  srcMobile: t,
  width: e = "auto",
  borderRadius: o = "none",
  className: l = "",
  ...a
}) {
  const n = D(Pt.img, l, Pt[Pr[e]], Pt[Ar[o]]);
  return /* @__PURE__ */ C("picture", { children: [
    t && /* @__PURE__ */ g("source", { media: `(max-width: ${Co}px)`, srcSet: t }),
    /* @__PURE__ */ g("source", { media: `(min-width: ${Co + 1}px)` }),
    /* @__PURE__ */ g("img", { ...a, className: n, alt: a.alt, style: { width: `${a.widthInPx}px` } })
  ] });
}
const Pr = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, Ar = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, Lr = "_callout_7jl0x_29", Tr = "_link_7jl0x_52", Te = {
  callout: Lr,
  "is-full-width": "_is-full-width_7jl0x_37",
  "is-small": "_is-small_7jl0x_47",
  link: Tr,
  "is-medium": "_is-medium_7jl0x_55",
  "is-info": "_is-info_7jl0x_58",
  "is-warning": "_is-warning_7jl0x_61",
  "is-success": "_is-success_7jl0x_64",
  "is-error": "_is-error_7jl0x_67",
  "is-neutral": "_is-neutral_7jl0x_70",
  "is-collection": "_is-collection_7jl0x_73",
  "content-container": "_content-container_7jl0x_79",
  "dialog-overlay-show": "_dialog-overlay-show_7jl0x_1",
  "dialog-content-show": "_dialog-content-show_7jl0x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7jl0x_1"
}, Oo = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, qr = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, Ir = {
  small: "is-small",
  medium: "is-medium"
};
function ta({
  status: t = "info",
  size: e = "medium",
  children: o,
  hasIcon: l = !1,
  backgroundImage: a,
  isFullWidth: n = !1
}) {
  const r = D(Te.callout, Te[qr[t]], Te[Ir[e]], {
    [Te["is-full-width"]]: n
  });
  return /* @__PURE__ */ C("div", { className: r, children: [
    l && /* @__PURE__ */ g(me, { name: Oo[t].name, color: Oo[t].color, size: "2xl" }),
    /* @__PURE__ */ g("div", { className: Te["content-container"], children: o }),
    a && /* @__PURE__ */ g("img", { src: a, alt: "background" })
  ] });
}
const Br = "_icon_a406m_79", ge = {
  "alert-dialog-overlay": "_alert-dialog-overlay_a406m_29",
  "dialog-overlay-show": "_dialog-overlay-show_a406m_1",
  "alert-dialog": "_alert-dialog_a406m_29",
  "dialog-content-show": "_dialog-content-show_a406m_1",
  "alert-dialog-title": "_alert-dialog-title_a406m_66",
  icon: Br,
  "icon-success": "_icon-success_a406m_82",
  "icon-error": "_icon-error_a406m_85",
  "icon-warning": "_icon-warning_a406m_88",
  "icon-info": "_icon-info_a406m_91",
  "alert-dialog-description": "_alert-dialog-description_a406m_95",
  "alert-dialog-content": "_alert-dialog-content_a406m_102",
  "alert-dialog-actions": "_alert-dialog-actions_a406m_112",
  "dialog-content-slide-up": "_dialog-content-slide-up_a406m_1"
}, Rr = {
  success: "verification-check-regular",
  error: "error-regular",
  warning: "warning-regular",
  info: "information-circle-regular"
};
function Fr({
  children: t,
  dialogTriggerNode: e,
  title: o,
  confirmActionText: l,
  dismissActionText: a,
  onDismissAction: n,
  onConfirmAction: r,
  confirmActionColor: i = "primary",
  iconStatus: c,
  calloutProps: s,
  isOpen: d,
  confirmActionIsLoading: u,
  setIsOpen: b,
  defaultOpen: f
}) {
  const p = D(ge["alert-dialog"]), [h, v] = F(!1), m = u || h, w = async (y) => {
    if (r)
      try {
        v(!0), await r(y);
      } finally {
        v(!1);
      }
  };
  return /* @__PURE__ */ C(Xi, { defaultOpen: f, open: d, onOpenChange: b, children: [
    /* @__PURE__ */ g(er, { asChild: !0, children: e }),
    /* @__PURE__ */ C(tr, { children: [
      /* @__PURE__ */ g(or, { className: ge["alert-dialog-overlay"] }),
      /* @__PURE__ */ C(
        lr,
        {
          "aria-describedby": void 0,
          className: p,
          onInteractOutside: (y) => y.preventDefault(),
          onPointerDownOutside: (y) => y.preventDefault(),
          onEscapeKeyDown: (y) => y.preventDefault(),
          children: [
            /* @__PURE__ */ C(ar, { className: ge["alert-dialog-title"], children: [
              c && /* @__PURE__ */ g("div", { className: D(ge.icon, ge[`icon-${c}`]), children: /* @__PURE__ */ g(me, { color: "inherit", name: Rr[c], size: "7xl" }) }),
              o
            ] }),
            /* @__PURE__ */ g(nr, { asChild: !0, children: /* @__PURE__ */ C("div", { className: ge["alert-dialog-description"], children: [
              /* @__PURE__ */ g("div", { className: ge["alert-dialog-content"], children: t }),
              s?.children && /* @__PURE__ */ g("div", { className: ge["callout-container"], children: /* @__PURE__ */ g(ta, { ...s }) })
            ] }) }),
            /* @__PURE__ */ C("div", { className: ge["alert-dialog-actions"], children: [
              a && n && /* @__PURE__ */ g(zo, { asChild: !0, children: /* @__PURE__ */ g(Y, { color: "tertiary", onClick: n, children: a }) }),
              /* @__PURE__ */ g(zo, { asChild: !0, children: /* @__PURE__ */ g(Y, { isLoading: m, color: i, onClick: w, children: l }) })
            ] })
          ]
        }
      )
    ] })
  ] });
}
const Hr = "_columns_10k0l_29", Wr = "_column_10k0l_29", de = {
  columns: Hr,
  "align-items-center": "_align-items-center_10k0l_36",
  "align-items-flex-start": "_align-items-flex-start_10k0l_39",
  "align-items-flex-end": "_align-items-flex-end_10k0l_42",
  "reverse-on-mobile": "_reverse-on-mobile_10k0l_57",
  column: Wr,
  "gap-0": "_gap-0_10k0l_68",
  "gap-1": "_gap-1_10k0l_71",
  "gap-2": "_gap-2_10k0l_74",
  "gap-3": "_gap-3_10k0l_77",
  "gap-4": "_gap-4_10k0l_80",
  "gap-5": "_gap-5_10k0l_83",
  "gap-6": "_gap-6_10k0l_86",
  "gap-7": "_gap-7_10k0l_89",
  "gap-8": "_gap-8_10k0l_92",
  "gap-9": "_gap-9_10k0l_95",
  "gap-10": "_gap-10_10k0l_98",
  "gap-11": "_gap-11_10k0l_101",
  "gap-12": "_gap-12_10k0l_104",
  "gap-14": "_gap-14_10k0l_107",
  "gap-16": "_gap-16_10k0l_110",
  "gap-18": "_gap-18_10k0l_113",
  "gap-20": "_gap-20_10k0l_116",
  "gap-24": "_gap-24_10k0l_119",
  "gap-28": "_gap-28_10k0l_122",
  "gap-32": "_gap-32_10k0l_125",
  "gap-36": "_gap-36_10k0l_128",
  "gap-40": "_gap-40_10k0l_131",
  "gap-44": "_gap-44_10k0l_134",
  "gap-48": "_gap-48_10k0l_137",
  "gap-52": "_gap-52_10k0l_140",
  "gap-56": "_gap-56_10k0l_143",
  "gap-60": "_gap-60_10k0l_146",
  "gap-64": "_gap-64_10k0l_149",
  "gap-72": "_gap-72_10k0l_152",
  "gap-80": "_gap-80_10k0l_155",
  "gap-96": "_gap-96_10k0l_158",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_10k0l_161",
  "is-1": "_is-1_10k0l_180",
  "is-2": "_is-2_10k0l_184",
  "is-3": "_is-3_10k0l_188",
  "is-4": "_is-4_10k0l_192",
  "is-5": "_is-5_10k0l_196",
  "is-6": "_is-6_10k0l_200",
  "is-7": "_is-7_10k0l_204",
  "is-8": "_is-8_10k0l_208",
  "is-9": "_is-9_10k0l_212",
  "is-10": "_is-10_10k0l_216",
  "is-11": "_is-11_10k0l_220",
  "is-12": "_is-12_10k0l_224",
  "is-offset-1": "_is-offset-1_10k0l_228",
  "is-offset-2": "_is-offset-2_10k0l_231",
  "is-offset-3": "_is-offset-3_10k0l_234",
  "is-offset-4": "_is-offset-4_10k0l_237",
  "is-offset-5": "_is-offset-5_10k0l_240",
  "is-offset-6": "_is-offset-6_10k0l_243",
  "is-offset-7": "_is-offset-7_10k0l_246",
  "is-offset-8": "_is-offset-8_10k0l_249",
  "is-offset-9": "_is-offset-9_10k0l_252",
  "is-offset-10": "_is-offset-10_10k0l_255",
  "is-offset-11": "_is-offset-11_10k0l_258",
  "is-narrow": "_is-narrow_10k0l_261",
  "dialog-overlay-show": "_dialog-overlay-show_10k0l_1",
  "dialog-content-show": "_dialog-content-show_10k0l_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_10k0l_1"
};
function Ke({ children: t, className: e = "", reverseOnMobile: o = !1, alignItems: l, ...a }) {
  const n = D(
    de.columns,
    o && de["reverse-on-mobile"],
    l && de[`align-items-${l}`],
    e
  );
  return /* @__PURE__ */ g("div", { className: n, ...a, children: t });
}
const Vr = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Gr = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Me({
  size: t = "auto",
  offset: e = "auto",
  isNarrow: o = !1,
  className: l = "",
  children: a,
  gap: n,
  hiddenContentOnMobile: r = !1,
  ...i
}) {
  const c = D(
    de.column,
    de[Vr[t]],
    de[Gr[e]],
    o && de["is-narrow"],
    n && de[`gap-${n}`],
    r && de["hidden-content-on-mobile"],
    l
  );
  return /* @__PURE__ */ g("div", { className: c, ...i, children: a });
}
const Ur = "_container_68o99_29", Eo = {
  container: Ur,
  "is-fluid": "_is-fluid_68o99_50"
};
function ne({ isFluid: t = !1, children: e, className: o = "", ...l }) {
  const a = D(Eo.container, t && Eo["is-fluid"], o);
  return /* @__PURE__ */ g("div", { className: a, ...l, children: e });
}
const Kr = "_section_g0e0c_29", Jr = "_content_g0e0c_32", U = {
  section: Kr,
  content: Jr,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, Yr = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, Zr = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, Qr = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function le({
  children: t,
  className: e = "",
  color: o,
  border: l = "none",
  isFullHeight: a,
  centerContent: n,
  isTopBottomPadding: r,
  padding: i = "medium",
  imageSrc: c,
  imagePosition: s,
  imageAlt: d,
  reverseBGColor: u,
  bgImage: b,
  ...f
}) {
  const p = D(
    U.section,
    e,
    o && U[Zr[o]],
    U[Qr[l]],
    a && U["is-full-height"],
    n && U["center-content"],
    c && U["image-flex"],
    s === "right" && U["image-reverse"],
    u && U["reverse-bg-color"]
  ), { isMobile: h } = il();
  return /* @__PURE__ */ C("section", { ...f, className: p, children: [
    c && /* @__PURE__ */ g("div", { className: U["image-container"], children: /* @__PURE__ */ g("img", { src: c, alt: d }) }),
    /* @__PURE__ */ g(
      "div",
      {
        className: D(
          U.content,
          r && U["is-top-bottom-padding"],
          i && U[Yr[i]],
          b && U["bg-image"]
        ),
        style: !h && b ? { backgroundImage: `url(${b})` } : {},
        children: t
      }
    )
  ] });
}
const Xr = "_hero_42kzz_29", es = "_side_42kzz_47", ts = "_cover_42kzz_55", os = "_image_42kzz_81", R = {
  hero: Xr,
  "hero-body": "_hero-body_42kzz_41",
  side: es,
  cover: ts,
  "is-small": "_is-small_42kzz_58",
  "is-medium": "_is-medium_42kzz_61",
  "is-large": "_is-large_42kzz_64",
  "is-halfheight": "_is-halfheight_42kzz_67",
  "is-fullheight": "_is-fullheight_42kzz_74",
  image: os,
  "hero-top-left": "_hero-top-left_42kzz_103",
  "dialog-overlay-show": "_dialog-overlay-show_42kzz_1",
  "dialog-content-show": "_dialog-content-show_42kzz_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_42kzz_1"
}, ls = {
  auto: "",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  halfHeight: "is-halfheight",
  fullHeight: "is-fullheight"
}, as = ({ imagePosition: t, imageSrc: e, imageSrcMobile: o, imageSrcTablet: l }) => {
  const { isMobile: a, isTablet: n } = il();
  let r = e;
  const i = D(
    R.image,
    t === "cover" && R.cover,
    t === "side" && R.side
  );
  return a && o && (r = o), n && l && (r = l), /* @__PURE__ */ g("img", { className: i, src: r, alt: "img-header" });
}, ns = ({ imagePosition: t, backgroundImage: e }) => {
  const o = D(
    R.image,
    t === "cover" && R.cover,
    t === "side" && R.side
  );
  return Ht(e, {
    className: o,
    ...e.props
  });
};
function is({
  backgroundImage: t,
  imageSrc: e,
  imageSrcMobile: o,
  imageSrcTablet: l,
  className: a,
  size: n = "auto",
  children: r,
  topLeft: i,
  imagePosition: c = "cover",
  ...s
}) {
  const d = D(
    R.hero,
    R[ls[n]],
    c === "cover" && R.cover,
    c === "side" && R.side,
    a
  ), u = e ?? o ?? l, b = !u && t;
  return /* @__PURE__ */ C("section", { className: d, ...s, children: [
    i && /* @__PURE__ */ g("div", { className: R["hero-top-left"], children: i }),
    r && /* @__PURE__ */ g(
      "div",
      {
        className: D(
          R["hero-body"],
          c === "cover" && R.cover,
          c === "side" && R.side
        ),
        children: r
      }
    ),
    u && /* @__PURE__ */ g(
      as,
      {
        imagePosition: c,
        imageSrc: e,
        imageSrcMobile: o,
        imageSrcTablet: l
      }
    ),
    b && /* @__PURE__ */ g(ns, { imagePosition: c, backgroundImage: t })
  ] });
}
const So = {
  MOBILE: 640,
  TABLET: 768
}, rs = (t, e) => t.split(";").map((o) => o.split("=")).filter(([o]) => !e || e.includes(o.trim())).reduce(
  (o, [l, a]) => (o[l.trim()] = a.trim(), o),
  {}
), oo = ({ access_token: t, refresh_token: e } = {}) => {
  const o = {}, l = rs(document.cookie, ["access_token", "refresh_token"]);
  return o.Authorization = `Bearer ${t ?? l.access_token}`, (l.refresh_token || e) && (o.refresh_token = e ?? l.refresh_token), o;
};
function ss() {
  const [t, e] = F({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return ke(() => {
    function o() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", o), o(), () => window.removeEventListener("resize", o);
  }, []), t;
}
function ue() {
  const { width: t } = ss();
  let e = "desktop";
  return t && t <= So.MOBILE ? e = "mobile" : t && t <= So.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop",
    isReady: typeof window < "u"
  };
}
function cs() {
  const t = Ge(!1), e = ct(() => t.current, []);
  return ke(() => (t.current = !0, () => {
    t.current = !1;
  }), []), e;
}
function gs(t) {
  return Array.isArray(t);
}
function lo({
  promiseFn: t,
  enabled: e = !0,
  initialData: o
}) {
  const l = Ge(0), a = cs(), [n, r] = F(o ?? void 0), [i, c] = F(e ?? !1), [s, d] = F(void 0), [u, b] = F(e ?? !1), [f, p] = F(!1), [h, v] = F(!1), m = ct(
    async (...y) => {
      const k = ++l.current;
      i || c(!0);
      try {
        if (!gs(y))
          throw new Error("Invalid arguments provided to the promise function.");
        const x = await t(...y);
        a() && k === l.current && r(x);
      } catch (x) {
        if (a() && k === l.current)
          throw x instanceof Error ? d(x) : d(new Error("An unknown error occurred")), x;
      } finally {
        c(!1), b(!1), p(!1);
      }
    },
    [a, i, t]
  );
  ke(() => {
    u && !f && m();
  }, [u, m, f]);
  const w = ct(
    async (...y) => {
      p(!0), b(!0), v(!0), await m(...y);
    },
    [m]
  );
  return { data: n, loading: i, error: s, refetching: f, refetch: w, hasRefetch: h };
}
const oa = ({
  isModalOpen: t,
  setIsModalOpen: e,
  isLoading: o,
  onConfirmIsMyHomeEligible: l,
  homeId: a
}) => {
  const { t: n } = ae(["landingPage", "common"]);
  return /* @__PURE__ */ C(
    Fr,
    {
      isOpen: t,
      setIsOpen: e,
      title: n("modal.collectionhp.eligibilitycheck.title"),
      onConfirmAction: l,
      onDismissAction: () => e(!1),
      confirmActionIsLoading: o,
      dismissActionText: n("common:global.cancel"),
      confirmActionText: n("common:global.confirm"),
      confirmActionColor: "primary",
      children: [
        /* @__PURE__ */ g(P, { children: n("modal.collectionhp.eligibilitycheck.body") }),
        /* @__PURE__ */ C(ta, { children: [
          /* @__PURE__ */ g(P, { children: n("modal.collectionhp.eligibilitycheck.callout.body") }),
          /* @__PURE__ */ g(ql, { href: `/homes/edit/${a}`, children: n("modal.collectionhp.eligibilitycheck.callout.link") })
        ] })
      ]
    }
  );
}, ds = async (t, e) => {
  const o = oo();
  return Ft.get("/landing-page/collection", {
    headers: o,
    params: { currency: t, locale: e }
  });
}, us = async (t, e) => {
  const o = oo();
  return Ft.get("/landing-page/collection/offline", {
    headers: o,
    params: { currency: t, locale: e }
  });
}, la = async (t) => {
  const e = oo();
  return await Ft.post("/landing-page/collection/eligibility-check", {
    headers: e,
    data: JSON.stringify({
      homeId: t
    })
  });
}, z = (t) => typeof t == "string", qe = () => {
  let t, e;
  const o = new Promise((l, a) => {
    t = l, e = a;
  });
  return o.resolve = t, o.reject = e, o;
}, Do = (t) => t == null ? "" : "" + t, bs = (t, e, o) => {
  t.forEach((l) => {
    e[l] && (o[l] = e[l]);
  });
}, _s = /###/g, No = (t) => t && t.indexOf("###") > -1 ? t.replace(_s, ".") : t, Mo = (t) => !t || z(t), Be = (t, e, o) => {
  const l = z(e) ? e.split(".") : e;
  let a = 0;
  for (; a < l.length - 1; ) {
    if (Mo(t)) return {};
    const n = No(l[a]);
    !t[n] && o && (t[n] = new o()), Object.prototype.hasOwnProperty.call(t, n) ? t = t[n] : t = {}, ++a;
  }
  return Mo(t) ? {} : {
    obj: t,
    k: No(l[a])
  };
}, Po = (t, e, o) => {
  const {
    obj: l,
    k: a
  } = Be(t, e, Object);
  if (l !== void 0 || e.length === 1) {
    l[a] = o;
    return;
  }
  let n = e[e.length - 1], r = e.slice(0, e.length - 1), i = Be(t, r, Object);
  for (; i.obj === void 0 && r.length; )
    n = `${r[r.length - 1]}.${n}`, r = r.slice(0, r.length - 1), i = Be(t, r, Object), i?.obj && typeof i.obj[`${i.k}.${n}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${n}`] = o;
}, hs = (t, e, o, l) => {
  const {
    obj: a,
    k: n
  } = Be(t, e, Object);
  a[n] = a[n] || [], a[n].push(o);
}, bt = (t, e) => {
  const {
    obj: o,
    k: l
  } = Be(t, e);
  if (o && Object.prototype.hasOwnProperty.call(o, l))
    return o[l];
}, fs = (t, e, o) => {
  const l = bt(t, o);
  return l !== void 0 ? l : bt(e, o);
}, aa = (t, e, o) => {
  for (const l in e)
    l !== "__proto__" && l !== "constructor" && (l in t ? z(t[l]) || t[l] instanceof String || z(e[l]) || e[l] instanceof String ? o && (t[l] = e[l]) : aa(t[l], e[l], o) : t[l] = e[l]);
  return t;
}, Ee = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ps = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const ms = (t) => z(t) ? t.replace(/[&<>"'\/]/g, (e) => ps[e]) : t;
class vs {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const o = this.regExpMap.get(e);
    if (o !== void 0)
      return o;
    const l = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, l), this.regExpQueue.push(e), l;
  }
}
const ys = [" ", ",", "?", "!", ";"], ks = new vs(20), ws = (t, e, o) => {
  e = e || "", o = o || "";
  const l = ys.filter((r) => e.indexOf(r) < 0 && o.indexOf(r) < 0);
  if (l.length === 0) return !0;
  const a = ks.getRegExp(`(${l.map((r) => r === "?" ? "\\?" : r).join("|")})`);
  let n = !a.test(t);
  if (!n) {
    const r = t.indexOf(o);
    r > 0 && !a.test(t.substring(0, r)) && (n = !0);
  }
  return n;
}, Bt = (t, e, o = ".") => {
  if (!t) return;
  if (t[e])
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  const l = e.split(o);
  let a = t;
  for (let n = 0; n < l.length; ) {
    if (!a || typeof a != "object")
      return;
    let r, i = "";
    for (let c = n; c < l.length; ++c)
      if (c !== n && (i += o), i += l[c], r = a[i], r !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof r) > -1 && c < l.length - 1)
          continue;
        n += c - n + 1;
        break;
      }
    a = r;
  }
  return a;
}, We = (t) => t?.replace("_", "-"), $s = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console?.[t]?.apply?.(console, e);
  }
};
class _t {
  constructor(e, o = {}) {
    this.init(e, o);
  }
  init(e, o = {}) {
    this.prefix = o.prefix || "i18next:", this.logger = e || $s, this.options = o, this.debug = o.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, o, l, a) {
    return a && !this.debug ? null : (z(e[0]) && (e[0] = `${l}${this.prefix} ${e[0]}`), this.logger[o](e));
  }
  create(e) {
    return new _t(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new _t(this.logger, e);
  }
}
var te = new _t();
class $t {
  constructor() {
    this.observers = {};
  }
  on(e, o) {
    return e.split(" ").forEach((l) => {
      this.observers[l] || (this.observers[l] = /* @__PURE__ */ new Map());
      const a = this.observers[l].get(o) || 0;
      this.observers[l].set(o, a + 1);
    }), this;
  }
  off(e, o) {
    if (this.observers[e]) {
      if (!o) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(o);
    }
  }
  emit(e, ...o) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([a, n]) => {
      for (let r = 0; r < n; r++)
        a(...o);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([a, n]) => {
      for (let r = 0; r < n; r++)
        a.apply(a, [e, ...o]);
    });
  }
}
class Ao extends $t {
  constructor(e, o = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = e || {}, this.options = o, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const o = this.options.ns.indexOf(e);
    o > -1 && this.options.ns.splice(o, 1);
  }
  getResource(e, o, l, a = {}) {
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, r = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    e.indexOf(".") > -1 ? i = e.split(".") : (i = [e, o], l && (Array.isArray(l) ? i.push(...l) : z(l) && n ? i.push(...l.split(n)) : i.push(l)));
    const c = bt(this.data, i);
    return !c && !o && !l && e.indexOf(".") > -1 && (e = i[0], o = i[1], l = i.slice(2).join(".")), c || !r || !z(l) ? c : Bt(this.data?.[e]?.[o], l, n);
  }
  addResource(e, o, l, a, n = {
    silent: !1
  }) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = [e, o];
    l && (i = i.concat(r ? l.split(r) : l)), e.indexOf(".") > -1 && (i = e.split("."), a = o, o = i[1]), this.addNamespaces(o), Po(this.data, i, a), n.silent || this.emit("added", e, o, l, a);
  }
  addResources(e, o, l, a = {
    silent: !1
  }) {
    for (const n in l)
      (z(l[n]) || Array.isArray(l[n])) && this.addResource(e, o, n, l[n], {
        silent: !0
      });
    a.silent || this.emit("added", e, o, l);
  }
  addResourceBundle(e, o, l, a, n, r = {
    silent: !1,
    skipCopy: !1
  }) {
    let i = [e, o];
    e.indexOf(".") > -1 && (i = e.split("."), a = l, l = o, o = i[1]), this.addNamespaces(o);
    let c = bt(this.data, i) || {};
    r.skipCopy || (l = JSON.parse(JSON.stringify(l))), a ? aa(c, l, n) : c = {
      ...c,
      ...l
    }, Po(this.data, i, c), r.silent || this.emit("added", e, o, l);
  }
  removeResourceBundle(e, o) {
    this.hasResourceBundle(e, o) && delete this.data[e][o], this.removeNamespaces(o), this.emit("removed", e, o);
  }
  hasResourceBundle(e, o) {
    return this.getResource(e, o) !== void 0;
  }
  getResourceBundle(e, o) {
    return o || (o = this.options.defaultNS), this.getResource(e, o);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const o = this.getDataByLanguage(e);
    return !!(o && Object.keys(o) || []).find((a) => o[a] && Object.keys(o[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var na = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, o, l, a) {
    return t.forEach((n) => {
      e = this.processors[n]?.process(e, o, l, a) ?? e;
    }), e;
  }
};
const ia = Symbol("i18next/PATH_KEY");
function xs() {
  const t = [], e = /* @__PURE__ */ Object.create(null);
  let o;
  return e.get = (l, a) => (o?.revoke?.(), a === ia ? t : (t.push(a), o = Proxy.revocable(l, e), o.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), e).proxy;
}
function Rt(t, e) {
  const {
    [ia]: o
  } = t(xs());
  return o.join(e?.keySeparator ?? ".");
}
const Lo = {}, To = (t) => !z(t) && typeof t != "boolean" && typeof t != "number";
class ht extends $t {
  constructor(e, o = {}) {
    super(), bs(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = o, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = te.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, o = {
    interpolation: {}
  }) {
    const l = {
      ...o
    };
    return e == null ? !1 : this.resolve(e, l)?.res !== void 0;
  }
  extractFromKey(e, o) {
    let l = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
    l === void 0 && (l = ":");
    const a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let n = o.ns || this.options.defaultNS || [];
    const r = l && e.indexOf(l) > -1, i = !this.options.userDefinedKeySeparator && !o.keySeparator && !this.options.userDefinedNsSeparator && !o.nsSeparator && !ws(e, l, a);
    if (r && !i) {
      const c = e.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: e,
          namespaces: z(n) ? [n] : n
        };
      const s = e.split(l);
      (l !== a || l === a && this.options.ns.indexOf(s[0]) > -1) && (n = s.shift()), e = s.join(a);
    }
    return {
      key: e,
      namespaces: z(n) ? [n] : n
    };
  }
  translate(e, o, l) {
    let a = typeof o == "object" ? {
      ...o
    } : o;
    if (typeof a != "object" && this.options.overloadTranslationOptionHandler && (a = this.options.overloadTranslationOptionHandler(arguments)), typeof a == "object" && (a = {
      ...a
    }), a || (a = {}), e == null) return "";
    typeof e == "function" && (e = Rt(e, {
      ...this.options,
      ...a
    })), Array.isArray(e) || (e = [String(e)]);
    const n = a.returnDetails !== void 0 ? a.returnDetails : this.options.returnDetails, r = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: c
    } = this.extractFromKey(e[e.length - 1], a), s = c[c.length - 1];
    let d = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    d === void 0 && (d = ":");
    const u = a.lng || this.language, b = a.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u?.toLowerCase() === "cimode")
      return b ? n ? {
        res: `${s}${d}${i}`,
        usedKey: i,
        exactUsedKey: i,
        usedLng: u,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(a)
      } : `${s}${d}${i}` : n ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: u,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(a)
      } : i;
    const f = this.resolve(e, a);
    let p = f?.res;
    const h = f?.usedKey || i, v = f?.exactUsedKey || i, m = ["[object Number]", "[object Function]", "[object RegExp]"], w = a.joinArrays !== void 0 ? a.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = a.count !== void 0 && !z(a.count), x = ht.hasDefaultValue(a), j = k ? this.pluralResolver.getSuffix(u, a.count, a) : "", $ = a.ordinal && k ? this.pluralResolver.getSuffix(u, a.count, {
      ordinal: !1
    }) : "", M = k && !a.ordinal && a.count === 0, N = M && a[`defaultValue${this.options.pluralSeparator}zero`] || a[`defaultValue${j}`] || a[`defaultValue${$}`] || a.defaultValue;
    let O = p;
    y && !p && x && (O = N);
    const A = To(O), be = Object.prototype.toString.apply(O);
    if (y && O && A && m.indexOf(be) < 0 && !(z(w) && Array.isArray(O))) {
      if (!a.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const T = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, O, {
          ...a,
          ns: c
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return n ? (f.res = T, f.usedParams = this.getUsedParamsDetails(a), f) : T;
      }
      if (r) {
        const T = Array.isArray(O), q = T ? [] : {}, Je = T ? v : h;
        for (const E in O)
          if (Object.prototype.hasOwnProperty.call(O, E)) {
            const re = `${Je}${r}${E}`;
            x && !p ? q[E] = this.translate(re, {
              ...a,
              defaultValue: To(N) ? N[E] : void 0,
              joinArrays: !1,
              ns: c
            }) : q[E] = this.translate(re, {
              ...a,
              joinArrays: !1,
              ns: c
            }), q[E] === re && (q[E] = O[E]);
          }
        p = q;
      }
    } else if (y && z(w) && Array.isArray(p))
      p = p.join(w), p && (p = this.extendTranslation(p, e, a, l));
    else {
      let T = !1, q = !1;
      !this.isValidLookup(p) && x && (T = !0, p = N), this.isValidLookup(p) || (q = !0, p = i);
      const E = (a.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && q ? void 0 : p, re = x && N !== p && this.options.updateMissing;
      if (q || T || re) {
        if (this.logger.log(re ? "updateKey" : "missingKey", u, s, i, re ? N : p), r) {
          const V = this.resolve(i, {
            ...a,
            keySeparator: !1
          });
          V && V.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Pe = [];
        const Ye = this.languageUtils.getFallbackCodes(this.options.fallbackLng, a.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Ye && Ye[0])
          for (let V = 0; V < Ye.length; V++)
            Pe.push(Ye[V]);
        else this.options.saveMissingTo === "all" ? Pe = this.languageUtils.toResolveHierarchy(a.lng || this.language) : Pe.push(a.lng || this.language);
        const ao = (V, ve, Ae) => {
          const no = x && Ae !== p ? Ae : E;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(V, s, ve, no, re, a) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(V, s, ve, no, re, a), this.emit("missingKey", V, s, ve, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? Pe.forEach((V) => {
          const ve = this.pluralResolver.getSuffixes(V, a);
          M && a[`defaultValue${this.options.pluralSeparator}zero`] && ve.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ve.push(`${this.options.pluralSeparator}zero`), ve.forEach((Ae) => {
            ao([V], i + Ae, a[`defaultValue${Ae}`] || N);
          });
        }) : ao(Pe, i, N));
      }
      p = this.extendTranslation(p, e, a, f, l), q && p === i && this.options.appendNamespaceToMissingKey && (p = `${s}${d}${i}`), (q || T) && this.options.parseMissingKeyHandler && (p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${s}${d}${i}` : i, T ? p : void 0, a));
    }
    return n ? (f.res = p, f.usedParams = this.getUsedParamsDetails(a), f) : p;
  }
  extendTranslation(e, o, l, a, n) {
    if (this.i18nFormat?.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...l
      }, l.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!l.skipInterpolation) {
      l.interpolation && this.interpolator.init({
        ...l,
        interpolation: {
          ...this.options.interpolation,
          ...l.interpolation
        }
      });
      const c = z(e) && (l?.interpolation?.skipOnVariables !== void 0 ? l.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let s;
      if (c) {
        const u = e.match(this.interpolator.nestingRegexp);
        s = u && u.length;
      }
      let d = l.replace && !z(l.replace) ? l.replace : l;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, l.lng || this.language || a.usedLng, l), c) {
        const u = e.match(this.interpolator.nestingRegexp), b = u && u.length;
        s < b && (l.nest = !1);
      }
      !l.lng && a && a.res && (l.lng = this.language || a.usedLng), l.nest !== !1 && (e = this.interpolator.nest(e, (...u) => n?.[0] === u[0] && !l.context ? (this.logger.warn(`It seems you are nesting recursively key: ${u[0]} in key: ${o[0]}`), null) : this.translate(...u, o), l)), l.interpolation && this.interpolator.reset();
    }
    const r = l.postProcess || this.options.postProcess, i = z(r) ? [r] : r;
    return e != null && i?.length && l.applyPostProcessor !== !1 && (e = na.handle(i, e, o, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(l)
      },
      ...l
    } : l, this)), e;
  }
  resolve(e, o = {}) {
    let l, a, n, r, i;
    return z(e) && (e = [e]), e.forEach((c) => {
      if (this.isValidLookup(l)) return;
      const s = this.extractFromKey(c, o), d = s.key;
      a = d;
      let u = s.namespaces;
      this.options.fallbackNS && (u = u.concat(this.options.fallbackNS));
      const b = o.count !== void 0 && !z(o.count), f = b && !o.ordinal && o.count === 0, p = o.context !== void 0 && (z(o.context) || typeof o.context == "number") && o.context !== "", h = o.lngs ? o.lngs : this.languageUtils.toResolveHierarchy(o.lng || this.language, o.fallbackLng);
      u.forEach((v) => {
        this.isValidLookup(l) || (i = v, !Lo[`${h[0]}-${v}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(i) && (Lo[`${h[0]}-${v}`] = !0, this.logger.warn(`key "${a}" for languages "${h.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach((m) => {
          if (this.isValidLookup(l)) return;
          r = m;
          const w = [d];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(w, d, m, v, o);
          else {
            let k;
            b && (k = this.pluralResolver.getSuffix(m, o.count, o));
            const x = `${this.options.pluralSeparator}zero`, j = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (b && (o.ordinal && k.indexOf(j) === 0 && w.push(d + k.replace(j, this.options.pluralSeparator)), w.push(d + k), f && w.push(d + x)), p) {
              const $ = `${d}${this.options.contextSeparator || "_"}${o.context}`;
              w.push($), b && (o.ordinal && k.indexOf(j) === 0 && w.push($ + k.replace(j, this.options.pluralSeparator)), w.push($ + k), f && w.push($ + x));
            }
          }
          let y;
          for (; y = w.pop(); )
            this.isValidLookup(l) || (n = y, l = this.getResource(m, v, y, o));
        }));
      });
    }), {
      res: l,
      usedKey: a,
      exactUsedKey: n,
      usedLng: r,
      usedNS: i
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, o, l, a = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(e, o, l, a) : this.resourceStore.getResource(e, o, l, a);
  }
  getUsedParamsDetails(e = {}) {
    const o = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], l = e.replace && !z(e.replace);
    let a = l ? e.replace : e;
    if (l && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !l) {
      a = {
        ...a
      };
      for (const n of o)
        delete a[n];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const o = "defaultValue";
    for (const l in e)
      if (Object.prototype.hasOwnProperty.call(e, l) && o === l.substring(0, o.length) && e[l] !== void 0)
        return !0;
    return !1;
  }
}
class qo {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = te.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = We(e), !e || e.indexOf("-") < 0) return null;
    const o = e.split("-");
    return o.length === 2 || (o.pop(), o[o.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(o.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = We(e), !e || e.indexOf("-") < 0) return e;
    const o = e.split("-");
    return this.formatLanguageCode(o[0]);
  }
  formatLanguageCode(e) {
    if (z(e) && e.indexOf("-") > -1) {
      let o;
      try {
        o = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return o && this.options.lowerCaseLng && (o = o.toLowerCase()), o || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let o;
    return e.forEach((l) => {
      if (o) return;
      const a = this.formatLanguageCode(l);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (o = a);
    }), !o && this.options.supportedLngs && e.forEach((l) => {
      if (o) return;
      const a = this.getScriptPartFromCode(l);
      if (this.isSupportedCode(a)) return o = a;
      const n = this.getLanguagePartFromCode(l);
      if (this.isSupportedCode(n)) return o = n;
      o = this.options.supportedLngs.find((r) => {
        if (r === n) return r;
        if (!(r.indexOf("-") < 0 && n.indexOf("-") < 0) && (r.indexOf("-") > 0 && n.indexOf("-") < 0 && r.substring(0, r.indexOf("-")) === n || r.indexOf(n) === 0 && n.length > 1))
          return r;
      });
    }), o || (o = this.getFallbackCodes(this.options.fallbackLng)[0]), o;
  }
  getFallbackCodes(e, o) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(o)), z(e) && (e = [e]), Array.isArray(e)) return e;
    if (!o) return e.default || [];
    let l = e[o];
    return l || (l = e[this.getScriptPartFromCode(o)]), l || (l = e[this.formatLanguageCode(o)]), l || (l = e[this.getLanguagePartFromCode(o)]), l || (l = e.default), l || [];
  }
  toResolveHierarchy(e, o) {
    const l = this.getFallbackCodes((o === !1 ? [] : o) || this.options.fallbackLng || [], e), a = [], n = (r) => {
      r && (this.isSupportedCode(r) ? a.push(r) : this.logger.warn(`rejecting language code not found in supportedLngs: ${r}`));
    };
    return z(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && n(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && n(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && n(this.getLanguagePartFromCode(e))) : z(e) && n(this.formatLanguageCode(e)), l.forEach((r) => {
      a.indexOf(r) < 0 && n(this.formatLanguageCode(r));
    }), a;
  }
}
const Io = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Bo = {
  select: (t) => t === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class js {
  constructor(e, o = {}) {
    this.languageUtils = e, this.options = o, this.logger = te.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, o) {
    this.rules[e] = o;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, o = {}) {
    const l = We(e === "dev" ? "en" : e), a = o.ordinal ? "ordinal" : "cardinal", n = JSON.stringify({
      cleanedCode: l,
      type: a
    });
    if (n in this.pluralRulesCache)
      return this.pluralRulesCache[n];
    let r;
    try {
      r = new Intl.PluralRules(l, {
        type: a
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Bo;
      if (!e.match(/-|_/)) return Bo;
      const c = this.languageUtils.getLanguagePartFromCode(e);
      r = this.getRule(c, o);
    }
    return this.pluralRulesCache[n] = r, r;
  }
  needsPlural(e, o = {}) {
    let l = this.getRule(e, o);
    return l || (l = this.getRule("dev", o)), l?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(e, o, l = {}) {
    return this.getSuffixes(e, l).map((a) => `${o}${a}`);
  }
  getSuffixes(e, o = {}) {
    let l = this.getRule(e, o);
    return l || (l = this.getRule("dev", o)), l ? l.resolvedOptions().pluralCategories.sort((a, n) => Io[a] - Io[n]).map((a) => `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : [];
  }
  getSuffix(e, o, l = {}) {
    const a = this.getRule(e, l);
    return a ? `${this.options.prepend}${l.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(o)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", o, l));
  }
}
const Ro = (t, e, o, l = ".", a = !0) => {
  let n = fs(t, e, o);
  return !n && a && z(o) && (n = Bt(t, o, l), n === void 0 && (n = Bt(e, o, l))), n;
}, At = (t) => t.replace(/\$/g, "$$$$");
class zs {
  constructor(e = {}) {
    this.logger = te.create("interpolator"), this.options = e, this.format = e?.interpolation?.format || ((o) => o), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: o,
      escapeValue: l,
      useRawValueToEscape: a,
      prefix: n,
      prefixEscaped: r,
      suffix: i,
      suffixEscaped: c,
      formatSeparator: s,
      unescapeSuffix: d,
      unescapePrefix: u,
      nestingPrefix: b,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: h,
      nestingOptionsSeparator: v,
      maxReplaces: m,
      alwaysFormat: w
    } = e.interpolation;
    this.escape = o !== void 0 ? o : ms, this.escapeValue = l !== void 0 ? l : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = n ? Ee(n) : r || "{{", this.suffix = i ? Ee(i) : c || "}}", this.formatSeparator = s || ",", this.unescapePrefix = d ? "" : u || "-", this.unescapeSuffix = this.unescapePrefix ? "" : d || "", this.nestingPrefix = b ? Ee(b) : f || Ee("$t("), this.nestingSuffix = p ? Ee(p) : h || Ee(")"), this.nestingOptionsSeparator = v || ",", this.maxReplaces = m || 1e3, this.alwaysFormat = w !== void 0 ? w : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (o, l) => o?.source === l ? (o.lastIndex = 0, o) : new RegExp(l, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(e, o, l, a) {
    let n, r, i;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, s = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const m = Ro(o, c, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(m, void 0, l, {
          ...a,
          ...o,
          interpolationkey: f
        }) : m;
      }
      const p = f.split(this.formatSeparator), h = p.shift().trim(), v = p.join(this.formatSeparator).trim();
      return this.format(Ro(o, c, h, this.options.keySeparator, this.options.ignoreJSONStructure), v, l, {
        ...a,
        ...o,
        interpolationkey: h
      });
    };
    this.resetRegExp();
    const d = a?.missingInterpolationHandler || this.options.missingInterpolationHandler, u = a?.interpolation?.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => At(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? At(this.escape(f)) : At(f)
    }].forEach((f) => {
      for (i = 0; n = f.regex.exec(e); ) {
        const p = n[1].trim();
        if (r = s(p), r === void 0)
          if (typeof d == "function") {
            const v = d(e, n, a);
            r = z(v) ? v : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, p))
            r = "";
          else if (u) {
            r = n[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), r = "";
        else !z(r) && !this.useRawValueToEscape && (r = Do(r));
        const h = f.safeValue(r);
        if (e = e.replace(n[0], h), u ? (f.regex.lastIndex += r.length, f.regex.lastIndex -= n[0].length) : f.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, o, l = {}) {
    let a, n, r;
    const i = (c, s) => {
      const d = this.nestingOptionsSeparator;
      if (c.indexOf(d) < 0) return c;
      const u = c.split(new RegExp(`${d}[ ]*{`));
      let b = `{${u[1]}`;
      c = u[0], b = this.interpolate(b, r);
      const f = b.match(/'/g), p = b.match(/"/g);
      ((f?.length ?? 0) % 2 === 0 && !p || p.length % 2 !== 0) && (b = b.replace(/'/g, '"'));
      try {
        r = JSON.parse(b), s && (r = {
          ...s,
          ...r
        });
      } catch (h) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, h), `${c}${d}${b}`;
      }
      return r.defaultValue && r.defaultValue.indexOf(this.prefix) > -1 && delete r.defaultValue, c;
    };
    for (; a = this.nestingRegexp.exec(e); ) {
      let c = [];
      r = {
        ...l
      }, r = r.replace && !z(r.replace) ? r.replace : r, r.applyPostProcessor = !1, delete r.defaultValue;
      const s = /{.*}/.test(a[1]) ? a[1].lastIndexOf("}") + 1 : a[1].indexOf(this.formatSeparator);
      if (s !== -1 && (c = a[1].slice(s).split(this.formatSeparator).map((d) => d.trim()).filter(Boolean), a[1] = a[1].slice(0, s)), n = o(i.call(this, a[1].trim(), r), r), n && a[0] === e && !z(n)) return n;
      z(n) || (n = Do(n)), n || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), n = ""), c.length && (n = c.reduce((d, u) => this.format(d, u, l.lng, {
        ...l,
        interpolationkey: a[1].trim()
      }), n.trim())), e = e.replace(a[0], n), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Cs = (t) => {
  let e = t.toLowerCase().trim();
  const o = {};
  if (t.indexOf("(") > -1) {
    const l = t.split("(");
    e = l[0].toLowerCase().trim();
    const a = l[1].substring(0, l[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? o.currency || (o.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? o.range || (o.range = a.trim()) : a.split(";").forEach((r) => {
      if (r) {
        const [i, ...c] = r.split(":"), s = c.join(":").trim().replace(/^'+|'+$/g, ""), d = i.trim();
        o[d] || (o[d] = s), s === "false" && (o[d] = !1), s === "true" && (o[d] = !0), isNaN(s) || (o[d] = parseInt(s, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: o
  };
}, Fo = (t) => {
  const e = {};
  return (o, l, a) => {
    let n = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (n = {
      ...n,
      [a.interpolationkey]: void 0
    });
    const r = l + JSON.stringify(n);
    let i = e[r];
    return i || (i = t(We(l), a), e[r] = i), i(o);
  };
}, Os = (t) => (e, o, l) => t(We(o), l)(e);
class Es {
  constructor(e = {}) {
    this.logger = te.create("formatter"), this.options = e, this.init(e);
  }
  init(e, o = {
    interpolation: {}
  }) {
    this.formatSeparator = o.interpolation.formatSeparator || ",";
    const l = o.cacheInBuiltFormats ? Fo : Os;
    this.formats = {
      number: l((a, n) => {
        const r = new Intl.NumberFormat(a, {
          ...n
        });
        return (i) => r.format(i);
      }),
      currency: l((a, n) => {
        const r = new Intl.NumberFormat(a, {
          ...n,
          style: "currency"
        });
        return (i) => r.format(i);
      }),
      datetime: l((a, n) => {
        const r = new Intl.DateTimeFormat(a, {
          ...n
        });
        return (i) => r.format(i);
      }),
      relativetime: l((a, n) => {
        const r = new Intl.RelativeTimeFormat(a, {
          ...n
        });
        return (i) => r.format(i, n.range || "day");
      }),
      list: l((a, n) => {
        const r = new Intl.ListFormat(a, {
          ...n
        });
        return (i) => r.format(i);
      })
    };
  }
  add(e, o) {
    this.formats[e.toLowerCase().trim()] = o;
  }
  addCached(e, o) {
    this.formats[e.toLowerCase().trim()] = Fo(o);
  }
  format(e, o, l, a = {}) {
    const n = o.split(this.formatSeparator);
    if (n.length > 1 && n[0].indexOf("(") > 1 && n[0].indexOf(")") < 0 && n.find((i) => i.indexOf(")") > -1)) {
      const i = n.findIndex((c) => c.indexOf(")") > -1);
      n[0] = [n[0], ...n.splice(1, i)].join(this.formatSeparator);
    }
    return n.reduce((i, c) => {
      const {
        formatName: s,
        formatOptions: d
      } = Cs(c);
      if (this.formats[s]) {
        let u = i;
        try {
          const b = a?.formatParams?.[a.interpolationkey] || {}, f = b.locale || b.lng || a.locale || a.lng || l;
          u = this.formats[s](i, f, {
            ...d,
            ...a,
            ...b
          });
        } catch (b) {
          this.logger.warn(b);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${s}`);
      return i;
    }, e);
  }
}
const Ss = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class Ds extends $t {
  constructor(e, o, l, a = {}) {
    super(), this.backend = e, this.store = o, this.services = l, this.languageUtils = l.languageUtils, this.options = a, this.logger = te.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(l, a.backend, a);
  }
  queueLoad(e, o, l, a) {
    const n = {}, r = {}, i = {}, c = {};
    return e.forEach((s) => {
      let d = !0;
      o.forEach((u) => {
        const b = `${s}|${u}`;
        !l.reload && this.store.hasResourceBundle(s, u) ? this.state[b] = 2 : this.state[b] < 0 || (this.state[b] === 1 ? r[b] === void 0 && (r[b] = !0) : (this.state[b] = 1, d = !1, r[b] === void 0 && (r[b] = !0), n[b] === void 0 && (n[b] = !0), c[u] === void 0 && (c[u] = !0)));
      }), d || (i[s] = !0);
    }), (Object.keys(n).length || Object.keys(r).length) && this.queue.push({
      pending: r,
      pendingCount: Object.keys(r).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(n),
      pending: Object.keys(r),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(e, o, l) {
    const a = e.split("|"), n = a[0], r = a[1];
    o && this.emit("failedLoading", n, r, o), !o && l && this.store.addResourceBundle(n, r, l, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = o ? -1 : 2, o && l && (this.state[e] = 0);
    const i = {};
    this.queue.forEach((c) => {
      hs(c.loaded, [n], r), Ss(c, e), o && c.errors.push(o), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((s) => {
        i[s] || (i[s] = {});
        const d = c.loaded[s];
        d.length && d.forEach((u) => {
          i[s][u] === void 0 && (i[s][u] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((c) => !c.done);
  }
  read(e, o, l, a = 0, n = this.retryTimeout, r) {
    if (!e.length) return r(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: o,
        fcName: l,
        tried: a,
        wait: n,
        callback: r
      });
      return;
    }
    this.readingCalls++;
    const i = (s, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const u = this.waitingReads.shift();
        this.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
      }
      if (s && d && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, o, l, a + 1, n * 2, r);
        }, n);
        return;
      }
      r(s, d);
    }, c = this.backend[l].bind(this.backend);
    if (c.length === 2) {
      try {
        const s = c(e, o);
        s && typeof s.then == "function" ? s.then((d) => i(null, d)).catch(i) : i(null, s);
      } catch (s) {
        i(s);
      }
      return;
    }
    return c(e, o, i);
  }
  prepareLoading(e, o, l = {}, a) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    z(e) && (e = this.languageUtils.toResolveHierarchy(e)), z(o) && (o = [o]);
    const n = this.queueLoad(e, o, l, a);
    if (!n.toLoad.length)
      return n.pending.length || a(), null;
    n.toLoad.forEach((r) => {
      this.loadOne(r);
    });
  }
  load(e, o, l) {
    this.prepareLoading(e, o, {}, l);
  }
  reload(e, o, l) {
    this.prepareLoading(e, o, {
      reload: !0
    }, l);
  }
  loadOne(e, o = "") {
    const l = e.split("|"), a = l[0], n = l[1];
    this.read(a, n, "read", void 0, void 0, (r, i) => {
      r && this.logger.warn(`${o}loading namespace ${n} for language ${a} failed`, r), !r && i && this.logger.log(`${o}loaded namespace ${n} for language ${a}`, i), this.loaded(e, r, i);
    });
  }
  saveMissing(e, o, l, a, n, r = {}, i = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(o)) {
      this.logger.warn(`did not save key "${l}" as the namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(l == null || l === "")) {
      if (this.backend?.create) {
        const c = {
          ...r,
          isUpdate: n
        }, s = this.backend.create.bind(this.backend);
        if (s.length < 6)
          try {
            let d;
            s.length === 5 ? d = s(e, o, l, a, c) : d = s(e, o, l, a), d && typeof d.then == "function" ? d.then((u) => i(null, u)).catch(i) : i(null, d);
          } catch (d) {
            i(d);
          }
        else
          s(e, o, l, a, i, c);
      }
      !e || !e[0] || this.store.addResource(e[0], o, l, a);
    }
  }
}
const Ho = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), z(t[1]) && (e.defaultValue = t[1]), z(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const o = t[3] || t[2];
      Object.keys(o).forEach((l) => {
        e[l] = o[l];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Wo = (t) => (z(t.ns) && (t.ns = [t.ns]), z(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), z(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs?.indexOf?.("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), typeof t.initImmediate == "boolean" && (t.initAsync = t.initImmediate), t), lt = () => {
}, Ns = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((o) => {
    typeof t[o] == "function" && (t[o] = t[o].bind(t));
  });
};
class Ve extends $t {
  constructor(e = {}, o) {
    if (super(), this.options = Wo(e), this.services = {}, this.logger = te, this.modules = {
      external: []
    }, Ns(this), o && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, o), this;
      setTimeout(() => {
        this.init(e, o);
      }, 0);
    }
  }
  init(e = {}, o) {
    this.isInitializing = !0, typeof e == "function" && (o = e, e = {}), e.defaultNS == null && e.ns && (z(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const l = Ho();
    this.options = {
      ...l,
      ...this.options,
      ...Wo(e)
    }, this.options.interpolation = {
      ...l.interpolation,
      ...this.options.interpolation
    }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const a = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? te.init(a(this.modules.logger), this.options) : te.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = Es;
      const d = new qo(this.options);
      this.store = new Ao(this.options.resources, this.options);
      const u = this.services;
      u.logger = te, u.resourceStore = this.store, u.languageUtils = d, u.pluralResolver = new js(d, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== l.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (u.formatter = a(s), u.formatter.init && u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new zs(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new Ds(a(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", (f, ...p) => {
        this.emit(f, ...p);
      }), this.modules.languageDetector && (u.languageDetector = a(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = a(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new ht(this.services, this.options), this.translator.on("*", (f, ...p) => {
        this.emit(f, ...p);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, o || (o = lt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...d) => this.store[s](...d);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...d) => (this.store[s](...d), this);
    });
    const i = qe(), c = () => {
      const s = (d, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(u), o(d, u);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), i;
  }
  loadResources(e, o = lt) {
    let l = o;
    const a = z(e) ? e : this.language;
    if (typeof e == "function" && (l = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (a?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return l();
      const n = [], r = (i) => {
        if (!i || i === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(i).forEach((s) => {
          s !== "cimode" && n.indexOf(s) < 0 && n.push(s);
        });
      };
      a ? r(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => r(c)), this.options.preload?.forEach?.((i) => r(i)), this.services.backendConnector.load(n, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), l(i);
      });
    } else
      l(null);
  }
  reloadResources(e, o, l) {
    const a = qe();
    return typeof e == "function" && (l = e, e = void 0), typeof o == "function" && (l = o, o = void 0), e || (e = this.languages), o || (o = this.options.ns), l || (l = lt), this.services.backendConnector.reload(e, o, (n) => {
      a.resolve(), l(n);
    }), a;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && na.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let o = 0; o < this.languages.length; o++) {
        const l = this.languages[o];
        if (!(["cimode", "dev"].indexOf(l) > -1) && this.store.hasLanguageSomeTranslations(l)) {
          this.resolvedLanguage = l;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, o) {
    this.isLanguageChangingTo = e;
    const l = qe();
    this.emit("languageChanging", e);
    const a = (i) => {
      this.language = i, this.languages = this.services.languageUtils.toResolveHierarchy(i), this.resolvedLanguage = void 0, this.setResolvedLanguage(i);
    }, n = (i, c) => {
      c ? this.isLanguageChangingTo === e && (a(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, l.resolve((...s) => this.t(...s)), o && o(i, (...s) => this.t(...s));
    }, r = (i) => {
      !e && !i && this.services.languageDetector && (i = []);
      const c = z(i) ? i : i && i[0], s = this.store.hasLanguageSomeTranslations(c) ? c : this.services.languageUtils.getBestMatchFromCodes(z(i) ? [i] : i);
      s && (this.language || a(s), this.translator.language || this.translator.changeLanguage(s), this.services.languageDetector?.cacheUserLanguage?.(s)), this.loadResources(s, (d) => {
        n(d, s);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? r(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(r) : this.services.languageDetector.detect(r) : r(e), l;
  }
  getFixedT(e, o, l) {
    const a = (n, r, ...i) => {
      let c;
      typeof r != "object" ? c = this.options.overloadTranslationOptionHandler([n, r].concat(i)) : c = {
        ...r
      }, c.lng = c.lng || a.lng, c.lngs = c.lngs || a.lngs, c.ns = c.ns || a.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || l || a.keyPrefix);
      const s = this.options.keySeparator || ".";
      let d;
      return c.keyPrefix && Array.isArray(n) ? d = n.map((u) => (typeof u == "function" && (u = Rt(u, {
        ...this.options,
        ...r
      })), `${c.keyPrefix}${s}${u}`)) : (typeof n == "function" && (n = Rt(n, {
        ...this.options,
        ...r
      })), d = c.keyPrefix ? `${c.keyPrefix}${s}${n}` : n), this.t(d, c);
    };
    return z(e) ? a.lng = e : a.lngs = e, a.ns = o, a.keyPrefix = l, a;
  }
  t(...e) {
    return this.translator?.translate(...e);
  }
  exists(...e) {
    return this.translator?.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, o = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const l = o.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, n = this.languages[this.languages.length - 1];
    if (l.toLowerCase() === "cimode") return !0;
    const r = (i, c) => {
      const s = this.services.backendConnector.state[`${i}|${c}`];
      return s === -1 || s === 0 || s === 2;
    };
    if (o.precheck) {
      const i = o.precheck(this, r);
      if (i !== void 0) return i;
    }
    return !!(this.hasResourceBundle(l, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || r(l, e) && (!a || r(n, e)));
  }
  loadNamespaces(e, o) {
    const l = qe();
    return this.options.ns ? (z(e) && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      l.resolve(), o && o(a);
    }), l) : (o && o(), Promise.resolve());
  }
  loadLanguages(e, o) {
    const l = qe();
    z(e) && (e = [e]);
    const a = this.options.preload || [], n = e.filter((r) => a.indexOf(r) < 0 && this.services.languageUtils.isSupportedCode(r));
    return n.length ? (this.options.preload = a.concat(n), this.loadResources((r) => {
      l.resolve(), o && o(r);
    }), l) : (o && o(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    try {
      const a = new Intl.Locale(e);
      if (a && a.getTextInfo) {
        const n = a.getTextInfo();
        if (n && n.direction) return n.direction;
      }
    } catch {
    }
    const o = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], l = this.services?.languageUtils || new qo(Ho());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : o.indexOf(l.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, o) {
    return new Ve(e, o);
  }
  cloneInstance(e = {}, o = lt) {
    const l = e.forkResourceStore;
    l && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, n = new Ve(a);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (n.logger = n.logger.clone(e)), ["store", "services", "language"].forEach((i) => {
      n[i] = this[i];
    }), n.services = {
      ...this.services
    }, n.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, l) {
      const i = Object.keys(this.store.data).reduce((c, s) => (c[s] = {
        ...this.store.data[s]
      }, c[s] = Object.keys(c[s]).reduce((d, u) => (d[u] = {
        ...c[s][u]
      }, d), c[s]), c), {});
      n.store = new Ao(i, a), n.services.resourceStore = n.store;
    }
    return n.translator = new ht(n.services, a), n.translator.on("*", (i, ...c) => {
      n.emit(i, ...c);
    }), n.init(a, o), n.translator.options = a, n.translator.backendConnector.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, n;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const B = Ve.createInstance();
B.createInstance = Ve.createInstance;
const Ms = B.createInstance;
B.dir;
B.init;
B.loadResources;
B.reloadResources;
B.use;
B.changeLanguage;
B.getFixedT;
B.t;
B.exists;
B.setDefaultNamespace;
B.hasLoadedNamespace;
B.loadNamespaces;
B.loadLanguages;
const Ps = "Studio", As = "{{count}} soveværelse", Ls = "{{count}} soveværelser", Ts = "", qs = "{{count}} seng", Is = "{{count}} senge", Bs = "Voksne", Rs = "Babyer", Fs = "Din kalender er blevet opdateret.", Hs = "En måned", Ws = "Præcise datoer", Vs = "Uge", Gs = "", Us = "", Ks = "", Js = "", Ys = "To uger", Zs = "Annuller", Qs = "Børn", Xs = "Datoer", ec = "Slet", tc = "Beskrivelse", oc = "Destination", lc = "Sådan!", ac = "Rediger", nc = "Enhver form for udveksling", ic = "Badekar", rc = "Grill", sc = "Cykel", cc = "Bil", gc = "Kat", dc = "By", uc = "På landet", bc = "Opvaskemaskine", _c = "Hund", hc = "Tørretumbler", fc = "Elevator", pc = "Favoritboliger", mc = "Pejs/brændeovn", vc = "Lejlighed", yc = "Privat have", kc = "under {{max}} GP", wc = "fra {{min}} GP", $c = "Mellem {{min}} og {{max}} GP", xc = "Privat fitnessrum", jc = "Hus", zc = "En Ø", Cc = "Isoleret", Oc = "Jacuzzi", Ec = "Søer", Sc = "Collection-hjem", Dc = "Bjerge", Nc = "{{count}} badeværelser", Mc = "Andre dyr", Pc = "Klaver", Ac = "Legeplads", Lc = "Primære bolig", Tc = "Gensifig udveksling", qc = "Omvendt søgning", Ic = "Flod", Bc = "Kystnær", Rc = "Feriebolig", Fc = "TV", Hc = "Landsby", Wc = "Wi-Fi", Vc = "Filtre", Gc = "Faste datoer", Uc = "En måned i {{date}}", Kc = "En weekend i {{date}}", Jc = "En uge i {{date}}", Yc = "To uger i {{date}}", Zc = "Fleksible datoer", Qc = "Gæster", Xc = "boliger", eg = "Sidste minut", tg = "Lokation", og = "Rediger", lg = "Navn", ag = "Næste", ng = "", ig = "", rg = "{{count}} voksne", sg = "", cg = "", gg = "{{count}} babyer", dg = "", ug = "", bg = "{{count}} børn", _g = "", hg = "{{count}} gæst", fg = "{{count}} gæster", pg = "Telefonnummerets format er ikke gyldigt.", mg = "Modtag e-mailnotifikationer", vg = "Gem", yg = "Ingen lokationer fundet", kg = "Flere beskeder", wg = "Rejseliste", $g = "", xg = "valgfrit", jg = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: Ps,
  bedroomsNumbers_one: As,
  bedroomsNumbers_other: Ls,
  beds_zero: Ts,
  beds_one: qs,
  beds_other: Is,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: Bs,
  global_babies: Rs,
  global_calendarUpdated_toast: Fs,
  global_calendar_aMonth: Hs,
  global_calendar_exactDates: Ws,
  global_calendar_oneWeek: Vs,
  global_calendar_oneWeekend: Gs,
  global_calendar_plusMinusDay_zero: Us,
  global_calendar_plusMinusDay_one: Ks,
  global_calendar_plusMinusDay_other: Js,
  global_calendar_twoWeeks: Ys,
  global_cancel: Zs,
  global_children: Qs,
  global_dates: Xs,
  global_delete: ec,
  global_description: tc,
  global_destination: oc,
  global_done: lc,
  global_edit: ac,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: nc,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: ic,
  global_filter_bbq: rc,
  global_filter_bicycle: sc,
  global_filter_car: cc,
  global_filter_cat: gc,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: dc,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: uc,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: bc,
  global_filter_dog: _c,
  global_filter_dryer: hc,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: fc,
  global_filter_favorite: pc,
  global_filter_fireplace: mc,
  global_filter_flat: vc,
  global_filter_garden: yc,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: kc,
  global_filter_guestPointsMin: wc,
  global_filter_guestPointsMinMax: $c,
  global_filter_gym: xc,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: jc,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: zc,
  global_filter_isolated: Cc,
  global_filter_jacuzzi: Oc,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: Ec,
  global_filter_luxury: Sc,
  global_filter_mountains: Dc,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: Nc,
  global_filter_other: Mc,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: Pc,
  global_filter_playground: Ac,
  global_filter_primary: Lc,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: Tc,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: qc,
  global_filter_river: Ic,
  global_filter_seaside: Bc,
  global_filter_secondary: Rc,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Fc,
  global_filter_villages: Hc,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: Wc,
  global_filters: Vc,
  global_fixDates: Gc,
  global_flexDates_aMonth: Uc,
  global_flexDates_aWeekend: Kc,
  global_flexDates_oneWeek: Jc,
  global_flexDates_twoWeek: Yc,
  global_flexibleDates: Zc,
  global_guests: Qc,
  global_homes: Xc,
  global_lastMinute: eg,
  global_location: tg,
  global_modify: og,
  global_name: lg,
  global_next: ag,
  global_numberOfAdults_zero: ng,
  global_numberOfAdults_one: ig,
  global_numberOfAdults_other: rg,
  global_numberOfBabies_zero: sg,
  global_numberOfBabies_one: cg,
  global_numberOfBabies_other: gg,
  global_numberOfChildren_zero: dg,
  global_numberOfChildren_one: ug,
  global_numberOfChildren_other: bg,
  global_numberOfGuests_zero: _g,
  global_numberOfGuests_one: hg,
  global_numberOfGuests_other: fg,
  global_phoneNumber_notValid: pg,
  global_receiveEmailAlerts: mg,
  global_save: vg,
  global_searchBar_noLocationFound: yg,
  global_seeMore_link: kg,
  global_travelWishlist: wg,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: $g,
  optional: xg,
  "privacy-policy": "Privatpolitik"
}, zg = {
  "global.collection.ishomeeligible": "Er mit hjem kvalificeret?",
  "global.collection.joinnow": "Tilmeld dig nu",
  "global.collection.startfreetrial": "Start 14 dages gratis prøveperiode",
  "modal.collectionhp.eligibilitycheck.body": "Vores team vil omhyggeligt gennemgå din boligs detaljer, herunder billeder og faciliteter, for at vurdere, om den kvalificerer sig til HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "For at maksimere dine chancer for succes foreslår vi, at du angiver alle faciliteterne i dit hjem og bruger billeder af høj kvalitet, der fremhæver hjemmets bedste features.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Opdater min annonce",
  "modal.collectionhp.eligibilitycheck.title": "Er din bolig klar til at blive vurderet?",
  "page.collectionhp.benefitssection.body": "Bliv en del af vores luksuriøse boligbytte-klub for {{price}} om året og nyd godt af ubegrænsede boligbytter med Collection-medlemmer.<br/><br/>Få ro i sindet med beskyttelse mod annulleringer og dækning for potentielle skader i din bolig under dine boligbytter.<br/><br/>Hvis du ikke finder et boligbytte i løbet af det første år, får du det andet år gratis.",
  "page.collectionhp.benefitssection.body.fallback": "Bliv en del af vores luksuriøse boligbytte-klub og nyd godt af ubegrænsede boligbytter med Collection-medlemmer.<br/><br/>Få ro i sindet med beskyttelse mod annulleringer og dækning for potentielle skader i din bolig under dine boligbytter.<br/><br/>Hvis du ikke finder et boligbytte i løbet af det første år, får du det andet år gratis.",
  "page.collectionhp.benefitssection.cta": "Se alle fordele",
  "page.collectionhp.benefitssection.home.location": "Peters hjem i Dollar, Skotland",
  "page.collectionhp.benefitssection.title": "HomeExchange-fællesskab kun for medlemmer",
  "page.collectionhp.contact.subtitle": "Vores Medlemskabs-rådgivere kan besvare alle dine spørgsmål.",
  "page.collectionhp.contact.title": "Brug for mere information?",
  "page.collectionhp.eligibilitycheck.label": "Din anmodning om egnethed er ved at blive gennemgået.",
  "page.collectionhp.faq.question1.body": 'Adgang til HomeExchange Collection-fællesskabet er forbeholdt medlemmer for at sikre, at deres privatliv respekteres. Hver ejendom er blevet nøje udvalgt i henhold til særlige kriterier såsom design, beliggenhed og faciliteter. Med et Collection-medlemskab får du adgang til tusindvis af luksusboliger i over 85 lande (primært i USA, Europa og Asien). </br></br> Du kan se et udvalg af vores smukkeste ejendomme i verden på <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">denne side</a>.',
  "page.collectionhp.faq.question1.title": "Hvor kan jeg se alle tilgængelige boliger?",
  "page.collectionhp.faq.question2.content": 'Medlemskabet på HomeExchange Collection er {{price}} per år. Det giver dig adgang til ubegrænsede boligbytter med medlemmer i HomeExchange Collection-fællesskabet i 12 måneder, samtidig med at du kan arrangere boligbytter med medlemmer i det klassiske HomeExchange-fællesskab, hvis du har lyst. Vores løfte: Hvis du ikke arrangerer et boligbytte i løbet af dit medlemskabs første år, giver vi dig det andet år gratis. <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">Se betingelser.</a> Du drager også fordel af garantier i tilfælde af skader eller aflysninger samt eksklusive tjenester. Oplev alle <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">fordelene ved medlemskabet</a>.',
  "page.collectionhp.faq.question2.title": "Hvor meget koster det at blive en del af HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": 'Collection-medlemskabet dækker ejendomsskader op til 2.000.000 $. </br></br> For at læse mere om garantierne, du kan drage fordel af, når du er medlem, inviterer vi dig til at besøge <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">denne side</a>.',
  "page.collectionhp.faq.question3.title": "Hvad sker der, hvis mine gæster eller jeg forårsager skade?",
  "page.collectionhp.faq.question4.content": 'For at søge om at blive medlem af HomeExchange Collection, skal du udfylde ansøgningsformularen, som giver os mulighed for at evaluere dit hus eller lejlighed. Vi giver dig et svar inden for tre dage. Medlemskabsgebyret bliver kun opkrævet, hvis din ansøgning godkendes. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Start din ansøgning.</a>',
  "page.collectionhp.faq.question4.title": "Hvordan tilmelder jeg mig?",
  "page.collectionhp.faq.question5.content": 'Log ind på HomeExchange Collection med samme login og adgangskode, som du bruger på HomeExchange, og klik på "Bliv medlem". Hvis vi allerede har afgjort, at din bolig opfylder kriterierne til HomeExchange Collection, bliver du automatisk videresendt til betalingssiden. Hvis ikke, inviterer vi dig til at sende os en e-mail til <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a>, så vi kan gennemgå din ansøgning og svare tilbage inden for tre dage.',
  "page.collectionhp.faq.question5.title": "Jeg er allerede medlem af HomeExchange. Hvordan tilmelder jeg mig HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": "Hvis du har spørgsmål, der ikke er besvaret her, skal du besøge vores side med <linkFAQCollection><b><u>Ofte Stillede Spørgsmål</u></b></linkFAQCollection><b></b>",
  "page.collectionhp.faq.title": "Ofte Stillede Spørgsmål",
  "page.collectionhp.header.elligible.subtilte": "Du er inviteret til at blive en del af vores eksklusive boligbytte-fællesskab.",
  "page.collectionhp.header.elligible.title": "Din bolig er kvalificeret til Collection",
  "page.collectionhp.header.external.subtitle": "Bliv en del af et eksklusivt fællesskab bestående af ligesindede rejsende, der bytter deres utrolige hjem verden over.",
  "page.collectionhp.header.external.title": "Boliger, der inspirerer – rejser, du husker",
  "page.collectionhp.home1.location": "Paris, Frankrig",
  "page.collectionhp.home1.title": "Skøn designerlejlighed",
  "page.collectionhp.home2.location": "Altea, Spanien",
  "page.collectionhp.home2.title": "Middelhavsvilla",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Oase ved floden",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "Fra smuk arkitektur til uimodståelige lokationer - hver bolig er nøje udvalgt for deres enestående kvaliteter.",
  "page.collectionhp.homessection.title": "Tusindvis af byttemuligheder med luksusboliger",
  "page.collectionhp.howitwork.contact.cta": "Kontakt medlemssupport, hvis du har spørgsmål",
  "page.collectionhp.howitwork.elligible": "Din bolig er egnet til at blive en del af vores Collection-fællesskab.",
  "page.collectionhp.howitwork.notelligible": "Dit hjem er desværre ikke kvalificeret.",
  "page.collectionhp.howitwork.step1.body": "Sørg for, at din annonce er færdig og indeholder billeder af dit hjem, så vores team kan træffe en hurtig afgørelse.",
  "page.collectionhp.howitwork.step1.title": "Se, om du er kvalificeret",
  "page.collectionhp.howitwork.step2.body": "Hvis dit hjem kvalificerer sig, sender vi dig en invitation til at tilmelde dig. For at aktivere dit medlemskab skal du blot klikke på linket i invitationen eller besøge medlemssiden på din konto.",
  "page.collectionhp.howitwork.step2.title": "Bliv et Collection-medlem",
  "page.collectionhp.howitwork.step3.body": "Når du har aktiveret dit medlemskab, kan du begynde at arrangere ubegrænsede boligbytter med Collection-boliger og låse op for ekstra fordele, der følger med dit medlemskab.",
  "page.collectionhp.howitwork.step3.title": "Nyd dit medlemskab",
  "page.collectionhp.howitwork.title": "Sådan fungerer det",
  "page.collectionhp.keybenefit1.body": "Alle vores hjem er blevet nøje udvalgt af vores team baseret på deres design, lokation og faciliteter. Alle hjem og medlemmer er verificeret for at garantere et sikkert og pålideligt fællesskab.",
  "page.collectionhp.keybenefit1.title": "Verificeret udvalg af boliger",
  "page.collectionhp.keybenefit2.body": "Du får ejendomsskadebeskyttelse på op til 2.000.000 $ og dækning på op til 350 $ per nat i tilfælde af annulleringer eller uforudsete begivenheder.",
  "page.collectionhp.keybenefit2.title": "Uovertrufne garantier",
  "page.collectionhp.keybenefit3.body": "Du modtager personlig support, så dine boligbytter forløber lettere. Medlemskabet inkluderer desuden gratis professionel forbedring af dine annoncebilleder.",
  "page.collectionhp.keybenefit3.title": "Personlig support",
  "page.collectionhp.testimonie1.body": "Vi har fire børn, så hver gang vi skulle rejse og bo på hotel, var vi nødt til at booke tre værelser. Så hørte vi om HomeExchange, og siden vi tilmeldte os, har vi besøgt fantastiske steder. Vi har været i Dubai, på skitur tre gange i Big Sky, Tahoe og i Colorado.",
  "page.collectionhp.testimonie1.label": "Miglino-familien - Californien",
  "page.collectionhp.testimonie2.body": "HomeExchange er en unik måde at rejse på, da det giver dig mulighed for at opleve en destination, men du får også muligheden for at skabe forbindelser og holde kontakten med familier, længe efter at boligbyttet er sluttet.",
  "page.collectionhp.testimonie2.label": "Eggleton-familien - Florida",
  "page.collectionhp.testimonie3.body": "Jeg husker engang i New York, da børnene stadig var meget små, og der var en rutsjebane i vores boligbytte-lejlighed samt al legetøjet, der tilhørte den anden families to sønner; vores drenge var lykkelige! Vores vært fortalte os også om en babysitter, de ofte benyttede sig af, så vi kunne tage ud og opleve New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Paris, Frankrig",
  "page.collectionhp.testimonies.cta": "Mød vores medlemmer",
  "page.collectionhp.testimonies.title": "Medlemmers historier",
  "page.collectionhp.whatis.body": "<Text>Vi mener, at luksus er noget helt personligt. For nogle er det en afsondret oase omgivet af smukke, naturlige udsigter.</Text><Text>For andre er det et arkitektonisk mesterværk, der ligger midt i hjertet af verdens mest livlige byer.</Text>",
  "page.collectionhp.whatis.title": "Hvad er en Collection-bolig?"
}, Cg = "Studio", Og = "{{count}} schlafzimmer", Eg = "{{count}} schlafzimmer", Sg = "", Dg = "{{count}} Bett", Ng = "{{count}} Betten", Mg = "Erwachsene", Pg = "Babys", Ag = "Ihr Kalender wurde aktualisiert.", Lg = "Ein Monat", Tg = "Genaue Daten", qg = "Eine Woche", Ig = "Ein Wochenende", Bg = "", Rg = "± {{count}} Tag", Fg = "± {{count}} Tage", Hg = "Zwei Wochen", Wg = "Abbrechen", Vg = "Kinder", Gg = "Daten", Ug = "Löschen", Kg = "Beschreibung", Jg = "Reiseziel", Yg = "Fertig!", Zg = "Bearbeiten", Qg = "Jede Tauschanfrage", Xg = "Badewanne", ed = "Grill", td = "Fahrrad", od = "Auto", ld = "Katze", ad = "Stadt", nd = "Auf dem Land", id = "Geschirrspüler", rd = "Hund", sd = "Trockner", cd = "Aufzug", gd = "Lieblingshäuser", dd = "Kamin", ud = "Apartment", bd = "Privater Garten", _d = "weniger als {{max}} GP", hd = "von {{min}} GP", fd = "Zwischen {{min}} und {{max}} GP", pd = "Privater Fitnessraum", md = "Haus", vd = "Insel", yd = "Abgelegen", kd = "Whirlpool", wd = "See", $d = "Häuser der Collection", xd = "Berge", jd = "{{count}} Badezimmer", zd = "Andere Tiere", Cd = "Klavier", Od = "Spielplatz", Ed = "Hauptwohnung", Sd = "Gegenseitiger Austausch", Dd = "Umgekehrte Suche", Nd = "Fluss", Md = "An der Küste", Pd = "Zweitwohnung", Ad = "Fernseher", Ld = "Dorf", Td = "WLAN", qd = "Filter", Id = "Feste Daten", Bd = "Eine Woche im {{date}}", Rd = "Ein Wochenende im {{date}}", Fd = "Eine Woche im {{date}}", Hd = "Zwei Wochen im {{date}}", Wd = "Flexible Daten", Vd = "Gäste", Gd = "Unterkünfte", Ud = "Last Minute", Kd = "Ort", Jd = "Ändern", Yd = "Name", Zd = "Weiter", Qd = "", Xd = "{{count}} Erwachsener", eu = "{{count}} Erwachsene", tu = "", ou = "{{count}} Baby", lu = "{{count}} Babys", au = "", nu = "{{count}} Kind", iu = "{{count}} Kinder", ru = "", su = "{{count}} Gast", cu = "{{count}} Gäste", gu = "Das Format der Telefonnummer ist ungültig.", du = "Benachrichtigungen per E-Mail erhalten", uu = "Speichern", bu = "Kein Reiseziel gefunden", _u = "Mehr anzeigen", hu = "Reiseprojekte", fu = "", pu = "optional", mu = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Cg,
  bedroomsNumbers_one: Og,
  bedroomsNumbers_other: Eg,
  beds_zero: Sg,
  beds_one: Dg,
  beds_other: Ng,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: Mg,
  global_babies: Pg,
  global_calendarUpdated_toast: Ag,
  global_calendar_aMonth: Lg,
  global_calendar_exactDates: Tg,
  global_calendar_oneWeek: qg,
  global_calendar_oneWeekend: Ig,
  global_calendar_plusMinusDay_zero: Bg,
  global_calendar_plusMinusDay_one: Rg,
  global_calendar_plusMinusDay_other: Fg,
  global_calendar_twoWeeks: Hg,
  global_cancel: Wg,
  global_children: Vg,
  global_dates: Gg,
  global_delete: Ug,
  global_description: Kg,
  global_destination: Jg,
  global_done: Yg,
  global_edit: Zg,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: Qg,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: Xg,
  global_filter_bbq: ed,
  global_filter_bicycle: td,
  global_filter_car: od,
  global_filter_cat: ld,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: ad,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: nd,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: id,
  global_filter_dog: rd,
  global_filter_dryer: sd,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: cd,
  global_filter_favorite: gd,
  global_filter_fireplace: dd,
  global_filter_flat: ud,
  global_filter_garden: bd,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: _d,
  global_filter_guestPointsMin: hd,
  global_filter_guestPointsMinMax: fd,
  global_filter_gym: pd,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: md,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: vd,
  global_filter_isolated: yd,
  global_filter_jacuzzi: kd,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: wd,
  global_filter_luxury: $d,
  global_filter_mountains: xd,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: jd,
  global_filter_other: zd,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: Cd,
  global_filter_playground: Od,
  global_filter_primary: Ed,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: Sd,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: Dd,
  global_filter_river: Nd,
  global_filter_seaside: Md,
  global_filter_secondary: Pd,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: Ad,
  global_filter_villages: Ld,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: Td,
  global_filters: qd,
  global_fixDates: Id,
  global_flexDates_aMonth: Bd,
  global_flexDates_aWeekend: Rd,
  global_flexDates_oneWeek: Fd,
  global_flexDates_twoWeek: Hd,
  global_flexibleDates: Wd,
  global_guests: Vd,
  global_homes: Gd,
  global_lastMinute: Ud,
  global_location: Kd,
  global_modify: Jd,
  global_name: Yd,
  global_next: Zd,
  global_numberOfAdults_zero: Qd,
  global_numberOfAdults_one: Xd,
  global_numberOfAdults_other: eu,
  global_numberOfBabies_zero: tu,
  global_numberOfBabies_one: ou,
  global_numberOfBabies_other: lu,
  global_numberOfChildren_zero: au,
  global_numberOfChildren_one: nu,
  global_numberOfChildren_other: iu,
  global_numberOfGuests_zero: ru,
  global_numberOfGuests_one: su,
  global_numberOfGuests_other: cu,
  global_phoneNumber_notValid: gu,
  global_receiveEmailAlerts: du,
  global_save: uu,
  global_searchBar_noLocationFound: bu,
  global_seeMore_link: _u,
  global_travelWishlist: hu,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: fu,
  optional: pu,
  "privacy-policy": "Datenschutz"
}, vu = {
  "global.collection.ishomeeligible": "Ist meine Unterkunft geeignet?",
  "global.collection.joinnow": "Jetzt beitreten",
  "global.collection.startfreetrial": "Kostenlosen 14-Tage-Probezeitraum starten",
  "modal.collectionhp.eligibilitycheck.body": "Unser Team wird die Details Ihrer Unterkunft, einschließlich der Fotos und der Ausstattung, sorgfältig prüfen, um zu entscheiden, ob sie für HomeExchange Collection infrage kommt.",
  "modal.collectionhp.eligibilitycheck.callout.body": "Um Ihre Erfolgsaussichten zu maximieren, empfehlen wir Ihnen, alle Ausstattungsmerkmale Ihrer Unterkunft aufzulisten und qualitativ hochwertige Fotos einzureichen, die die Highlights zeigen.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Unterkunft aktualisieren",
  "modal.collectionhp.eligibilitycheck.title": "Ist Ihre Unterkunft bereit für unsere Prüfung?",
  "page.collectionhp.benefitssection.body": "Werden Sie Teil unseres Luxus-Haustausch-Clubs für {{price}} pro Jahr und genießen Sie unbegrenzt viele Tausche mit Collection Mitgliedern.<br/><br/>Seien Sie sorgenfrei mit unserem Schutz gegen Stornierungen und der Deckung von eventuellen Schäden an Ihrer Unterkunft während des Tauschs.<br/><br/>Und sollten Sie im ersten Jahr keinen Tausch finden, erhalten Sie ein zweites Jahr kostenlos.",
  "page.collectionhp.benefitssection.body.fallback": "Werden Sie Teil unseres Luxus-Haustausch-Clubs und genießen Sie unbegrenzt viele Tausche mit Collection Mitgliedern.<br/><br/>Seien Sie sorgenfrei mit unserem Schutz gegen Stornierungen und der Deckung von eventuellen Schäden an Ihrer Unterkunft während des Tauschs.<br/><br/>Und sollten Sie im ersten Jahr keinen Tausch finden, erhalten Sie ein zweites Jahr kostenlos.",
  "page.collectionhp.benefitssection.cta": "Alle Vorteile ansehen",
  "page.collectionhp.benefitssection.home.location": "Peters Unterkunft in Dollar, Schottland",
  "page.collectionhp.benefitssection.title": "Haustausch-Community nur für Mitglieder",
  "page.collectionhp.contact.subtitle": "Unsere Mitglieder-Berater:innen stehen Ihnen bei allen Fragen unterstützend zur Seite.",
  "page.collectionhp.contact.title": "Benötigen Sie weitere Information?",
  "page.collectionhp.eligibilitycheck.label": "Ihr Antrag auf Eignung wird geprüft.",
  "page.collectionhp.faq.question1.body": 'Der Zugang zur HomeExchange Collection Community ist den Mitgliedern vorbehalten, um zu gewährleisten, dass die Privatsphäre respektiert wird. Jede Immobilie wurde sorgfältig anhand von bestimmten Kriterien wie Design, Lage und Ausstattung ausgewählt. Mit einer Collection Mitgliedschaft haben Sie Zugang zu Tausenden von Luxusimmobilien in über 85 Ländern (hauptsächlich in den Vereinigten Staaten, Europa und Asien). </br></br>Eine Auswahl unserer schönsten Immobilien weltweit finden Sie <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">hier</a>.',
  "page.collectionhp.faq.question1.title": "Wo sehe ich alle verfügbaren Unterkünfte?",
  "page.collectionhp.faq.question2.content": 'Die HomeExchange Collection Mitgliedschaft kostet {{price}} pro Jahr. Sie ermöglicht Ihnen zwölf Monate lang Zugang zu unbegrenzt vielen Tauschen mit Mitgliedern der HomeExchange Collection Community und ebenso mit Mitgliedern der HomeExchange Classic Community. Unser Versprechen: Wenn Sie im ersten Jahr Ihrer Mitgliedschaft keinen Tausch abschließen, schenken wir Ihnen das zweite Jahr unter <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">diesen Bedingungen</a>. Sie profitieren außerdem von Garantien im Falle von Schäden oder Stornierungen sowie exklusiven Services. Entdecken Sie alle <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">Vorteile der Mitgliedschaft</a> im Detail.',
  "page.collectionhp.faq.question2.title": "Wie viel kostet die Mitgliedschaft bei HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": 'Die Collection Mitgliedschaft deckt Sachschäden von bis zu 2.000.000 $ ab. </br></br> Um mehr über die Garantien zu erfahren, von denen Sie als Mitglied profitieren und wie diese funktionieren, besuchen Sie <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">diese Seite</a>.',
  "page.collectionhp.faq.question3.title": "Was passiert, wenn meine Gäste oder ich einen Schaden verursachen?",
  "page.collectionhp.faq.question4.content": 'Um Teil von HomeExchange Collection zu werden, füllen Sie bitte das Bewerbungsformular aus, damit wir Ihre Unterkunft beurteilen können. Wir geben Ihnen innerhalb von drei Tagen eine Rückmeldung. Die Mitgliedschaftsgebühr wird nur erhoben, wenn Ihre Bewerbung angenommen wurde. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Starten Sie jetzt Ihre Bewerbung zur Mitgliedschaft.</a>',
  "page.collectionhp.faq.question4.title": "Wie werde ich Mitglied?",
  "page.collectionhp.faq.question5.content": 'Loggen Sie sich bei HomeExchange Collection über den gleichen Login und mit demselben Passwort wie bei HomeExchange ein und klicken Sie auf „Mitglied werden“. Wenn wir bereits beurteilt haben, dass Ihre Immobilie die Auswahlkriterien für HomeExchange Collection erfüllt, werden Sie automatisch auf die Zahlungsseite weitergeleitet. Falls nicht, bitten wir Sie, uns eine E-Mail an <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange</a> zu schicken, damit wir Ihre Bewerbung prüfen können und Sie innerhalb von drei Tagen Rückmeldung erhalten.',
  "page.collectionhp.faq.question5.title": "Ich bin bereits ein Mitglied von HomeExchange. Wie kann ich HomeExchange Collection beitreten?",
  "page.collectionhp.faq.subtitle": "Sollten Sie Fragen haben, die hier nicht aufgeführt sind, besuchen Sie bitte unseren <linkFAQCollection><b><u>FAQ-Bereich</u></b></linkFAQCollection><b></b>.",
  "page.collectionhp.faq.title": "Häufig gestellte Fragen",
  "page.collectionhp.header.elligible.subtilte": "Sie sind eingeladen, unserer exklusiven Haustausch-Community beizutreten.",
  "page.collectionhp.header.elligible.title": "Ihre Unterkunft ist für Collection geeignet",
  "page.collectionhp.header.external.subtitle": "Werden Sie Teil einer exklusiven Community gleichgesinnter Reisender, die ihre bemerkenswerten Unterkünfte weltweit tauschen.",
  "page.collectionhp.header.external.title": "Inspirierende Häuser, unvergessliche Reisen",
  "page.collectionhp.home1.location": "Paris, Frankreich",
  "page.collectionhp.home1.title": "Schicke Designerwohnung",
  "page.collectionhp.home2.location": "Altea, Spanien",
  "page.collectionhp.home2.title": "Mediterranes Haus",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Rückzugsort am Flussufer",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "Von atemberaubender Architektur bis hin zu erstklassigen Standorten wird jede Unterkunft aufgrund der außergewöhnlichen Qualitäten von uns persönlich ausgesucht.",
  "page.collectionhp.homessection.title": "Tausende Tauschmöglichkeiten mit Luxusimmobilien",
  "page.collectionhp.howitwork.contact.cta": "Wenden Sie sich bei Fragen an unseren Kundenservice",
  "page.collectionhp.howitwork.elligible": "Ihre Unterkunft ist für die Mitgliedschaft in unserer Collection Community geeignet.",
  "page.collectionhp.howitwork.notelligible": "Leider ist Ihre Unterkunft nicht geeignet.",
  "page.collectionhp.howitwork.step1.body": "Stellen Sie sicher, dass Ihre Anzeige vollständig ist, einschließlich Fotos Ihrer Unterkunft, damit unser Team Ihnen schnell Rückmeldung geben kann.",
  "page.collectionhp.howitwork.step1.title": "Eignung prüfen",
  "page.collectionhp.howitwork.step2.body": "Wenn Ihre Unterkunft geeignet ist, erhalten Sie eine Einladung zum Beitritt. Um Ihre Mitgliedschaft zu aktivieren, klicken Sie einfach auf den Link in der Einladung oder besuchen Sie den Mitgliedschaftsbereich in Ihrem Konto.",
  "page.collectionhp.howitwork.step2.title": "Collection Mitglied werden",
  "page.collectionhp.howitwork.step3.body": "Sobald Sie Ihre Mitgliedschaft aktiviert haben, können Sie unbegrenzt viele Tausche mit Collection Unterkünften organisieren und erhalten Zugriff auf die zusätzlichen Vorteile Ihrer Mitgliedschaft.",
  "page.collectionhp.howitwork.step3.title": "Mitgliedschaft genießen",
  "page.collectionhp.howitwork.title": "So funktioniert's",
  "page.collectionhp.keybenefit1.body": "Unsere Unterkünfte wurden von unserem Team sorgfältig auf Grundlage von Design, Lage und Ausstattung ausgewählt. Alle Unterkünfte und Mitglieder sind verifiziert, um eine sichere und vertrauenswürdige Community zu gewährleisten.",
  "page.collectionhp.keybenefit1.title": "Geprüfte Auswahl an Unterkünften",
  "page.collectionhp.keybenefit2.body": "Sie erhalten einen Sachschadenschutz von bis zu 2.000.000 $ und die Deckung von bis zu 350 $ pro Nacht im Falle von Stornierungen oder unvorhersehbaren Ereignissen.",
  "page.collectionhp.keybenefit2.title": "Unvergleichbare Garantien",
  "page.collectionhp.keybenefit3.body": "Sie erhalten persönliche Unterstützung, um einen reibungslosen Ablauf Ihres Tauschs zu gewährleisten. Zusätzlich beinhaltet die Mitgliedschaft die kostenlose, professionelle Optimierung Ihrer Anzeigenfotos.",
  "page.collectionhp.keybenefit3.title": "Persönliche Unterstützung",
  "page.collectionhp.testimonie1.body": "Wir haben vier Kinder und jedes Mal, wenn wir auf Reisen in Hotels übernachtet haben, mussten wir drei Zimmer nehmen. Dann haben wir von HomeExchange gehört und seitdem wir angemeldet sind, haben wir fantastische Orte bereist. Wir waren in Dubai und sind dreimal Skifahren gewesen in Big Sky, Tahoe und Colorado.",
  "page.collectionhp.testimonie1.label": "Familie Miglino – Kalifornien",
  "page.collectionhp.testimonie2.body": "HomeExchange ist eine einzigartige Art des Reisens, bei der man nicht nur ein Reiseziel erkunden kann, sondern auch die Möglichkeit hat, Kontakte zu knüpfen und auch nach dem Tausch mit den Familien in Verbindung zu bleiben.",
  "page.collectionhp.testimonie2.label": "Familie Eggleton – Florida",
  "page.collectionhp.testimonie3.body": "Ich erinnere mich, dass wir einmal in New York waren, als die Kinder noch sehr klein waren, und in der Tauschwohnung gab es eine Rutsche sowie Spielsachen der beiden Jungs der anderen Familie – unsere Jungs waren begeistert! Die Gastgeber haben uns den Kontakt eines Babysitters dagelassen, den sie selbst regelmäßig nutzen, sodass wir in New York ausgehen konnten.",
  "page.collectionhp.testimonie3.label": "Laetitia – Paris, Frankreich",
  "page.collectionhp.testimonies.cta": "Mitglieder kennenlernen",
  "page.collectionhp.testimonies.title": "Mitgliederbewertungen",
  "page.collectionhp.whatis.body": "<Text>Wir denken, dass Luxus etwas sehr Persönliches ist. Für die einen ist es ein abgelegener Rückzugsort, umgeben von einer atemberaubenden Natur. Für andere ist es ein architektonisches Meisterwerk im Herzen der pulsierendsten Städte der Welt.</Text><Text>Unsere Collection spiegelt diese bemerkenswerte Vielfalt wider. Sie ist so einzigartig wie unsere Community und doch haben alle Unterkünfte eines gemeinsam: Sie sorgen beim ersten Eintreten für einen magischen Moment.</Text>",
  "page.collectionhp.whatis.title": "Was ist eine Collection Unterkunft?"
}, yu = "Studio", ku = "{{count}} bedroom", wu = "{{count}} bedrooms", $u = "", xu = "{{count}} bed", ju = "{{count}} beds", zu = "Adults", Cu = "Babies", Ou = "Your calendar has been updated.", Eu = "A month", Su = "Exact dates", Du = "One week", Nu = "One weekend", Mu = "", Pu = "± {{count}} day", Au = "± {{count}} days", Lu = "Two weeks", Tu = "Cancel", qu = "Children", Iu = "Dates", Bu = "Delete", Ru = "Description", Fu = "Destination", Hu = "Done!", Wu = "Edit", Vu = "Any type of exchange", Gu = "Bathtub", Uu = "BBQ", Ku = "Bicycle", Ju = "Car", Yu = "Cat", Zu = "City", Qu = "Countryside", Xu = "Dishwasher", eb = "Dog", tb = "Dryer", ob = "Elevator", lb = "Favorite homes", ab = "Fireplace", nb = "Apartment", ib = "Private backyard", rb = "less than {{max}} GP", sb = "from {{min}} GP", cb = "Between {{min}} and {{max}} GP", gb = "Private gym", db = "House", ub = "Island", bb = "Isolated", _b = "Jacuzzi", hb = "Lake", fb = "Collection homes", pb = "Mountain", mb = "{{count}} bathrooms", vb = "Other animals", yb = "Piano", kb = "Kid's playground", wb = "Primary", $b = "Reciprocal exchange", xb = "Reverse search", jb = "River", zb = "Coastal", Cb = "Secondary", Ob = "TV", Eb = "Village", Sb = "WiFi", Db = "Filters", Nb = "Fixed dates", Mb = "A month in {{date}}", Pb = "A Week-end in {{date}}", Ab = "One week in {{date}}", Lb = "Two weeks in {{date}}", Tb = "Flexible dates", qb = "Guests", Ib = "homes", Bb = "Last minute", Rb = "Location", Fb = "Modify", Hb = "Name", Wb = "Next", Vb = "", Gb = "{{count}} adult", Ub = "{{count}} adults", Kb = "", Jb = "{{count}} baby", Yb = "{{count}} babies", Zb = "", Qb = "{{count}} child", Xb = "{{count}} children", e_ = "{{count}} guest", t_ = "{{count}} guest", o_ = "{{count}} guests", l_ = "The phone number format is not valid", a_ = "Receive email alerts", n_ = "Save", i_ = "No locations found", r_ = "See more", s_ = "Travel wishlist", c_ = "No result", g_ = "optional", d_ = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: yu,
  bedroomsNumbers_one: ku,
  bedroomsNumbers_other: wu,
  beds_zero: $u,
  beds_one: xu,
  beds_other: ju,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: zu,
  global_babies: Cu,
  global_calendarUpdated_toast: Ou,
  global_calendar_aMonth: Eu,
  global_calendar_exactDates: Su,
  global_calendar_oneWeek: Du,
  global_calendar_oneWeekend: Nu,
  global_calendar_plusMinusDay_zero: Mu,
  global_calendar_plusMinusDay_one: Pu,
  global_calendar_plusMinusDay_other: Au,
  global_calendar_twoWeeks: Lu,
  global_cancel: Tu,
  global_children: qu,
  global_dates: Iu,
  global_delete: Bu,
  global_description: Ru,
  global_destination: Fu,
  global_done: Hu,
  global_edit: Wu,
  "global_filter_a-c": "A/C",
  global_filter_available: Vu,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: Gu,
  global_filter_bbq: Uu,
  global_filter_bicycle: Ku,
  global_filter_car: Ju,
  global_filter_cat: Yu,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: Zu,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: Qu,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: Xu,
  global_filter_dog: eb,
  global_filter_dryer: tb,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: ob,
  global_filter_favorite: lb,
  global_filter_fireplace: ab,
  global_filter_flat: nb,
  global_filter_garden: ib,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: rb,
  global_filter_guestPointsMin: sb,
  global_filter_guestPointsMinMax: cb,
  global_filter_gym: gb,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: db,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: ub,
  global_filter_isolated: bb,
  global_filter_jacuzzi: _b,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: hb,
  global_filter_luxury: fb,
  global_filter_mountains: pb,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: mb,
  global_filter_other: vb,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: yb,
  global_filter_playground: kb,
  global_filter_primary: wb,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: $b,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: xb,
  global_filter_river: jb,
  global_filter_seaside: zb,
  global_filter_secondary: Cb,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Ob,
  global_filter_villages: Eb,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: Sb,
  global_filters: Db,
  global_fixDates: Nb,
  global_flexDates_aMonth: Mb,
  global_flexDates_aWeekend: Pb,
  global_flexDates_oneWeek: Ab,
  global_flexDates_twoWeek: Lb,
  global_flexibleDates: Tb,
  global_guests: qb,
  global_homes: Ib,
  global_lastMinute: Bb,
  global_location: Rb,
  global_modify: Fb,
  global_name: Hb,
  global_next: Wb,
  global_numberOfAdults_zero: Vb,
  global_numberOfAdults_one: Gb,
  global_numberOfAdults_other: Ub,
  global_numberOfBabies_zero: Kb,
  global_numberOfBabies_one: Jb,
  global_numberOfBabies_other: Yb,
  global_numberOfChildren_zero: Zb,
  global_numberOfChildren_one: Qb,
  global_numberOfChildren_other: Xb,
  global_numberOfGuests_zero: e_,
  global_numberOfGuests_one: t_,
  global_numberOfGuests_other: o_,
  global_phoneNumber_notValid: l_,
  global_receiveEmailAlerts: a_,
  global_save: n_,
  global_searchBar_noLocationFound: i_,
  global_seeMore_link: r_,
  global_travelWishlist: s_,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: c_,
  optional: g_,
  "privacy-policy": "Privacy Policy"
}, u_ = {
  "global.collection.ishomeeligible": "Is my home eligible?",
  "global.collection.joinnow": "Join now",
  "global.collection.startfreetrial": "Start 14-day free trial",
  "modal.collectionhp.eligibilitycheck.body": "Our team will carefully review your home’s details, including photos and amenities, to determine if it’s eligible for HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "To maximize your chances of success, we’d suggest listing all your home’s amenities and submitting high-quality photos that highlight its best features.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Update my listing",
  "modal.collectionhp.eligibilitycheck.title": "Is your home ready for review?",
  "page.collectionhp.benefitssection.body": "Join our luxury home swap club for {{price}} a year and enjoy unlimited exchanges with Collection Members.<br/><br/>Enjoy peace of mind with protection against cancellations and coverage for any potential home damages during your exchanges.<br/><br/>Plus, if you don't find an exchange in the first year, you get a second year free.",
  "page.collectionhp.benefitssection.body.fallback": "Join our luxury home swap club and enjoy unlimited exchanges with Collection Members.<br/><br/>Enjoy peace of mind with protection against cancellations and coverage for any potential home damages during your exchanges.<br/><br/>Plus, if you don't find an exchange in the first year, you get a second year free.",
  "page.collectionhp.benefitssection.cta": "See all benefits",
  "page.collectionhp.benefitssection.home.location": "Peter’s home in Dollar, Scotland",
  "page.collectionhp.benefitssection.title": "Member-only Home Exchange Community",
  "page.collectionhp.contact.subtitle": "Our Membership Advisors are available to answer any questions you may have.",
  "page.collectionhp.contact.title": "Need more information?",
  "page.collectionhp.eligibilitycheck.label": "Your eligibility request is under review.",
  "page.collectionhp.faq.question1.body": 'Access to HomeExchange Collection community is reserved for members to ensure that their privacy is fully respected. Each property has been carefully selected according to specific criteria such as design, location, and amenities. With a Collection membership you have access to thousands of luxury homes located in over 85 countries (mainly throughout the United States, Europe, and Asia)\u2028</br></br>\u2028You can view a selection of our most beautiful properties around the world on <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">page</a>.',
  "page.collectionhp.faq.question1.title": "Where can I see all available homes?",
  "page.collectionhp.faq.question2.content": `Membership to HomeExchange Collection is {{price}} per year. It gives you access to unlimited exchanges with members of the HomeExchange Collection community for twelve months, while allowing you to exchange with members of the classic HomeExchange community if you wish.\u2028\u2028Our promise: If you can' t finalize an exchange in your first year of membership, we'll give you a second year for free, <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">see conditions.</a>\u2028\u2028You also benefit from guarantees in case of damage or cancellation, as well as exclusive services. Discover all the <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">advantages of membership</a> in detail.`,
  "page.collectionhp.faq.question2.title": "How much does it cost to join HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": `The Collection membership covers property damage up to $2,000,000. \u2028</br></br>\u2028To know more about the guarantees you'll benefit when being a member and how they work, we invite you to check out <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">this page</a>.`,
  "page.collectionhp.faq.question3.title": "What happens if my guests or I cause damage?",
  "page.collectionhp.faq.question4.content": 'To apply to join the HomeExchange Collection, complete the application form which will allow us to evaluate your home or apartment. We will give you an answer within three days. The membership fee will only be charged if your application is accepted. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Start your membership application.</a>',
  "page.collectionhp.faq.question4.title": "How do I join?",
  "page.collectionhp.faq.question5.content": 'Log in to HomeExchange Collection with the same login and password as for HomeExchange and click on "Become a member". If we have already identified that your property meets the selection criteria for HomeExchange Collection, you will automatically be redirected to the payment page. If not, we invite you to send us an email at <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a> so that we can review your application and respond within three days.',
  "page.collectionhp.faq.question5.title": "I am already a member of HomeExchange. How do I join HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": `If you have any questions that aren't here, please visit our <a href="https://homeexchangecollection.zendesk.com/hc/en-us"> <b><u>FAQ</u></b></a> page.`,
  "page.collectionhp.faq.title": "Frequently Asked Questions",
  "page.collectionhp.header.elligible.subtilte": "You are invited to join our exclusive home exchange community.",
  "page.collectionhp.header.elligible.title": "Your home is eligible for Collection",
  "page.collectionhp.header.external.subtitle": "Join an exclusive community of like-minded travelers exchanging their remarkable homes worldwide.",
  "page.collectionhp.header.external.title": "Homes That Inspire, Travels You’ll Remember",
  "page.collectionhp.home1.location": "Paris, France",
  "page.collectionhp.home1.title": "Lovely designer apartment",
  "page.collectionhp.home2.location": "Altea, Spain",
  "page.collectionhp.home2.title": "Mediterranean House",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Riverfront Retreat",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "From breathtaking architecture to unbeatable locations, each home is handpicked for its exceptional qualities.",
  "page.collectionhp.homessection.title": "Thousands of swap opportunities with luxury properties",
  "page.collectionhp.howitwork.contact.cta": "Contact member support for any question",
  "page.collectionhp.howitwork.elligible": "Your home is eligible to join our Collection community.",
  "page.collectionhp.howitwork.notelligible": "Unfortunately, your home is not eligible.",
  "page.collectionhp.howitwork.step1.body": "Ensure your listing is complete, including photos of your home, so our team can provide a prompt response.",
  "page.collectionhp.howitwork.step1.title": "Check your eligibility",
  "page.collectionhp.howitwork.step2.body": "If your home is eligible, you’ll receive an invitation to join. To activate your membership, simply click the link in the invitation or visit the membership page in your account.",
  "page.collectionhp.howitwork.step2.title": "Become a Collection Member",
  "page.collectionhp.howitwork.step3.body": "Once you activate your membership, you can begin organizing unlimited exchanges with Collection homes and unlock the additional benefits that come with your membership.",
  "page.collectionhp.howitwork.step3.title": "Enjoy your Membership",
  "page.collectionhp.howitwork.title": "How it works",
  "page.collectionhp.keybenefit1.body": "All our homes have been carefully selected by our team based on their design, location, and amenities. All homes and members are verified to ensure a secure and trusted community.",
  "page.collectionhp.keybenefit1.title": "Verified selection of homes",
  "page.collectionhp.keybenefit2.body": "You receive property damage protection up to $2,000,000 and coverage of up to $350 per night in case of cancellations or unforeseen events. ",
  "page.collectionhp.keybenefit2.title": "Unmatched Guarantees",
  "page.collectionhp.keybenefit3.body": "You receive personalized support ensuring smooth facilitation of your exchanges. Additionally, the membership includes free professional enhancement of your listing pictures. ",
  "page.collectionhp.keybenefit3.title": "Personalized support",
  "page.collectionhp.testimonie1.body": "We have four kids so every time we would travel and stay a hotel, we ended up having to get three rooms. Then we found out about HomeExchange and ever since we've joined, we've gone to amazing places. We've gone to Dubai, went skiing three times in Big Sky, Tahoe and Colorado.",
  "page.collectionhp.testimonie1.label": "The Miglino Family - California",
  "page.collectionhp.testimonie2.body": "HomeExchange is a unique type of travel in that it allows you to experience a destination, but you also have the ability to create connections and keep in contact with families well after the exchange has ended.",
  "page.collectionhp.testimonie2.label": "The Eggleton Family - Florida",
  "page.collectionhp.testimonie3.body": "I remember once in New York, the kids were still very young, and there was a slide in our exchange apartment, as well as all of the toys of the two boys of the other family; our boyes were delighted! Our host shared the name of a babysitter they use regularly, so we were able to go out in New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Paris, France",
  "page.collectionhp.testimonies.cta": "Meet our members",
  "page.collectionhp.testimonies.title": "Member Testimonies",
  "page.collectionhp.whatis.body": "<Text>We believe luxury is deeply personal. For some, it’s a secluded retreat surrounded by breathtaking natural views. For others, it’s an architectural masterpiece nestled in the heart of the world’s most vibrant cities.</Text><Text>Our Collection captures this remarkable diversity. It's as unique as our community, yet all the homes share one defining quality: they leave you in awe the moment you step inside.</Text>",
  "page.collectionhp.whatis.title": "What is a Collection home?"
}, b_ = "Estudio", __ = "{{count}} dormitorio", h_ = "{{count}} dormitorios", f_ = "", p_ = "{{count}} cama", m_ = "{{count}} camas", v_ = "", y_ = "", k_ = "Tu calendario ha sido actualizado.", w_ = "Un mes", $_ = "Fechas exactas", x_ = "Una semana", j_ = "Un fin de semana", z_ = "", C_ = "± {{count}} día", O_ = "± {{count}} días", E_ = "Dos semanas", S_ = "Cancelar", D_ = "", N_ = "Fechas", M_ = "Eliminar", P_ = "Descripción", A_ = "Destino", L_ = "¡Listo!", T_ = "Editar", q_ = "Cualquier tipo de intercambio", I_ = "Bañera", B_ = "Barbacoa", R_ = "Bicicleta", F_ = "Coche", H_ = "Gato", W_ = "Ciudad", V_ = "Campo", G_ = "Lavavajillas", U_ = "Perro", K_ = "Secadora", J_ = "Ascensor", Y_ = "Casas favoritas", Z_ = "Chimenea", Q_ = "Piso", X_ = "Patio privado", eh = "", th = "", oh = "", lh = "", ah = "Casa", nh = "Isla", ih = "Aislado", rh = "Jacuzzi", sh = "Lagos", ch = "Casas Collection", gh = "", dh = "{{count}} baños", uh = "Otros animales", bh = "Piano", _h = "Columpios", hh = "Principal", fh = "Intercambio recíproco", ph = "Búsqueda inversa", mh = "Río", vh = "En la costa", yh = "Secundaria", kh = "TV", wh = "Pueblo", $h = "WiFi", xh = "Filtros", jh = "Fechas fijas", zh = "Un mes en {{date}}", Ch = "Un fin de semana en {{date}}", Oh = "Una semana en {{date}}", Eh = "Dos semanas en {{date}}", Sh = "Fechas flexibles", Dh = "Invitados", Nh = "casas", Mh = "Último minuto", Ph = "Ubicación", Ah = "Modificar", Lh = "Nombre", Th = "Siguiente", qh = "", Ih = "{{count}} adulto", Bh = "{{count}} adultos", Rh = "", Fh = "{{count}} bebé", Hh = "bebé", Wh = "", Vh = "{{count}} niño/a", Gh = "{{count}} niños", Uh = "", Kh = "{{count}} invitado/a", Jh = "{{count}} invitados", Yh = "El formato del número de teléfono no es válido.", Zh = "Recibir notificaciones por correo electrónico", Qh = "Guardar", Xh = "No encontramos este lugar", ef = "Ver más", tf = "Proyectos de viaje", of = "", lf = "opcional", af = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: b_,
  bedroomsNumbers_one: __,
  bedroomsNumbers_other: h_,
  beds_zero: f_,
  beds_one: p_,
  beds_other: m_,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: v_,
  global_babies: y_,
  global_calendarUpdated_toast: k_,
  global_calendar_aMonth: w_,
  global_calendar_exactDates: $_,
  global_calendar_oneWeek: x_,
  global_calendar_oneWeekend: j_,
  global_calendar_plusMinusDay_zero: z_,
  global_calendar_plusMinusDay_one: C_,
  global_calendar_plusMinusDay_other: O_,
  global_calendar_twoWeeks: E_,
  global_cancel: S_,
  global_children: D_,
  global_dates: N_,
  global_delete: M_,
  global_description: P_,
  global_destination: A_,
  global_done: L_,
  global_edit: T_,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: q_,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: I_,
  global_filter_bbq: B_,
  global_filter_bicycle: R_,
  global_filter_car: F_,
  global_filter_cat: H_,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: W_,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: V_,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: G_,
  global_filter_dog: U_,
  global_filter_dryer: K_,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: J_,
  global_filter_favorite: Y_,
  global_filter_fireplace: Z_,
  global_filter_flat: Q_,
  global_filter_garden: X_,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: eh,
  global_filter_guestPointsMin: th,
  global_filter_guestPointsMinMax: oh,
  global_filter_gym: lh,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: ah,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: nh,
  global_filter_isolated: ih,
  global_filter_jacuzzi: rh,
  "global_filter_kids-toys": "",
  global_filter_lakes: sh,
  global_filter_luxury: ch,
  global_filter_mountains: gh,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: dh,
  global_filter_other: uh,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: bh,
  global_filter_playground: _h,
  global_filter_primary: hh,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: fh,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: ph,
  global_filter_river: mh,
  global_filter_seaside: vh,
  global_filter_secondary: yh,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: kh,
  global_filter_villages: wh,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: $h,
  global_filters: xh,
  global_fixDates: jh,
  global_flexDates_aMonth: zh,
  global_flexDates_aWeekend: Ch,
  global_flexDates_oneWeek: Oh,
  global_flexDates_twoWeek: Eh,
  global_flexibleDates: Sh,
  global_guests: Dh,
  global_homes: Nh,
  global_lastMinute: Mh,
  global_location: Ph,
  global_modify: Ah,
  global_name: Lh,
  global_next: Th,
  global_numberOfAdults_zero: qh,
  global_numberOfAdults_one: Ih,
  global_numberOfAdults_other: Bh,
  global_numberOfBabies_zero: Rh,
  global_numberOfBabies_one: Fh,
  global_numberOfBabies_other: Hh,
  global_numberOfChildren_zero: Wh,
  global_numberOfChildren_one: Vh,
  global_numberOfChildren_other: Gh,
  global_numberOfGuests_zero: Uh,
  global_numberOfGuests_one: Kh,
  global_numberOfGuests_other: Jh,
  global_phoneNumber_notValid: Yh,
  global_receiveEmailAlerts: Zh,
  global_save: Qh,
  global_searchBar_noLocationFound: Xh,
  global_seeMore_link: ef,
  global_travelWishlist: tf,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: of,
  optional: lf,
  "privacy-policy": "Política de Privacidad"
}, nf = {
  "global.collection.ishomeeligible": "¿Cumple mi casa los requisitos?",
  "global.collection.joinnow": "Únete ahora",
  "global.collection.startfreetrial": "Comenzar prueba gratuita de 14 días",
  "modal.collectionhp.eligibilitycheck.body": "",
  "modal.collectionhp.eligibilitycheck.callout.body": "",
  "modal.collectionhp.eligibilitycheck.callout.link": "",
  "modal.collectionhp.eligibilitycheck.title": "",
  "page.collectionhp.benefitssection.body": "",
  "page.collectionhp.benefitssection.body.fallback": "",
  "page.collectionhp.benefitssection.cta": "",
  "page.collectionhp.benefitssection.home.location": "",
  "page.collectionhp.benefitssection.title": "",
  "page.collectionhp.contact.subtitle": "",
  "page.collectionhp.contact.title": "",
  "page.collectionhp.eligibilitycheck.label": "",
  "page.collectionhp.faq.question1.body": "",
  "page.collectionhp.faq.question1.title": "",
  "page.collectionhp.faq.question2.content": "",
  "page.collectionhp.faq.question2.title": "",
  "page.collectionhp.faq.question3.content": "",
  "page.collectionhp.faq.question3.title": "",
  "page.collectionhp.faq.question4.content": "",
  "page.collectionhp.faq.question4.title": "",
  "page.collectionhp.faq.question5.content": "",
  "page.collectionhp.faq.question5.title": "",
  "page.collectionhp.faq.subtitle": "",
  "page.collectionhp.faq.title": "",
  "page.collectionhp.header.elligible.subtilte": "Te invitamos a unirte a nuestra exclusiva comunidad de intercambio de casas.",
  "page.collectionhp.header.elligible.title": "Tu casa cumple los requisitos para unirse a Collection",
  "page.collectionhp.header.external.subtitle": "Únete a una exclusiva comunidad de viajeros con ideas afines que intercambian sus extraordinarias casas por todo el mundo.",
  "page.collectionhp.header.external.title": "Casas que inspiran, viajes que no olvidarás",
  "page.collectionhp.home1.location": "",
  "page.collectionhp.home1.title": "",
  "page.collectionhp.home2.location": "",
  "page.collectionhp.home2.title": "",
  "page.collectionhp.home3.location": "",
  "page.collectionhp.home3.title": "",
  "page.collectionhp.homessection.browse-home.link": "/es/p/ver-casas-collection",
  "page.collectionhp.homessection.subtitle": "",
  "page.collectionhp.homessection.title": "",
  "page.collectionhp.howitwork.contact.cta": "",
  "page.collectionhp.howitwork.elligible": "",
  "page.collectionhp.howitwork.notelligible": "",
  "page.collectionhp.howitwork.step1.body": "",
  "page.collectionhp.howitwork.step1.title": "",
  "page.collectionhp.howitwork.step2.body": "",
  "page.collectionhp.howitwork.step2.title": "",
  "page.collectionhp.howitwork.step3.body": "",
  "page.collectionhp.howitwork.step3.title": "",
  "page.collectionhp.howitwork.title": "",
  "page.collectionhp.keybenefit1.body": "",
  "page.collectionhp.keybenefit1.title": "",
  "page.collectionhp.keybenefit2.body": "",
  "page.collectionhp.keybenefit2.title": "",
  "page.collectionhp.keybenefit3.body": "",
  "page.collectionhp.keybenefit3.title": "",
  "page.collectionhp.testimonie1.body": "",
  "page.collectionhp.testimonie1.label": "",
  "page.collectionhp.testimonie2.body": "",
  "page.collectionhp.testimonie2.label": "",
  "page.collectionhp.testimonie3.body": "",
  "page.collectionhp.testimonie3.label": "",
  "page.collectionhp.testimonies.cta": "",
  "page.collectionhp.testimonies.title": "",
  "page.collectionhp.whatis.body": "",
  "page.collectionhp.whatis.title": ""
}, rf = "Studio", sf = "{{count}} chambre", cf = "{{count}} chambres", gf = "", df = "{{count}} lit", uf = "{{count}} lits", bf = "Adultes", _f = "Bébés", hf = "Votre calendrier a été mis à jour.", ff = "Un mois", pf = "Dates exactes", mf = "Une semaine", vf = "Un week-end", yf = "Vide", kf = "± {{count}} jour", wf = "± {{count}} jours", $f = "Deux semaines", xf = "Annuler", jf = "Enfants", zf = "Dates", Cf = "Supprimer", Of = "Description", Ef = "Destination", Sf = "C'est prêt !", Df = "Modifier", Nf = "Tout type d'échange", Mf = "Baignoire", Pf = "Barbecue", Af = "Vélo", Lf = "Voiture", Tf = "Chat", qf = "Ville", If = "Campagne", Bf = "Lave-vaisselle", Rf = "Chien", Ff = "Sèche linge", Hf = "Ascenseur", Wf = "Maisons favorites", Vf = "Cheminée", Gf = "Appartement", Uf = "Jardin privé", Kf = "moins de {{max}} GP", Jf = "à partir de {{min}} GP", Yf = "Entre {{min}} et {{max}} GP", Zf = "Salle de sport privée", Qf = "Maison", Xf = "Île", ep = "Isolé", tp = "Jacuzzi", op = "Lac", lp = "Maisons Collection", ap = "Montagne", np = "{{count}} salles de bain", ip = "Autre", rp = "Piano", sp = "Aire de jeux", cp = "Principale", gp = "Échange réciproque", dp = "Recherche inversée", up = "Rivière", bp = "Bord de mer", _p = "Secondaire", hp = "TV", fp = "Village", pp = "WiFi", mp = "Filtres", vp = "Dates fixes", yp = "Un mois en {{date}}", kp = "Un week-end en {{date}}", wp = "Une semaine en {{date}}", $p = "Deux semaines en {{date}}", xp = "Dates flexibles", jp = "Personnes", zp = "maisons", Cp = "Dernière minute", Op = "Lieu", Ep = "Modifier", Sp = "Titre", Dp = "Suivant", Np = "Vide", Mp = "{{count}} adulte", Pp = "{{count}} adultes", Ap = "Vide", Lp = "{{count}} bébé", Tp = "{{count}} bébés", qp = "Vide", Ip = "{{count}} enfant", Bp = "{{count}} enfants", Rp = "{{count}} personne", Fp = "{{count}} personne", Hp = "{{count}} personnes", Wp = "Le format du numéro de téléphone est invalide.", Vp = "Recevoir des alertes par email", Gp = "Enregistrer", Up = "Aucun lieu trouvé", Kp = "Voir plus", Jp = "Projets de voyage", Yp = "", Zp = "facultatif", Qp = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: rf,
  bedroomsNumbers_one: sf,
  bedroomsNumbers_other: cf,
  beds_zero: gf,
  beds_one: df,
  beds_other: uf,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: bf,
  global_babies: _f,
  global_calendarUpdated_toast: hf,
  global_calendar_aMonth: ff,
  global_calendar_exactDates: pf,
  global_calendar_oneWeek: mf,
  global_calendar_oneWeekend: vf,
  global_calendar_plusMinusDay_zero: yf,
  global_calendar_plusMinusDay_one: kf,
  global_calendar_plusMinusDay_other: wf,
  global_calendar_twoWeeks: $f,
  global_cancel: xf,
  global_children: jf,
  global_dates: zf,
  global_delete: Cf,
  global_description: Of,
  global_destination: Ef,
  global_done: Sf,
  global_edit: Df,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: Nf,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: Mf,
  global_filter_bbq: Pf,
  global_filter_bicycle: Af,
  global_filter_car: Lf,
  global_filter_cat: Tf,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: qf,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: If,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: Bf,
  global_filter_dog: Rf,
  global_filter_dryer: Ff,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: Hf,
  global_filter_favorite: Wf,
  global_filter_fireplace: Vf,
  global_filter_flat: Gf,
  global_filter_garden: Uf,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: Kf,
  global_filter_guestPointsMin: Jf,
  global_filter_guestPointsMinMax: Yf,
  global_filter_gym: Zf,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: Qf,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: Xf,
  global_filter_isolated: ep,
  global_filter_jacuzzi: tp,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: op,
  global_filter_luxury: lp,
  global_filter_mountains: ap,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: np,
  global_filter_other: ip,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: rp,
  global_filter_playground: sp,
  global_filter_primary: cp,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: gp,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: dp,
  global_filter_river: up,
  global_filter_seaside: bp,
  global_filter_secondary: _p,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: hp,
  global_filter_villages: fp,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: pp,
  global_filters: mp,
  global_fixDates: vp,
  global_flexDates_aMonth: yp,
  global_flexDates_aWeekend: kp,
  global_flexDates_oneWeek: wp,
  global_flexDates_twoWeek: $p,
  global_flexibleDates: xp,
  global_guests: jp,
  global_homes: zp,
  global_lastMinute: Cp,
  global_location: Op,
  global_modify: Ep,
  global_name: Sp,
  global_next: Dp,
  global_numberOfAdults_zero: Np,
  global_numberOfAdults_one: Mp,
  global_numberOfAdults_other: Pp,
  global_numberOfBabies_zero: Ap,
  global_numberOfBabies_one: Lp,
  global_numberOfBabies_other: Tp,
  global_numberOfChildren_zero: qp,
  global_numberOfChildren_one: Ip,
  global_numberOfChildren_other: Bp,
  global_numberOfGuests_zero: Rp,
  global_numberOfGuests_one: Fp,
  global_numberOfGuests_other: Hp,
  global_phoneNumber_notValid: Wp,
  global_receiveEmailAlerts: Vp,
  global_save: Gp,
  global_searchBar_noLocationFound: Up,
  global_seeMore_link: Kp,
  global_travelWishlist: Jp,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: Yp,
  optional: Zp,
  "privacy-policy": "Charte de vie privée"
}, Xp = {
  "global.collection.ishomeeligible": "Ma maison est-elle éligible ?",
  "global.collection.joinnow": "Devenir membre",
  "global.collection.startfreetrial": "Démarrer l'essai gratuit de 14 jours",
  "modal.collectionhp.eligibilitycheck.body": "Notre équipe prendra soin d'évaluer votre annonce (photos et équipements compris) afin d'établir si votre propriété est éligible pour rejoindre HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "Afin de mettre toutes les chances de votre côté, nous vous recommandons de mentionner l'ensemble des équipements de votre propriété et d'ajouter des photos de qualité qui mettent ses atouts en avant.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Mettre à jour mon annonce",
  "modal.collectionhp.eligibilitycheck.title": "Votre annonce est-elle prête à être examinée ?",
  "page.collectionhp.benefitssection.body": "Rejoignez notre club d'échange de maisons de luxe pour {{price}} par an et profitez d'échanges illimités avec les membres Collection.<br/><br/>Voyagez en toute sérénité grâce à nos protections en cas d'annulation et de dommages matériels éventuels au cours de vos échanges.<br/><br/>De plus, votre deuxième année est offerte si vous ne trouvez pas d'échange la première année.",
  "page.collectionhp.benefitssection.body.fallback": "Rejoignez notre club d'échange de maisons de luxe et profitez d'échanges illimités avec les membres Collection.<br/><br/>Voyagez en toute sérénité grâce à nos protections en cas d'annulation et de dommages matériels éventuels au cours de vos échanges.<br/><br/>De plus, votre deuxième année est offerte si vous ne trouvez pas d'échange la première année.",
  "page.collectionhp.benefitssection.cta": "Découvrir tous les avantages",
  "page.collectionhp.benefitssection.home.location": "La maison de Peter à Dollar, en Écosse",
  "page.collectionhp.benefitssection.title": "Une communauté d'échange de maisons réservée aux membres",
  "page.collectionhp.contact.subtitle": "Nos Spécialistes adhésion sont à votre disposition pour répondre à toutes vos questions.",
  "page.collectionhp.contact.title": "Besoin d'informations complémentaires ?",
  "page.collectionhp.eligibilitycheck.label": "Votre demande d'éligibilité est en train d'être examinée.",
  "page.collectionhp.faq.question1.body": 'L’accès à la communauté HomeExchange Collection est réservée à ses membres afin de garantir le respect total de leur vie privée. Chaque propriété est soigneusement sélectionnée selon des critères stricts qui incluent le design, la localisation et les équipements. En rejoignant la communauté Collection, vous accédez à des milliers de maisons de luxe situées dans plus de 85 pays (notamment aux États-Unis, en Europe et en Asie). </br></br> Consultez une sélection de nos plus belles propriétés aux quatre coins du monde <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">ici</a>.',
  "page.collectionhp.faq.question1.title": "Où puis-je découvrir l'ensemble des maisons disponibles ?",
  "page.collectionhp.faq.question2.content": `L'adhésion à HomeExchange Collection coûte {{price}} par an. Elle donne accès à un nombre illimité d'échanges avec les membres de la communauté HomeExchange Collection pendant douze mois, tout en permettant de poursuivre les échanges avec les membres de la version classique de HomeExchange, si vous le souhaitez.\u2028Notre promesse : la deuxième année est offerte si vous ne parvenez pas à finaliser un échange au cours de la première année, <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">voir conditions.</a>\u2028Vous bénéficiez également de services exclusifs et de garanties en cas de dommages ou d'annulation. Découvrez l'ensemble des <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">avantages de l'adhésion</a> en détail.`,
  "page.collectionhp.faq.question2.title": "Combien coûte l'adhésion à HomeExchange Collection ?",
  "page.collectionhp.faq.question3.content": `L'adhésion Collection comprend une protection en cas de dommages matériels jusqu'à 2 000 000 $. </br></br>\u2028Consultez <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">cette page</a> pour en savoir plus sur les garanties proposées à nos membres, et leur fonctionnement.`,
  "page.collectionhp.faq.question3.title": "Que faire si je cause ou subis des dommages ?",
  "page.collectionhp.faq.question4.content": 'Pour demander à rejoindre HomeExchange Collection, remplissez le formulaire d’adhésion afin que nous puissions évaluer votre maison ou votre appartement. Vous recevrez une réponse sous trois jours. Le montant de l’adhésion ne sera prélevé que si votre demande est approuvée. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Lancer ma demande d’adhésion.</a>',
  "page.collectionhp.faq.question4.title": "Comment rejoindre la communauté ?",
  "page.collectionhp.faq.question5.content": `Connectez-vous sur HomeExchange Collection à l'aide de vos identifiants et mot de passe HomeExchange habituels et cliquez sur “Devenir membre”. Vous serez automatiquement redirigé vers la page de paiement si nous avons déjà établi que votre propriété répond aux critères de sélection de HomeExchange Collection. Dans le cas contraire, nous vous invitons à nous envoyer un email à l'adresse <a href="<u>mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a> afin que nous puissions étudier votre demande et vous répondre sous trois jours.`,
  "page.collectionhp.faq.question5.title": "Je suis déjà membre de HomeExchange. Comment rejoindre HomeExchange Collection ?",
  "page.collectionhp.faq.subtitle": "N'hésitez pas à consulter notre <linkFAQCollection> <b><u>FAQ</u></b></linkFAQCollection><b> </b> si vous ne trouvez pas les réponses à vos questions ci-dessous.",
  "page.collectionhp.faq.title": "Foire aux questions",
  "page.collectionhp.header.elligible.subtilte": "Vous êtes invité à rejoindre notre communauté exclusive d'échange de maisons.",
  "page.collectionhp.header.elligible.title": "Votre maison est éligible pour rejoindre Collection",
  "page.collectionhp.header.external.subtitle": "Rejoignez une communauté internationale exclusive et échangez votre maison en toute confiance",
  "page.collectionhp.header.external.title": "Des propriétés d'exception pour des voyages inoubliables",
  "page.collectionhp.home1.location": "Paris, France",
  "page.collectionhp.home1.title": "Charmant appartement design",
  "page.collectionhp.home2.location": "Altea, Espagne",
  "page.collectionhp.home2.title": "Villa méditerranéenne",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Refuge en bord de rivière",
  "page.collectionhp.homessection.browse-home.link": "/p/voir-maisons-collection",
  "page.collectionhp.homessection.subtitle": "Chaque propriété est soigneusement sélectionnée en vertu de ses qualités exceptionnelles, d'une architecture à couper le souffle à une localisation imbattable.",
  "page.collectionhp.homessection.title": "Des milliers d'opportunités d'échange dans des propriétés de luxe",
  "page.collectionhp.howitwork.contact.cta": "Contactez le service membres en cas de question",
  "page.collectionhp.howitwork.elligible": "Votre maison est éligible pour rejoindre notre communauté Collection.",
  "page.collectionhp.howitwork.notelligible": "Malheureusement, votre maison n'est pas éligible.",
  "page.collectionhp.howitwork.step1.body": "Complétez votre annonce avec soin, en incluant des photos de votre maison, afin que notre équipe puisse vous répondre dans les meilleurs délais.",
  "page.collectionhp.howitwork.step1.title": "Vérifiez votre éligibilité",
  "page.collectionhp.howitwork.step2.body": "Vous recevrez une invitation pour nous rejoindre si votre maison est éligible. Pour souscrire à l'adhésion, cliquez simplement sur le lien figurant dans l'invitation ou consultez la page d'adhésion de votre compte.",
  "page.collectionhp.howitwork.step2.title": "Devenez membre Collection",
  "page.collectionhp.howitwork.step3.body": "Une fois membre de la communauté, vous pouvez commencer à organiser des échanges illimités avec des maisons Collection et bénéficier des nouveaux avantages de votre adhésion.",
  "page.collectionhp.howitwork.step3.title": "Profitez de votre adhésion",
  "page.collectionhp.howitwork.title": "Comment ça marche",
  "page.collectionhp.keybenefit1.body": "Notre équipe sélectionne l'ensemble des propriétés avec soin en tenant compte de leur design, leur localisation et leurs équipements. Chaque logement et chaque membre sont soumis à une vérification afin de garantir la sécurité de notre communauté et un climat de confiance.",
  "page.collectionhp.keybenefit1.title": "Sélection de maisons vérifiées",
  "page.collectionhp.keybenefit2.body": "Vous bénéficiez d’une protection en cas de dommages matériels jusqu’à 2 000 000 $ et d’une indemnisation jusqu’à 350 $ par nuit en cas d’annulation ou d’imprévu.",
  "page.collectionhp.keybenefit2.title": "Garanties inégalées",
  "page.collectionhp.keybenefit3.body": "Vous bénéficiez d'un service membres dédié pour faciliter l'organisation de vos échanges. L'adhésion comprend également une retouche professionnelle gratuite des photos de votre annonce.",
  "page.collectionhp.keybenefit3.title": "Service membres dédié",
  "page.collectionhp.testimonie1.body": "Avec quatre enfants, nous étions forcés de prendre trois chambres d'hôtel à chaque voyage. Nous avons ensuite découvert HomeExchange et avons visité des endroits incroyables en rejoignant cette communauté. Nous avons voyagé à Dubaï et sommes partis au ski trois fois à Big Sky, à Tahoe et dans le Colorado.",
  "page.collectionhp.testimonie1.label": "La famille Miglino, Californie",
  "page.collectionhp.testimonie2.body": "L'échange de maisons est une façon de voyager unique vous permettant de découvrir une destination tout en ayant la possibilité de tisser des liens et rester en contact avec les familles bien après la fin des échanges.",
  "page.collectionhp.testimonie2.label": "La famille Eggleton, Floride",
  "page.collectionhp.testimonie3.body": "Je me souviens d'un séjour à New York lorsque les enfants étaient encore très jeunes. Il y avait un toboggan et tous les jouets des deux garçons de l'autre famille dans l'appartement de notre échange ; nos garçons étaient aux anges ! Notre hôte nous avait également donné le nom d'une baby-sitter de confiance pour que nous puissions profiter de sorties à New York.",
  "page.collectionhp.testimonie3.label": "Laetitia, Paris, France",
  "page.collectionhp.testimonies.cta": "Faire connaissance avec les membres",
  "page.collectionhp.testimonies.title": "Témoignages de nos membres",
  "page.collectionhp.whatis.body": "<Text>La notion de luxe est intimement personnelle. Pour certains, le luxe est synonyme de havre de paix isolé, au milieu de paysages naturels à couper le souffle. Pour d'autres, il s'agit plutôt d'un chef-d'œuvre architectural niché au cœur des villes les plus dynamiques du monde.</Text><Text>Cette incroyable diversité est l'essence même de notre Collection, tout aussi unique que notre communauté. L'ensemble de nos propriétés ont toutefois une qualité essentielle en commun : elles vous laisseront bouche bée dès votre arrivée.</Text>",
  "page.collectionhp.whatis.title": "Qu'est-ce qu'une propriété Collection ?"
}, em = "Studio", tm = "{{count}} soba", om = "{{count}} sobe", lm = "{{count}} sobe", am = "", nm = "{{count}} krevet", im = "{{count}} kreveti", rm = "{{count}} kreveti", sm = "Odrasle osobe", cm = "Bebe", gm = "Vaš je kalendar ažuriran.", dm = "Mjesec", um = "Točni datumi", bm = "Jedan tjedan", _m = "Jedan vikend", hm = "dana", fm = "dan", pm = "dana", mm = "± {{count}} dan", vm = "Dva tjedna", ym = "Odustani", km = "Djeca", wm = "Datumi", $m = "Izbrišite", xm = "Opis", jm = "Odredište", zm = "Gotovo!", Cm = "Uredite", Om = "Sve vrste zamjene", Em = "Kada", Sm = "Roštilj", Dm = "Bicikl", Nm = "Automobil", Mm = "Mačka", Pm = "Grad", Am = "Ruralno", Lm = "Perilica suđa", Tm = "Pas", qm = "Sušilica", Im = "Dizalo", Bm = "Favoriti", Rm = "Kamin", Fm = "Stan", Hm = "Privatno dvorište", Wm = "manje od {{max}} GP", Vm = "od {{min}} GP", Gm = "Između {{min}} i {{max}} GP", Um = "Privatna teretana", Km = "Kuća", Jm = "Otok", Ym = "Izoliran", Zm = "Jacuzzi", Qm = "Jezera", Xm = "Domove iz Collectiona", ev = "Planine", tv = "broj kupanica: %{count}", ov = "Ostale životinje", lv = "Glasovir", av = "Dječje igralište", nv = "Moj dom", iv = "Recipročna zamjena", rv = "Obrnuta pretraga", sv = "Rijeka", cv = "Na obali", gv = "Drugi", dv = "TV", uv = "Selo", bv = "WiFi", _v = "Filtri", hv = "Fiksni datumi", fv = "{{date}}: jedan mjesec", pv = "{{date}}: jedan vikend", mv = "{{date}}: jedan tjedan", vv = "{{date}}: dva tjedna", yv = "Fleksibilni datumi", kv = "Gosti", wv = "domova", $v = "U zadnji tren", xv = "Lokacija", jv = "Uredi", zv = "", Cv = "Dalje", Ov = "odraslih osoba", Ev = "odrasla osoba", Sv = "odrasle osobe", Dv = "odraslih osoba", Nv = "beba", Mv = "beba", Pv = "bebe", Av = "beba", Lv = "djece", Tv = "dijete", qv = "djeteta", Iv = "djece", Bv = "gostiju", Rv = "gost", Fv = "gosta", Hv = "gostiju", Wv = "Format telefonskog broja nije valjan.", Vv = "Primajte obavijesti e-poštom", Gv = "Spremi", Uv = "Nema pronađenih lokacija", Kv = "Saznajte više", Jv = "Planovi putovanja", Yv = "", Zv = "nije obavezno", Qv = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: em,
  bedroomsNumbers_one: tm,
  bedroomsNumbers_few: om,
  bedroomsNumbers_other: lm,
  beds_zero: am,
  beds_one: nm,
  beds_few: im,
  beds_other: rm,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: sm,
  global_babies: cm,
  global_calendarUpdated_toast: gm,
  global_calendar_aMonth: dm,
  global_calendar_exactDates: um,
  global_calendar_oneWeek: bm,
  global_calendar_oneWeekend: _m,
  global_calendar_plusMinusDay_zero: hm,
  global_calendar_plusMinusDay_one: fm,
  global_calendar_plusMinusDay_few: pm,
  global_calendar_plusMinusDay_other: mm,
  global_calendar_twoWeeks: vm,
  global_cancel: ym,
  global_children: km,
  global_dates: wm,
  global_delete: $m,
  global_description: xm,
  global_destination: jm,
  global_done: zm,
  global_edit: Cm,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: Om,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: Em,
  global_filter_bbq: Sm,
  global_filter_bicycle: Dm,
  global_filter_car: Nm,
  global_filter_cat: Mm,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: Pm,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: Am,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: Lm,
  global_filter_dog: Tm,
  global_filter_dryer: qm,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: Im,
  global_filter_favorite: Bm,
  global_filter_fireplace: Rm,
  global_filter_flat: Fm,
  global_filter_garden: Hm,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: Wm,
  global_filter_guestPointsMin: Vm,
  global_filter_guestPointsMinMax: Gm,
  global_filter_gym: Um,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: Km,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: Jm,
  global_filter_isolated: Ym,
  global_filter_jacuzzi: Zm,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: Qm,
  global_filter_luxury: Xm,
  global_filter_mountains: ev,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: tv,
  global_filter_other: ov,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: lv,
  global_filter_playground: av,
  global_filter_primary: nv,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: iv,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: rv,
  global_filter_river: sv,
  global_filter_seaside: cv,
  global_filter_secondary: gv,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: dv,
  global_filter_villages: uv,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: bv,
  global_filters: _v,
  global_fixDates: hv,
  global_flexDates_aMonth: fv,
  global_flexDates_aWeekend: pv,
  global_flexDates_oneWeek: mv,
  global_flexDates_twoWeek: vv,
  global_flexibleDates: yv,
  global_guests: kv,
  global_homes: wv,
  global_lastMinute: $v,
  global_location: xv,
  global_modify: jv,
  global_name: zv,
  global_next: Cv,
  global_numberOfAdults_zero: Ov,
  global_numberOfAdults_one: Ev,
  global_numberOfAdults_few: Sv,
  global_numberOfAdults_other: Dv,
  global_numberOfBabies_zero: Nv,
  global_numberOfBabies_one: Mv,
  global_numberOfBabies_few: Pv,
  global_numberOfBabies_other: Av,
  global_numberOfChildren_zero: Lv,
  global_numberOfChildren_one: Tv,
  global_numberOfChildren_few: qv,
  global_numberOfChildren_other: Iv,
  global_numberOfGuests_zero: Bv,
  global_numberOfGuests_one: Rv,
  global_numberOfGuests_few: Fv,
  global_numberOfGuests_other: Hv,
  global_phoneNumber_notValid: Wv,
  global_receiveEmailAlerts: Vv,
  global_save: Gv,
  global_searchBar_noLocationFound: Uv,
  global_seeMore_link: Kv,
  global_travelWishlist: Jv,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: Yv,
  optional: Zv,
  "privacy-policy": "Pravila o privatnosti"
}, Xv = {
  "global.collection.ishomeeligible": "Je li moj dom prihvatljiv?",
  "global.collection.joinnow": "Pridružite se odmah",
  "global.collection.startfreetrial": "Započnite 14-dnevno besplatno probno razdoblje",
  "modal.collectionhp.eligibilitycheck.body": "Naš će tim pažljivo pregledati podatke o Vašem domu, uključujući fotografije i sadržaje, kako bi utvrdio ispunjava li uvjete za Collection članstvo.",
  "modal.collectionhp.eligibilitycheck.callout.body": "Kako biste povećali svoje šanse za uspjeh, predlažemo da navedete sve sadržaje svojeg doma i dodate visokokvalitetne fotografije koje ističu njegove najbolje značajke.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Ažuriraj moj oglas",
  "modal.collectionhp.eligibilitycheck.title": "Je li Vaš dom spreman za pregled?",
  "page.collectionhp.benefitssection.body": "Pridružite se našem klubu za zamjenu luksuznih domova za {{price}} godišnje i uživajte u neograničenim zamjenama s članovima kluba Collection.<br/><br/>Možete mirno uživati sa zaštitom od otkazivanja i pokrićem svih potencijalnih šteta u domu tijekom Vaših zamjena.<br/><br/>Uz to, ako tijekom prve godine ne pronađete zamjenu, drugu godinu dobivate besplatno.",
  "page.collectionhp.benefitssection.body.fallback": "Pridružite se našem klubu za zamjenu luksuznih domova i uživajte u neograničenim zamjenama s članovima kluba Collection.<br/><br/>Možete mirno uživati sa zaštitom od otkazivanja i pokrićem svih potencijalnih šteta u domu tijekom Vaših zamjena.<br/><br/>Uz to, ako tijekom prve godine ne pronađete zamjenu, drugu godinu dobivate besplatno.",
  "page.collectionhp.benefitssection.cta": "Pogledajte sve pogodnosti",
  "page.collectionhp.benefitssection.home.location": "Peterov dom u Dollaru u Škotskoj",
  "page.collectionhp.benefitssection.title": "Zajednica za zamjenu domova, isključivo za članove",
  "page.collectionhp.contact.subtitle": "Naši savjetnici za članstvo dostupni su za sva pitanja koja imate.",
  "page.collectionhp.contact.title": "Trebate više informacija?",
  "page.collectionhp.eligibilitycheck.label": "Vaš zahtjev za ispunjavanje uvjeta se provjerava.",
  "page.collectionhp.faq.question1.body": 'Pristup zajednici HomeExchange Collection rezerviran je za članove kako bi se osiguralo da se njihova privatnost potpuno poštuje. Svaka nekretnina pažljivo je odabrana u skladu s konkretnim kriterijima kao što su dizajn, lokacija i sadržaji. S Collection članstvom imate pristup tisućama luksuznih domova koji se nalaze u više od 85 zemalja (uglavnom diljem Sjedinjenih Država, Europe i Azije)</br></br>Izbor naših najljepših nekretnina diljem svijeta možete pogledati na ovoj <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">stranici</a>.',
  "page.collectionhp.faq.question1.title": "Gdje mogu vidjeti sve dostupne domove?",
  "page.collectionhp.faq.question2.content": 'Članstvo u HomeExchange Collection iznosi {{price}} godišnje. Omogućuje Vam pristup neograničenim zamjenama s članovima HomeExchange Collection zajednice tijekom dvanaest mjeseci, a istovremeno se možete i mijenjati s članovima klasične HomeExchange zajednice ako želite. Naše obećanje: ako ne uspijete finalizirati zamjenu tijekom prve godine članstva, dat ćemo Vam drugu godinu besplatno, <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">ovdje pogledajte uvjete.</a>Možete i koristiti od jamstava u slučaju štete ili otkazivanja, kao i ekskluzivne usluge. Otkrijte sve <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">Prednosti članstva</a> u više pojedinosti.',
  "page.collectionhp.faq.question2.title": "Koliko košta pridruživanje HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": 'Collection članstvo pokriva materijalnu štetu do 2.000.000 USD. </br> </br> Ako želite saznati više o jamstvima koja ćete imati kada postanete član i kako ona funkcioniraju, pogledajte <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank"> ovu stranicu </a>.',
  "page.collectionhp.faq.question3.title": "Što se događa ako moji gosti ili ja prouzročimo štetu?",
  "page.collectionhp.faq.question4.content": 'Da biste se prijavili za pridruživanje HomeExchange Collection, ispunite obrazac za prijavu koji će nam omogućiti procjenu Vašeg doma ili stana. Odgovor ćemo Vam dati u roku od tri dana. Članarina će se naplatiti samo ako Vaša prijava bude prihvaćena. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Pokrenite svoju prijavu za članstvo.</a>',
  "page.collectionhp.faq.question4.title": "Kako se mogu pridružiti?",
  "page.collectionhp.faq.question5.content": 'Prijavite se u HomeExchange Collection s istim podacima za prijavu i lozinkom kao za HomeExchange te kliknite na "Postani član" (Become a member). Ako smo već utvrdili da Vaša nekretnina zadovoljava kriterije za HomeExchange Collection, automatski ćete biti preusmjereni na stranicu za plaćanje. Ako ne, pošaljite nam e-poruku na <a href="mailto:joincollection@homeexchange.com"> joincollection@homeexchange.com</a> kako bismo mogli pregledati Vašu prijavu i odgovoriti u roku od tri dana.',
  "page.collectionhp.faq.question5.title": "Već sam HomeExchange član. Kako se mogu pridružiti HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": "Ako imate ikakvih pitanja koja nisu navedena ovdje, posjetite našu stranicu s <linkFAQCollection> <b><u>Čestim pitanjima</u></b></linkFAQCollection><b> </b>.",
  "page.collectionhp.faq.title": "Česta pitanja",
  "page.collectionhp.header.elligible.subtilte": "Pozvani ste da se pridružite našoj ekskluzivnoj zajednici za zamjenu domova.",
  "page.collectionhp.header.elligible.title": "Vaš dom je prihvatljiv za Collection",
  "page.collectionhp.header.external.subtitle": "Otključajte pristup ekskluzivnoj zajednici za zamjenu domova i uživajte u autentičnim iskustvima putovanja u izuzetnim domovima.",
  "page.collectionhp.header.external.title": "Pridružite se zajednici za zamjenu luksuznih domova",
  "page.collectionhp.home1.location": "Pariz, Francuska",
  "page.collectionhp.home1.title": "Lijep dizajnerski stan",
  "page.collectionhp.home2.location": "Altea, Španjolska",
  "page.collectionhp.home2.title": "Kuća na Mediteranu",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Riverfront Retreat",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "Od arhitekture koja oduzima dah do neponovljivih lokacija, svaki je dom odabran zbog svojih iznimnih kvaliteta.",
  "page.collectionhp.homessection.title": "Tisuće mogućnosti za zamjene luksuznih nekretnina",
  "page.collectionhp.howitwork.contact.cta": "Kontaktirajte podršku ako imate ikakvih pitanja",
  "page.collectionhp.howitwork.elligible": "Vaš dom je prihvatljiv za pridruživanje Collection zajednici.",
  "page.collectionhp.howitwork.notelligible": "Nažalost, Vaš dom nije prihvatljiv.",
  "page.collectionhp.howitwork.step1.body": "Provjerite je li Vaš oglas potpun, uključujući fotografije doma, kako bi naš tim mogao dati brz odgovor.",
  "page.collectionhp.howitwork.step1.title": "Provjerite ispunjavate li uvjete",
  "page.collectionhp.howitwork.step2.body": "Ako Vaš dom ispunjava uvjete, primit ćete pozivnicu da se pridružite. Za aktiviranje svojeg članstva kliknite vezu u pozivnici ili posjetite stranicu za članstvo na svom računu.",
  "page.collectionhp.howitwork.step2.title": "Postanite Collection član",
  "page.collectionhp.howitwork.step3.body": "Nakon što aktivirate svoje članstvo, možete početi organizirati neograničene zamjene s Collection domovima i otključati dodatne pogodnosti koje dolaze s Vašim članstvom.",
  "page.collectionhp.howitwork.step3.title": "Uživajte u svom članstvu",
  "page.collectionhp.howitwork.title": "Kako funkcionira?",
  "page.collectionhp.keybenefit1.body": "Sve je naše domove pažljivo odabrao naš tim na temelju njihovog dizajna, lokacije i dodataka. Svi domovi i članovi su provjereni kako bi zajednica bila sigurna i pouzdana.",
  "page.collectionhp.keybenefit1.title": "Provjeren izbor domova",
  "page.collectionhp.keybenefit2.body": "Dobivate zaštitu od štete na imovini do 2.000.000 USD i pokriće do 350 USD po noćenju u slučaju otkazivanja ili nepredviđenih događaja.",
  "page.collectionhp.keybenefit2.title": "Neusporediva jamstva",
  "page.collectionhp.keybenefit3.body": "Dobivate personaliziranu podršku koja osigurava olakšavanje Vaše zamjene. Osim toga, članstvo uključuje besplatno profesionalno poboljšanje slika Vašeg oglasa.",
  "page.collectionhp.keybenefit3.title": "Personalizirana podrška",
  "page.collectionhp.testimonie1.body": "Imamo četvero djece pa smo svaki put kad bismo putovali i odsjeli u hotelu, na kraju morali dobiti tri sobe. Tada smo saznali za HomeExchange i otkad smo se pridružili, otišli smo na nevjerojatna mjesta. Išli smo u Dubai, tri puta smo skijali u Big Skyu, Tahoeu i Coloradu.",
  "page.collectionhp.testimonie1.label": "Obitelj Miglino - Kalifornija",
  "page.collectionhp.testimonie2.body": "HomeExchange je jedinstven način putovanja jer vam omogućava da iskusite odredište, ali i da možete uspostavljati veze i održavati kontakt s obiteljima i nakon završetka zamjene.",
  "page.collectionhp.testimonie2.label": "Obitelj Eggleton - Florida",
  "page.collectionhp.testimonie3.body": "Sjećam se jednom u New Yorku, dok su djeca još bila vrlo mala, u našem stanu za zamjenu je bio tobogan, kao i sve igračke dvojice dječaka iz druge obitelji; naši su dječaci bili oduševljeni! Naš domaćin nam je rekao ime dadilje koju redovito koriste, tako da smo mogli izaći u New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Pariz, Francuska",
  "page.collectionhp.testimonies.cta": "Upoznajte naše članove",
  "page.collectionhp.testimonies.title": "Izjave članova",
  "page.collectionhp.whatis.body": "<Text>Smatramo da je luksuz nešto vrlo osobno. Nekome je to osamljeno utočište sa zadivljujućim pogled u prirodu. Drugima je to arhitektonsko remek-djelo smješteno u srcu najdinamičnijih svjetskih gradova.</Text><Text>Naš Collection obuhvaća ovu zadivljujuću raznolikost. Jedinstvena je popust naše zajednice, a istovremeno svi domovi imaju jednu zajedničku kvalitetu: zadivljuju Vas čim kročite u njih.</Text>",
  "page.collectionhp.whatis.title": "Što je Collection dom?"
}, ey = "Monolocale", ty = "{{count}} camera da letto", oy = "{{count}} camere da letto", ly = "", ay = "{{count}} letto", ny = "{{count}} letti", iy = "Adulti", ry = "Neonati", sy = "Il tuo calendario è stato aggiornato.", cy = "Un mese", gy = "Date esatte", dy = "Una settimana", uy = "", by = "", _y = "", hy = "", fy = "Due settimane", py = "Annulla", my = "Bambini", vy = "Date", yy = "Elimina", ky = "Descrizione", wy = "Destinazione", $y = "Fatto!", xy = "Modifica", jy = "Qualsiasi tipo di scambio", zy = "Vasca da bagno", Cy = "Barbecue", Oy = "Bicicletta", Ey = "Automobile", Sy = "Gatto", Dy = "Città", Ny = "Campagna", My = "Lavastoviglie", Py = "Cane", Ay = "Asciugatrice", Ly = "Ascensore", Ty = "Case preferite", qy = "Camino", Iy = "Appartamento", By = "Cortile privato", Ry = "Meno di {{max}} GP", Fy = "da {{min}} GP", Hy = "Tra {{min}} e {{max}} GP", Wy = "Palestra privata", Vy = "Casa", Gy = "Isola o penisola", Uy = "Isolata", Ky = "Idromassaggio", Jy = "Lago", Yy = "Case Collection", Zy = "Montagna", Qy = "{{count}} bagni", Xy = "Altri animali", ek = "Pianoforte", tk = "Zona giochi per bambini", ok = "Prima", lk = "Scambio reciproco", ak = "Ricerca inversa", nk = "Fiume", ik = "Sulla costa", rk = "Seconda", sk = "TV", ck = "Paese", gk = "WiFi", dk = "Filtri", uk = "Date esatte", bk = "Un mese in {{date}}", _k = "Un fine settimana in {{date}}", hk = "Una settimana in {{date}}", fk = "Due settimane in {{date}}", pk = "Date flessibili", mk = "Ospiti", vk = "case", yk = "Ultimo minuto", kk = "Posizione", wk = "Modifica", $k = "Nome", xk = "Avanti", jk = "Zero", zk = "Uno", Ck = "Altro", Ok = "Zero", Ek = "Uno", Sk = "Altro", Dk = "Zero", Nk = "Uno", Mk = "Altro", Pk = "Zero", Ak = "Uno", Lk = "Altro", Tk = "Il formato del numero di telefono non è valido.", qk = "Ricevi avvisi via email", Ik = "Salva", Bk = "Nessuna posizione trovata", Rk = "Vedere di più", Fk = "Progetti di viaggio", Hk = "", Wk = "facoltativo", Vk = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: ey,
  bedroomsNumbers_one: ty,
  bedroomsNumbers_other: oy,
  beds_zero: ly,
  beds_one: ay,
  beds_other: ny,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: iy,
  global_babies: ry,
  global_calendarUpdated_toast: sy,
  global_calendar_aMonth: cy,
  global_calendar_exactDates: gy,
  global_calendar_oneWeek: dy,
  global_calendar_oneWeekend: uy,
  global_calendar_plusMinusDay_zero: by,
  global_calendar_plusMinusDay_one: _y,
  global_calendar_plusMinusDay_other: hy,
  global_calendar_twoWeeks: fy,
  global_cancel: py,
  global_children: my,
  global_dates: vy,
  global_delete: yy,
  global_description: ky,
  global_destination: wy,
  global_done: $y,
  global_edit: xy,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: jy,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: zy,
  global_filter_bbq: Cy,
  global_filter_bicycle: Oy,
  global_filter_car: Ey,
  global_filter_cat: Sy,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: Dy,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: Ny,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: My,
  global_filter_dog: Py,
  global_filter_dryer: Ay,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: Ly,
  global_filter_favorite: Ty,
  global_filter_fireplace: qy,
  global_filter_flat: Iy,
  global_filter_garden: By,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: Ry,
  global_filter_guestPointsMin: Fy,
  global_filter_guestPointsMinMax: Hy,
  global_filter_gym: Wy,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: Vy,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: Gy,
  global_filter_isolated: Uy,
  global_filter_jacuzzi: Ky,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: Jy,
  global_filter_luxury: Yy,
  global_filter_mountains: Zy,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: Qy,
  global_filter_other: Xy,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: ek,
  global_filter_playground: tk,
  global_filter_primary: ok,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: lk,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: ak,
  global_filter_river: nk,
  global_filter_seaside: ik,
  global_filter_secondary: rk,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: sk,
  global_filter_villages: ck,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: gk,
  global_filters: dk,
  global_fixDates: uk,
  global_flexDates_aMonth: bk,
  global_flexDates_aWeekend: _k,
  global_flexDates_oneWeek: hk,
  global_flexDates_twoWeek: fk,
  global_flexibleDates: pk,
  global_guests: mk,
  global_homes: vk,
  global_lastMinute: yk,
  global_location: kk,
  global_modify: wk,
  global_name: $k,
  global_next: xk,
  global_numberOfAdults_zero: jk,
  global_numberOfAdults_one: zk,
  global_numberOfAdults_other: Ck,
  global_numberOfBabies_zero: Ok,
  global_numberOfBabies_one: Ek,
  global_numberOfBabies_other: Sk,
  global_numberOfChildren_zero: Dk,
  global_numberOfChildren_one: Nk,
  global_numberOfChildren_other: Mk,
  global_numberOfGuests_zero: Pk,
  global_numberOfGuests_one: Ak,
  global_numberOfGuests_other: Lk,
  global_phoneNumber_notValid: Tk,
  global_receiveEmailAlerts: qk,
  global_save: Ik,
  global_searchBar_noLocationFound: Bk,
  global_seeMore_link: Rk,
  global_travelWishlist: Fk,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: Hk,
  optional: Wk,
  "privacy-policy": "Informativa sulla privacy"
}, Gk = {
  "global.collection.ishomeeligible": "La mia casa è idonea?",
  "global.collection.joinnow": "Unisciti adesso",
  "global.collection.startfreetrial": "Inizia la prova gratuita di 14 giorni",
  "modal.collectionhp.eligibilitycheck.body": "Il nostro team esaminerà attentamente i dettagli della tua casa, comprese le foto e i servizi, per determinare se è idonea per HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "Per massimizzare le tue possibilità di successo, ti consigliamo di elencare tutti i comfort della tua casa inviando foto di alta qualità che ne mettano in risalto le caratteristiche migliori.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Aggiorna il mio annuncio",
  "modal.collectionhp.eligibilitycheck.title": "La tua casa è pronta per essere esaminata?",
  "page.collectionhp.benefitssection.body": "Unisciti al nostro club di scambio casa di lusso a {{price}} all'anno e goditi scambi illimitati con i membri Collection.<br/><br/>Con la protezione contro le cancellazioni e la copertura per eventuali danni alla casa durante i tuoi scambi puoi scambiare in tranquillità.<br/><br/>Inoltre, se non trovi uno scambio nel primo anno, ottieni un secondo anno gratuito.",
  "page.collectionhp.benefitssection.body.fallback": "Unisciti al nostro club di scambio casa di lusso e goditi scambi illimitati con i membri Collection.<br/><br/>Con la protezione contro le cancellazioni e la copertura per eventuali danni alla casa durante i tuoi scambi puoi scambiare in tranquillità.<br/><br/>Inoltre, se non trovi uno scambio nel primo anno, ottieni un secondo anno gratuito.",
  "page.collectionhp.benefitssection.cta": "Scopri tutti i vantaggi",
  "page.collectionhp.benefitssection.home.location": "La casa di Peter a Dollar, Scozia",
  "page.collectionhp.benefitssection.title": "Comunità di scambio casa riservata ai soli membri",
  "page.collectionhp.contact.subtitle": "I nostri consulenti per le adesioni sono pronti a rispondere a qualsiasi tua domanda.",
  "page.collectionhp.contact.title": "Hai bisogno di maggiori informazioni?",
  "page.collectionhp.eligibilitycheck.label": "La tua richiesta è in fase di revisione.",
  "page.collectionhp.faq.question1.body": `L'accesso alla community di HomeExchange Collection è riservato ai membri per garantire che la loro privacy sia pienamente rispettata. Ogni proprietà è stata accuratamente selezionata in base a criteri specifici come il design, la posizione e i servizi. Aderendo a Collection hai accesso a migliaia di case di lusso situate in oltre 85 paesi (principalmente negli Stati Uniti, in Europa e in Asia)</br></br>Puoi visualizzare una selezione delle nostre proprietà più belle in tutto il mondo su <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">pagina</a>.`,
  "page.collectionhp.faq.question1.title": "Dove posso vedere tutte le case disponibili?",
  "page.collectionhp.faq.question2.content": `Aderire a HomeExchange Collection costa {{price}} all'anno. Ti dà accesso a scambi illimitati con i membri della community di HomeExchange Collection per dodici mesi consentendoti al contempo, se lo desideri, di scambiare anche con i membri di HomeExchange Classic. La nostra promessa è semplice: se non riesci a finalizzare uno scambio nel tuo primo anno di adesione, ti offriamo un secondo anno gratuito, <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank"> vedi le condizioni. </a> Puoi inoltre beneficiare di garanzie in caso di danni o cancellazione, nonché di servizi esclusivi. Scopri nel dettaglio tutti i <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">vantaggi dell'adesione</a>.`,
  "page.collectionhp.faq.question2.title": "Quanto costa l'adesione a HomeExchange Collection? ",
  "page.collectionhp.faq.question3.content": `L'iscrizione a Collection copre i danni alla proprietà fino a 2.000.000$. </br></br> Per scoprire più da vicino le garanzie di cui potrai beneficiare diventando un membro e come funzionano, ti invitiamo a consultare <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">questa pagina</a>.`,
  "page.collectionhp.faq.question3.title": "Cosa succede se io o i miei ospiti causiamo dei danni?",
  "page.collectionhp.faq.question4.content": 'Per fare domanda di adesione a HomeExchange Collection, compila il modulo di richiesta che ci consentirà di valutare la tua casa o appartamento. Ti daremo una risposta entro tre giorni. La quota di adesione verrà addebitata solo se la tua domanda sarà accettata. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Inizia la tua richiesta di adesione.</a>',
  "page.collectionhp.faq.question4.title": "Come posso unirmi?",
  "page.collectionhp.faq.question5.content": `Accedi a HomeExchange Collection con lo stesso nome utente e la stessa password di HomeExchange e fai clic su "Diventa un membro". Se abbiamo già identificato che la tua casa soddisfa i criteri di selezione per HomeExchange Collection, andrai direttamente alla pagina di pagamento. In caso contrario, ti invitiamo a inviarci una mail all'indirizzo <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a> in modo da poter esaminare la tua richiesta. Ti risponderemo entro tre giorni.`,
  "page.collectionhp.faq.question5.title": "Sono già un membro di HomeExchange. Come faccio a unirmi a HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": "Se hai domande che non sono presenti qui, visita la nostra pagina <linkFAQCollection><b><u> FAQ </u></b></linkFAQCollection><b> </b>. ",
  "page.collectionhp.faq.title": "Domande frequenti",
  "page.collectionhp.header.elligible.subtilte": "Ti invitiamo a unirti alla nostra comunità di scambio casa esclusiva.",
  "page.collectionhp.header.elligible.title": "La tua casa è idonea per Collection.",
  "page.collectionhp.header.external.subtitle": "Unisciti a una comunità esclusiva di viaggiatori che la pensano allo stesso modo e che si scambiano le loro case straordinarie in tutto il mondo.",
  "page.collectionhp.header.external.title": "Case che ispirano, viaggi che ricorderai",
  "page.collectionhp.home1.location": "Parigi, Francia",
  "page.collectionhp.home1.title": "Grazioso appartamento di design",
  "page.collectionhp.home2.location": "Altea, Spagna",
  "page.collectionhp.home2.title": "Casa mediterranea",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Rifugio sul lungofiume",
  "page.collectionhp.homessection.browse-home.link": "/p/visualizza-case-collection",
  "page.collectionhp.homessection.subtitle": "Dall'architettura mozzafiato alle location imbattibili, ogni casa è selezionata con cura per le sue eccezionali qualità.",
  "page.collectionhp.homessection.title": "Migliaia di opportunità di scambio con immobili di lusso",
  "page.collectionhp.howitwork.contact.cta": "Contatta il supporto membri per qualsiasi domanda",
  "page.collectionhp.howitwork.elligible": "La tua casa è idonea a far parte della nostra comunità Collection.",
  "page.collectionhp.howitwork.notelligible": "Purtroppo la tua casa non è idonea.",
  "page.collectionhp.howitwork.step1.body": "Assicurati che il tuo annuncio sia completo, comprese le foto della tua casa, in modo che il nostro team possa fornirti una risposta tempestiva.",
  "page.collectionhp.howitwork.step1.title": "Verifica la tua idoneità",
  "page.collectionhp.howitwork.step2.body": "Se la tua casa è idonea, riceverai un invito a unirti. Per attivare la tua adesione, clicca semplicemente sul link nell'invito o visita la pagina di adesione nel tuo account.",
  "page.collectionhp.howitwork.step2.title": "Diventa un membro di Collection",
  "page.collectionhp.howitwork.step3.body": "Una volta attivata la tua adesione, potrai iniziare a organizzare scambi illimitati con le case Collection e usufruire dei vantaggi aggiuntivi inclusi nella tua adesione.",
  "page.collectionhp.howitwork.step3.title": "Attiva la tua adesione",
  "page.collectionhp.howitwork.title": "Come funziona",
  "page.collectionhp.keybenefit1.body": "Tutte le nostre case sono state accuratamente selezionate dal nostro team in base al design, alla posizione e ai servizi. Tutte le case e i membri sono verificati per garantire una comunità sicura e affidabile.",
  "page.collectionhp.keybenefit1.title": "Selezione di case verificate",
  "page.collectionhp.keybenefit2.body": "Ricevi una protezione contro i danni alla proprietà fino a 2.000.000$ e una copertura fino a 350$ a notte in caso di cancellazioni o eventi imprevisti. ",
  "page.collectionhp.keybenefit2.title": "Garanzie senza pari",
  "page.collectionhp.keybenefit3.body": "Riceverai supporto personalizzato che assicura maggiore fluidità ai tuoi scambi. Inoltre, l'adesione include un editing professionale gratuito delle immagini del tuo annuncio.",
  "page.collectionhp.keybenefit3.title": "Supporto personalizzato",
  "page.collectionhp.testimonie1.body": "Abbiamo quattro figli, quindi ogni volta che viaggiavamo e alloggiavamo in un hotel, finivamo per dover prendere tre stanze. Poi abbiamo scoperto HomeExchange e da quando ci siamo iscritti, siamo andati in posti fantastici. Siamo andati a Dubai, siamo andati a sciare tre volte a Big Sky, Tahoe e Colorado.",
  "page.collectionhp.testimonie1.label": "La famiglia Miglino - California",
  "page.collectionhp.testimonie2.body": "HomeExchange è un modo di viaggiare unico in quanto ti permette di vivere una destinazione, ma hai anche la possibilità di creare legami e rimanere in contatto con le famiglie anche dopo la fine dello scambio.",
  "page.collectionhp.testimonie2.label": "La famiglia Eggleton - Florida",
  "page.collectionhp.testimonie3.body": "Ricordo che una volta a New York, i bambini erano ancora molto piccoli e c'era uno scivolo nel nostro appartamento in scambio, così come tutti i giocattoli dei due ragazzi dell'altra famiglia; i nostri ragazzi erano felicissimi! Il nostro host ha condiviso con noi il nome di una babysitter che usano regolarmente, così siamo stati in grado di uscire la sera a New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Parigi, Francia",
  "page.collectionhp.testimonies.cta": "Incontra i nostri membri",
  "page.collectionhp.testimonies.title": "Testimonianze dei membri",
  "page.collectionhp.whatis.body": "<Text>Crediamo che il lusso sia profondamente personale. Per alcuni, è un rifugio appartato circondato da viste naturali mozzafiato. Per altri, è un capolavoro architettonico incastonato nel cuore delle città più vivaci del mondo.</Text><Text>La nostra Collection cattura questa straordinaria diversità. È unica come la nostra comunità, ma tutte le case condividono una qualità distintiva: ti lasciano a bocca aperta nel momento in cui ci metti piede dentro.</Text>",
  "page.collectionhp.whatis.title": "Cosa rende una casa da Collection?"
}, Uk = "Studio", Kk = "{{count}} soverom", Jk = "{{count}} soverom", Yk = "", Zk = "{{count}} seng", Qk = "{{count}} senger", Xk = "Voksne", ew = "Babyer", tw = "", ow = "En måned", lw = "Nøyaktige datoer", aw = "Uke", nw = "", iw = "", rw = "", sw = "", cw = "To uker", gw = "", dw = "Barn", uw = "Datoer", bw = "", _w = "Beskrivelse", hw = "Reisemål", fw = "", pw = "", mw = "alle typer boligbytter", vw = "Badekar", yw = "Grill", kw = "Sykkel", ww = "Bil", $w = "Katt", xw = "By", jw = "Landlig", zw = "Oppvaskmaskin", Cw = "Hund", Ow = "Tørketrommel", Ew = "Heis", Sw = "Favoritthjem", Dw = "Peis", Nw = "Leilighet", Mw = "", Pw = "mindre enn {{max}} GP", Aw = "fra {{min}} GP", Lw = "Mellom {{min}} og {{max}} GP", Tw = "Privat treningsrom", qw = "Hus", Iw = "Øy", Bw = "Isolert", Rw = "Jacuzzi", Fw = "Innsjøer", Hw = "Collection-hjem", Ww = "Fjell", Vw = "", Gw = "Andre dyr", Uw = "Piano", Kw = "", Jw = "Primær", Yw = "Gjensidig boligbytte", Zw = "Omvendt søk", Qw = "Elv", Xw = "", e$ = "Sekundær", t$ = "TV", o$ = "Landsbygd", l$ = "WiFi", a$ = "Filtrer", n$ = "Nøyaktige datoer", i$ = "", r$ = "", s$ = "", c$ = "", g$ = "Fleksible datoer", d$ = "Gjester", u$ = "", b$ = "Siste øyeblikk", _$ = "Beliggenhet", h$ = "", f$ = "", p$ = "", m$ = "", v$ = "", y$ = "", k$ = "", w$ = "", $$ = "", x$ = "", j$ = "", z$ = "", C$ = "", O$ = "", E$ = "", S$ = "", D$ = "", N$ = "Lagre", M$ = "", P$ = "Se mer", A$ = "Reiseplaner", L$ = "", T$ = "", q$ = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: Uk,
  bedroomsNumbers_one: Kk,
  bedroomsNumbers_other: Jk,
  beds_zero: Yk,
  beds_one: Zk,
  beds_other: Qk,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: Xk,
  global_babies: ew,
  global_calendarUpdated_toast: tw,
  global_calendar_aMonth: ow,
  global_calendar_exactDates: lw,
  global_calendar_oneWeek: aw,
  global_calendar_oneWeekend: nw,
  global_calendar_plusMinusDay_zero: iw,
  global_calendar_plusMinusDay_one: rw,
  global_calendar_plusMinusDay_other: sw,
  global_calendar_twoWeeks: cw,
  global_cancel: gw,
  global_children: dw,
  global_dates: uw,
  global_delete: bw,
  global_description: _w,
  global_destination: hw,
  global_done: fw,
  global_edit: pw,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: mw,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: vw,
  global_filter_bbq: yw,
  global_filter_bicycle: kw,
  global_filter_car: ww,
  global_filter_cat: $w,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: xw,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: jw,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: zw,
  global_filter_dog: Cw,
  global_filter_dryer: Ow,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: Ew,
  global_filter_favorite: Sw,
  global_filter_fireplace: Dw,
  global_filter_flat: Nw,
  global_filter_garden: Mw,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: Pw,
  global_filter_guestPointsMin: Aw,
  global_filter_guestPointsMinMax: Lw,
  global_filter_gym: Tw,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: qw,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: Iw,
  global_filter_isolated: Bw,
  global_filter_jacuzzi: Rw,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: Fw,
  global_filter_luxury: Hw,
  global_filter_mountains: Ww,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: Vw,
  global_filter_other: Gw,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: Uw,
  global_filter_playground: Kw,
  global_filter_primary: Jw,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: Yw,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: Zw,
  global_filter_river: Qw,
  global_filter_seaside: Xw,
  global_filter_secondary: e$,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: t$,
  global_filter_villages: o$,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: l$,
  global_filters: a$,
  global_fixDates: n$,
  global_flexDates_aMonth: i$,
  global_flexDates_aWeekend: r$,
  global_flexDates_oneWeek: s$,
  global_flexDates_twoWeek: c$,
  global_flexibleDates: g$,
  global_guests: d$,
  global_homes: u$,
  global_lastMinute: b$,
  global_location: _$,
  global_modify: h$,
  global_name: f$,
  global_next: p$,
  global_numberOfAdults_zero: m$,
  global_numberOfAdults_one: v$,
  global_numberOfAdults_other: y$,
  global_numberOfBabies_zero: k$,
  global_numberOfBabies_one: w$,
  global_numberOfBabies_other: $$,
  global_numberOfChildren_zero: x$,
  global_numberOfChildren_one: j$,
  global_numberOfChildren_other: z$,
  global_numberOfGuests_zero: C$,
  global_numberOfGuests_one: O$,
  global_numberOfGuests_other: E$,
  global_phoneNumber_notValid: S$,
  global_receiveEmailAlerts: D$,
  global_save: N$,
  global_searchBar_noLocationFound: M$,
  global_seeMore_link: P$,
  global_travelWishlist: A$,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: L$,
  optional: T$,
  "privacy-policy": "Personvernpolicy"
}, I$ = {
  "global.collection.ishomeeligible": "",
  "global.collection.joinnow": "",
  "global.collection.startfreetrial": "",
  "modal.collectionhp.eligibilitycheck.body": "",
  "modal.collectionhp.eligibilitycheck.callout.body": "",
  "modal.collectionhp.eligibilitycheck.callout.link": "",
  "modal.collectionhp.eligibilitycheck.title": "",
  "page.collectionhp.benefitssection.body": "",
  "page.collectionhp.benefitssection.body.fallback": "",
  "page.collectionhp.benefitssection.cta": "",
  "page.collectionhp.benefitssection.home.location": "",
  "page.collectionhp.benefitssection.title": "",
  "page.collectionhp.contact.subtitle": "",
  "page.collectionhp.contact.title": "",
  "page.collectionhp.eligibilitycheck.label": "",
  "page.collectionhp.faq.question1.body": "",
  "page.collectionhp.faq.question1.title": "",
  "page.collectionhp.faq.question2.content": "",
  "page.collectionhp.faq.question2.title": "",
  "page.collectionhp.faq.question3.content": "",
  "page.collectionhp.faq.question3.title": "",
  "page.collectionhp.faq.question4.content": "",
  "page.collectionhp.faq.question4.title": "",
  "page.collectionhp.faq.question5.content": "",
  "page.collectionhp.faq.question5.title": "",
  "page.collectionhp.faq.subtitle": "",
  "page.collectionhp.faq.title": "",
  "page.collectionhp.header.elligible.subtilte": "",
  "page.collectionhp.header.elligible.title": "",
  "page.collectionhp.header.external.subtitle": "",
  "page.collectionhp.header.external.title": "",
  "page.collectionhp.home1.location": "",
  "page.collectionhp.home1.title": "",
  "page.collectionhp.home2.location": "",
  "page.collectionhp.home2.title": "",
  "page.collectionhp.home3.location": "",
  "page.collectionhp.home3.title": "",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "",
  "page.collectionhp.homessection.title": "",
  "page.collectionhp.howitwork.contact.cta": "",
  "page.collectionhp.howitwork.elligible": "",
  "page.collectionhp.howitwork.notelligible": "",
  "page.collectionhp.howitwork.step1.body": "",
  "page.collectionhp.howitwork.step1.title": "",
  "page.collectionhp.howitwork.step2.body": "",
  "page.collectionhp.howitwork.step2.title": "",
  "page.collectionhp.howitwork.step3.body": "",
  "page.collectionhp.howitwork.step3.title": "",
  "page.collectionhp.howitwork.title": "",
  "page.collectionhp.keybenefit1.body": "",
  "page.collectionhp.keybenefit1.title": "",
  "page.collectionhp.keybenefit2.body": "",
  "page.collectionhp.keybenefit2.title": "",
  "page.collectionhp.keybenefit3.body": "",
  "page.collectionhp.keybenefit3.title": "",
  "page.collectionhp.testimonie1.body": "",
  "page.collectionhp.testimonie1.label": "",
  "page.collectionhp.testimonie2.body": "",
  "page.collectionhp.testimonie2.label": "",
  "page.collectionhp.testimonie3.body": "",
  "page.collectionhp.testimonie3.label": "",
  "page.collectionhp.testimonies.cta": "",
  "page.collectionhp.testimonies.title": "",
  "page.collectionhp.whatis.body": "",
  "page.collectionhp.whatis.title": ""
}, B$ = "Studio", R$ = "{{count}} slaapkamer", F$ = "{{count}} slaapkamers", H$ = "", W$ = "{{count}} bed", V$ = "{{count}} bedden", G$ = "Volwassenen", U$ = "Baby's", K$ = "Je kalender is bijgewerkt.", J$ = "Een maand", Y$ = "Exacte data", Z$ = "Een week", Q$ = "Een weekend", X$ = "", ex = "± {{count}} dag", tx = "± {{count}} dagen", ox = "Twee weken", lx = "Annuleren", ax = "Kinderen", nx = "Data", ix = "Verwijderen", rx = "Beschrijving", sx = "Bestemming", cx = "Klaar!", gx = "Bewerken", dx = "Elk type ruil", ux = "Bad", bx = "BBQ", _x = "Fiets", hx = "Auto", fx = "Kat", px = "De stad", mx = "Het platteland", vx = "Vaatwasmachine", yx = "Hond", kx = "Droger", wx = "Lift", $x = "Favoriete huizen", xx = "Open haard", jx = "Appartement", zx = "Privétuin", Cx = "Minder dan {{max}} GP", Ox = "vanaf {{min}} GP", Ex = "Tussen {{min}} en {{max}} GP", Sx = "Privésportzaal", Dx = "Huis", Nx = "Een eiland", Mx = "Geïsoleerd", Px = "Jacuzzi", Ax = "Een meer", Lx = "Collection-huizen", Tx = "De bergen", qx = "{{count}} badkamers", Ix = "Andere dieren", Bx = "", Rx = "Speeltuin", Fx = "Eerste", Hx = "Wederzijdse huizenruil", Wx = "Omgekeerd zoeken", Vx = "Rivier", Gx = "Kust", Ux = "Vakantiehuis", Kx = "TV", Jx = "Dorp", Yx = "WiFi", Zx = "Filters", Qx = "Vaste data", Xx = "Een maand in {{date}}", e1 = "Een weekend in {{date}}", t1 = "Een week in {{date}}", o1 = "Twee weken in {{date}}", l1 = "Flexibele data", a1 = "Gasten", n1 = "huizen", i1 = "Last minute", r1 = "Locatie", s1 = "Wijzigen", c1 = "Naam", g1 = "Volgende", d1 = "", u1 = "{{count}} volwassene", b1 = "{{count}} volwassenen", _1 = "", h1 = "{{count}} baby", f1 = "{{count}} baby's", p1 = "", m1 = "{{count}} kind", v1 = "{{count}} kinderen", y1 = "", k1 = "{{count}} gast", w1 = "{{count}} gasten", $1 = "De indeling van het telefoonnummer is niet geldig.", x1 = "E-mailmeldingen ontvangen", j1 = "Opslaan", z1 = "Geen locaties gevonden", C1 = "Bekijk meer", O1 = "Reisplannen", E1 = "Geen resultaat", S1 = "optioneel", D1 = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: B$,
  bedroomsNumbers_one: R$,
  bedroomsNumbers_other: F$,
  beds_zero: H$,
  beds_one: W$,
  beds_other: V$,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: G$,
  global_babies: U$,
  global_calendarUpdated_toast: K$,
  global_calendar_aMonth: J$,
  global_calendar_exactDates: Y$,
  global_calendar_oneWeek: Z$,
  global_calendar_oneWeekend: Q$,
  global_calendar_plusMinusDay_zero: X$,
  global_calendar_plusMinusDay_one: ex,
  global_calendar_plusMinusDay_other: tx,
  global_calendar_twoWeeks: ox,
  global_cancel: lx,
  global_children: ax,
  global_dates: nx,
  global_delete: ix,
  global_description: rx,
  global_destination: sx,
  global_done: cx,
  global_edit: gx,
  "global_filter_a-c": "Airco",
  global_filter_available: dx,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: ux,
  global_filter_bbq: bx,
  global_filter_bicycle: _x,
  global_filter_car: hx,
  global_filter_cat: fx,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: px,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: mx,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijke woning",
  global_filter_dishwasher: vx,
  global_filter_dog: yx,
  global_filter_dryer: kx,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: wx,
  global_filter_favorite: $x,
  global_filter_fireplace: xx,
  global_filter_flat: jx,
  global_filter_garden: zx,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: Cx,
  global_filter_guestPointsMin: Ox,
  global_filter_guestPointsMinMax: Ex,
  global_filter_gym: Sx,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: Dx,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: Nx,
  global_filter_isolated: Mx,
  global_filter_jacuzzi: Px,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: Ax,
  global_filter_luxury: Lx,
  global_filter_mountains: Tx,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: qx,
  global_filter_other: Ix,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: Bx,
  global_filter_playground: Rx,
  global_filter_primary: Fx,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: Hx,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: Wx,
  global_filter_river: Vx,
  global_filter_seaside: Gx,
  global_filter_secondary: Ux,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: Kx,
  global_filter_villages: Jx,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: Yx,
  global_filters: Zx,
  global_fixDates: Qx,
  global_flexDates_aMonth: Xx,
  global_flexDates_aWeekend: e1,
  global_flexDates_oneWeek: t1,
  global_flexDates_twoWeek: o1,
  global_flexibleDates: l1,
  global_guests: a1,
  global_homes: n1,
  global_lastMinute: i1,
  global_location: r1,
  global_modify: s1,
  global_name: c1,
  global_next: g1,
  global_numberOfAdults_zero: d1,
  global_numberOfAdults_one: u1,
  global_numberOfAdults_other: b1,
  global_numberOfBabies_zero: _1,
  global_numberOfBabies_one: h1,
  global_numberOfBabies_other: f1,
  global_numberOfChildren_zero: p1,
  global_numberOfChildren_one: m1,
  global_numberOfChildren_other: v1,
  global_numberOfGuests_zero: y1,
  global_numberOfGuests_one: k1,
  global_numberOfGuests_other: w1,
  global_phoneNumber_notValid: $1,
  global_receiveEmailAlerts: x1,
  global_save: j1,
  global_searchBar_noLocationFound: z1,
  global_seeMore_link: C1,
  global_travelWishlist: O1,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: E1,
  optional: S1,
  "privacy-policy": "Privacy"
}, N1 = {
  "global.collection.ishomeeligible": "Komt mijn huis in aanmerking?",
  "global.collection.joinnow": "Word nu lid",
  "global.collection.startfreetrial": "Begin je proefperiode van 14 dagen",
  "modal.collectionhp.eligibilitycheck.body": "Ons team zal zorgvuldig de details van je huis bekijken, inclusief foto's en voorzieningen, om te bepalen of het in aanmerking komt voor HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "Om je kansen op succes te maximaliseren, raden we je aan om alle voorzieningen van je huis te vermelden en foto's van hoge kwaliteittoe te voegen die de beste kenmerken van je huis belichten.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Mijn advertentie bijwerken",
  "modal.collectionhp.eligibilitycheck.title": "Is je huis klaar voor een beoordeling?",
  "page.collectionhp.benefitssection.body": "Word lid van onze luxe-huizenruilclub voor {{price}} per jaar en profiteer van onbeperkt ruilen met Collection-leden.<br/><br/>Geniet van gemoedsrust dankzij onze bescherming tegen annuleringen en dekking voor mogelijke schade aan je huis tijdens je uitwisselingen.<br/><br/>En als je in het eerste jaar geen ruil vindt, krijg je het tweede jaar gratis.",
  "page.collectionhp.benefitssection.body.fallback": "Word lid van onze luxe-huizenruilclub en profiteer van onbeperkt ruilen met Collection-leden.<br/><br/>Geniet van gemoedsrust dankzij onze bescherming tegen annuleringen en dekking voor mogelijke schade aan je huis tijdens je uitwisselingen.<br/><br/>En als je in het eerste jaar geen ruil vindt, krijg je het tweede jaar gratis.",
  "page.collectionhp.benefitssection.cta": "Bekijk alle voordelen",
  "page.collectionhp.benefitssection.home.location": "Peters huis in Dollar, Schotland",
  "page.collectionhp.benefitssection.title": "Alleen voor leden toegankelijke huizenruilgemeenschap",
  "page.collectionhp.contact.subtitle": "Onze ledenadviseurs staan klaar om al je vragen te beantwoorden.",
  "page.collectionhp.contact.title": "Meer informatie nodig?",
  "page.collectionhp.eligibilitycheck.label": "Je verzoek is in behandeling.",
  "page.collectionhp.faq.question1.body": 'Toegang tot de HomeExchange Collection-community is voorbehouden aan leden om ervoor te zorgen dat hun privacy volledig wordt gerespecteerd. Elk pand is zorgvuldig geselecteerd op basis van specifieke criteria, zoals interieur, locatie en voorzieningen. Met een Collection-lidmaatschap heb je toegang tot duizenden luxueuze woningen in meer dan 85 landen (vooral in de Verenigde Staten, Europa en Azië) </br></br> Je kunt een selectie van onze mooiste panden over de hele wereld bekijken door op deze <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">pagina </a> te klikken.',
  "page.collectionhp.faq.question1.title": "Waar kan ik alle beschikbare huizen bekijken?",
  "page.collectionhp.faq.question2.content": 'Het lidmaatschap van HomeExchange Collection is {{price}} per jaar. Het geeft je toegang tot een onbeperkt aantal uitwisselingen met leden van de HomeExchange Collection-gemeenschap gedurende twaalf maanden, terwijl je ook kunt uitwisselen met leden van de klassieke HomeExchange-gemeenschap, als je dat wilt.\\nOnze belofte: Als je geen uitwisseling tot stand kunt brengen in je eerste jaar, krijg je een tweede jaar gratis (<a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">zie voorwaarden</a>).\\nJe profiteert ook van garanties in geval van schade of annulering, evenals exclusieve diensten. Ontdek alle <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">voordelen van het lidmaatschap</a>.',
  "page.collectionhp.faq.question2.title": "Hoeveel kost het om lid te worden van HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": 'Het Collection-lidmaatschap dekt materiële schade tot $2.000.000. </br></br>Om meer te weten te komen over de garanties waarvan je profiteert als je lid bent en hoe ze werken, nodigen we je uit om een kijkje te nemen naar <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">deze pagina</a>.',
  "page.collectionhp.faq.question3.title": "Wat gebeurt er als ik of mijn gasten schade veroorzaken?",
  "page.collectionhp.faq.question4.content": 'Om je aan te melden voor HomeExchange Collection, vul je het aanmeldingsformulier in zodat we je huis of appartement kunnen evalueren. Je ontvangt binnen drie dagen een antwoord. Het lidmaatschapsgeld wordt alleen in rekening gebracht als je aanvraag wordt geaccepteerd. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Start je lidmaatschapsaanvraag.</a>',
  "page.collectionhp.faq.question4.title": "Hoe word ik lid?",
  "page.collectionhp.faq.question5.content": 'Gebruik dezelfde logingegevens voor HomeExchange Collection als voor HomeExchange en klik op "Word lid". Als we al hebben vastgesteld dat je woning voldoet aan de selectiecriteria voor HomeExchange Collection, word je automatisch doorgestuurd naar de betaalpagina. Als dat niet het geval is, nodigen we je uit om een e-mail te sturen naar <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a> zodat we je aanvraag kunnen behandelen en binnen drie dagen kunnen reageren.',
  "page.collectionhp.faq.question5.title": "Ik ben al lid van HomeExchange. Hoe word ik lid van HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": "Als je vragen hebt die hier niet staan, ga dan naar onze pagina met <linkFAQCollection> <b><u>veelgestelde vragen</u></b></linkFAQCollection><b> </b>. ",
  "page.collectionhp.faq.title": "Veelgestelde vragen",
  "page.collectionhp.header.elligible.subtilte": "Je bent uitgenodigd om lid te worden van onze exclusieve huizenruilgemeenschap.",
  "page.collectionhp.header.elligible.title": "Je huis komt in aanmerking voor Collection",
  "page.collectionhp.header.external.subtitle": "Word lid van een exclusieve gemeenschap van gelijkgestemde reizigers die overal ter wereld hun prachtige huizen uitwisselen.",
  "page.collectionhp.header.external.title": "Inspirerende huizen, onvergetelijke vakanties",
  "page.collectionhp.home1.location": "Parijs, Frankrijk",
  "page.collectionhp.home1.title": "Prachtig design-appartement",
  "page.collectionhp.home2.location": "Altea, Spanje",
  "page.collectionhp.home2.title": "Mediterraan huis",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Toevluchtsoord aan de rivier",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "Van adembenemende architectuur tot onovertroffen locaties: elk huis is zorgvuldig geselecteerd vanwege zijn uitzonderlijke kwaliteiten.",
  "page.collectionhp.homessection.title": "Duizenden uitwisselingsmogelijkheden met luxe-eigendommen",
  "page.collectionhp.howitwork.contact.cta": "Neem bij vragen contact op met onze ledenservice",
  "page.collectionhp.howitwork.elligible": "Je huis komt in aanmerking om deel uit te maken van onze Collection-community.",
  "page.collectionhp.howitwork.notelligible": "Helaas komt je huis niet in aanmerking.",
  "page.collectionhp.howitwork.step1.body": "Zorg ervoor dat je advertentie volledig is, inclusief foto's van je huis, zodat ons team snel kan reageren.",
  "page.collectionhp.howitwork.step1.title": "Controleer of je in aanmerking komt",
  "page.collectionhp.howitwork.step2.body": "Als je huis in aanmerking komt, zal je een uitnodiging ontvangen om lid te worden. Om je lidmaatschap te activeren, klik je op de link in de uitnodiging of ga je naar de lidmaatschapspagina in je account.",
  "page.collectionhp.howitwork.step2.title": "Word een Collection-lid",
  "page.collectionhp.howitwork.step3.body": "Zodra je je lidmaatschap activeert, kun je beginnen met het organiseren van onbeperkte uitwisselingen met Collection-huizen en genieten van de extra voordelen die bij je lidmaatschap horen.",
  "page.collectionhp.howitwork.step3.title": "Geniet van je lidmaatschap",
  "page.collectionhp.howitwork.title": "Hoe het werkt",
  "page.collectionhp.keybenefit1.body": "Al onze huizen zijn zorgvuldig geselecteerd door ons team op basis van hun interieur, locatie en voorzieningen. Alle huizen en leden worden geverifieerd om een veilige en betrouwbare community te garanderen.",
  "page.collectionhp.keybenefit1.title": "Geverifieerde selectie woningen",
  "page.collectionhp.keybenefit2.body": "Je geniet van bescherming tegen schade aan eigendommen tot $ 2.000.000 en dekking tot $ 350 per nacht in geval van annuleringen of onvoorziene gebeurtenissen. ",
  "page.collectionhp.keybenefit2.title": "Ongeëvenaarde garanties",
  "page.collectionhp.keybenefit3.body": "Je krijgt persoonlijke ondersteuning om je uitwisselingen soepel te laten verlopen. Bovendien omvat het lidmaatschap gratis professionele verbetering van je foto's. ",
  "page.collectionhp.keybenefit3.title": "Persoonlijke ondersteuning",
  "page.collectionhp.testimonie1.body": "We hebben vier kinderen, dus elke keer dat we op reis gingen en in een hotel verbleven, moesten we uiteindelijk drie kamers nemen. Toen kwamen we HomeExchange tegen en sinds we lid zijn, hebben we geweldige plekken bezocht. We zijn naar Dubai geweest, en zijn drie keer gaan skiën in Big Sky, Tahoe en Colorado.",
  "page.collectionhp.testimonie1.label": "De familie Miglino - Californië",
  "page.collectionhp.testimonie2.body": "HomeExchange is een unieke manier van reizen die je in staat stelt om een bestemming op een authentieke manier te ervaren en om connecties te maken en contact te houden met families lang nadat de uitwisseling is afgelopen.",
  "page.collectionhp.testimonie2.label": "De familie Eggleton - Florida",
  "page.collectionhp.testimonie3.body": "Ik herinner me een keer in New York, de kinderen waren nog erg jong, en er was een glijbaan in ons appartement, en ook al het speelgoed van de twee jongens van het gezin; onze jongens waren er dolblij mee! Onze gastheer gaf de naam van een oppas die ze regelmatig gebruiken, zodat we eens konden uitgaan in New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Parijs, Frankrijk",
  "page.collectionhp.testimonies.cta": "Maak kennis met onze leden",
  "page.collectionhp.testimonies.title": "Getuigenissen van leden",
  "page.collectionhp.whatis.body": "<Text>Wij geloven dat luxe heel persoonlijk is. Voor sommigen is het een afgelegen toevluchtsoord omringd door adembenemende uitzichten. Voor anderen is het een architectonisch meesterwerk genesteld in het hart van een van 's werelds meest levendige steden. </Text><Text>Ons Collection-aanbod legt deze opmerkelijke diversiteit vast. Het is net zo uniek als onze gemeenschap, maar alle huizen delen één bepalende kwaliteit: ze laten je met ontzag achter zodra je binnenstapt.</Text>",
  "page.collectionhp.whatis.title": "Wat is een Collection-huis?"
}, M1 = "Studio", P1 = "{{count}} quarto", A1 = "{{count}} quartos", L1 = "", T1 = "{{count}} cama", q1 = "{{count}} camas", I1 = "", B1 = "", R1 = "O seu calendário foi atualizado.", F1 = "Um mês", H1 = "Datas exatas", W1 = "Uma semana", V1 = "Um fim de semana", G1 = "", U1 = "± {{count}} dia", K1 = "± {{count]] dias", J1 = "Duas semanas", Y1 = "Cancelar", Z1 = "", Q1 = "Datas", X1 = "Eliminar", ej = "Descrição", tj = "Destino", oj = "Feito!", lj = "Editar", aj = "Qualquer tipo de pedido de Troca", nj = "Banheiro", ij = "BBQ", rj = "Bicicleta", sj = "Carro", cj = "Gato", gj = "Cidade", dj = "Campo", uj = "Lavadora de louças", bj = "Cão", _j = "Secadora", hj = "Elevador", fj = "Casas favoritas", pj = "Lareira", mj = "Apartamento", vj = "Quintal privado", yj = "", kj = "", wj = "", $j = "", xj = "Casa", jj = "Ilha", zj = "Isolada", Cj = "Jacuzzi", Oj = "Lagos", Ej = "Casas Collection", Sj = "", Dj = "{{count}} casas de banho", Nj = "Outros animais", Mj = "Piano", Pj = "Parque infantil", Aj = "Principal", Lj = "Troca Reciproca", Tj = "Busca invertida", qj = "Rio", Ij = "Litoral", Bj = "Secundária", Rj = "TV", Fj = "Aldeia", Hj = "WiFi", Wj = "Filtros", Vj = "Datas fixas", Gj = "Um mês em {{date}}", Uj = "Um fim de semana em {{date}}", Kj = "Uma semana em {{date}}", Jj = "Duas semanas em {{date}}", Yj = "Datas flexíveis", Zj = "Convidados", Qj = "casas", Xj = "Última hora", ez = "Localização", tz = "Modificar", oz = "Nome", lz = "Seguinte", az = "", nz = "{{count}} adulto", iz = "{{count}} adultos", rz = "", sz = "{{count}} bebé", cz = "{{count}} bebés", gz = "", dz = "{{count}} criança", uz = "{{count}} crianças", bz = "", _z = "{{count}} convidado", hz = "{{count}} convidados", fz = "O formato do número de telefone não é válido.", pz = "Receber alertas por e-mail", mz = "Guardar", vz = "Não foram encontradas localizações", yz = "Ver mais", kz = "Ideias de viagens", wz = "", $z = "", xz = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: M1,
  bedroomsNumbers_one: P1,
  bedroomsNumbers_other: A1,
  beds_zero: L1,
  beds_one: T1,
  beds_other: q1,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: I1,
  global_babies: B1,
  global_calendarUpdated_toast: R1,
  global_calendar_aMonth: F1,
  global_calendar_exactDates: H1,
  global_calendar_oneWeek: W1,
  global_calendar_oneWeekend: V1,
  global_calendar_plusMinusDay_zero: G1,
  global_calendar_plusMinusDay_one: U1,
  global_calendar_plusMinusDay_other: K1,
  global_calendar_twoWeeks: J1,
  global_cancel: Y1,
  global_children: Z1,
  global_dates: Q1,
  global_delete: X1,
  global_description: ej,
  global_destination: tj,
  global_done: oj,
  global_edit: lj,
  "global_filter_a-c": "A/C",
  global_filter_available: aj,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: nj,
  global_filter_bbq: ij,
  global_filter_bicycle: rj,
  global_filter_car: sj,
  global_filter_cat: cj,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: gj,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: dj,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: uj,
  global_filter_dog: bj,
  global_filter_dryer: _j,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: hj,
  global_filter_favorite: fj,
  global_filter_fireplace: pj,
  global_filter_flat: mj,
  global_filter_garden: vj,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: yj,
  global_filter_guestPointsMin: kj,
  global_filter_guestPointsMinMax: wj,
  global_filter_gym: $j,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: xj,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: jj,
  global_filter_isolated: zj,
  global_filter_jacuzzi: Cj,
  "global_filter_kids-toys": "",
  global_filter_lakes: Oj,
  global_filter_luxury: Ej,
  global_filter_mountains: Sj,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: Dj,
  global_filter_other: Nj,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: Mj,
  global_filter_playground: Pj,
  global_filter_primary: Aj,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: Lj,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: Tj,
  global_filter_river: qj,
  global_filter_seaside: Ij,
  global_filter_secondary: Bj,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: Rj,
  global_filter_villages: Fj,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: Hj,
  global_filters: Wj,
  global_fixDates: Vj,
  global_flexDates_aMonth: Gj,
  global_flexDates_aWeekend: Uj,
  global_flexDates_oneWeek: Kj,
  global_flexDates_twoWeek: Jj,
  global_flexibleDates: Yj,
  global_guests: Zj,
  global_homes: Qj,
  global_lastMinute: Xj,
  global_location: ez,
  global_modify: tz,
  global_name: oz,
  global_next: lz,
  global_numberOfAdults_zero: az,
  global_numberOfAdults_one: nz,
  global_numberOfAdults_other: iz,
  global_numberOfBabies_zero: rz,
  global_numberOfBabies_one: sz,
  global_numberOfBabies_other: cz,
  global_numberOfChildren_zero: gz,
  global_numberOfChildren_one: dz,
  global_numberOfChildren_other: uz,
  global_numberOfGuests_zero: bz,
  global_numberOfGuests_one: _z,
  global_numberOfGuests_other: hz,
  global_phoneNumber_notValid: fz,
  global_receiveEmailAlerts: pz,
  global_save: mz,
  global_searchBar_noLocationFound: vz,
  global_seeMore_link: yz,
  global_travelWishlist: kz,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: wz,
  optional: $z,
  "privacy-policy": "Privacidade"
}, jz = {
  "global.collection.ishomeeligible": "A minha casa é elegível?",
  "global.collection.joinnow": "Aderir agora",
  "global.collection.startfreetrial": "Iniciar o período experimental grátis de 14 dias",
  "modal.collectionhp.eligibilitycheck.body": "",
  "modal.collectionhp.eligibilitycheck.callout.body": "",
  "modal.collectionhp.eligibilitycheck.callout.link": "",
  "modal.collectionhp.eligibilitycheck.title": "",
  "page.collectionhp.benefitssection.body": "",
  "page.collectionhp.benefitssection.body.fallback": "",
  "page.collectionhp.benefitssection.cta": "",
  "page.collectionhp.benefitssection.home.location": "",
  "page.collectionhp.benefitssection.title": "",
  "page.collectionhp.contact.subtitle": "",
  "page.collectionhp.contact.title": "",
  "page.collectionhp.eligibilitycheck.label": "",
  "page.collectionhp.faq.question1.body": "",
  "page.collectionhp.faq.question1.title": "",
  "page.collectionhp.faq.question2.content": "",
  "page.collectionhp.faq.question2.title": "",
  "page.collectionhp.faq.question3.content": "",
  "page.collectionhp.faq.question3.title": "",
  "page.collectionhp.faq.question4.content": "",
  "page.collectionhp.faq.question4.title": "",
  "page.collectionhp.faq.question5.content": "",
  "page.collectionhp.faq.question5.title": "",
  "page.collectionhp.faq.subtitle": "",
  "page.collectionhp.faq.title": "",
  "page.collectionhp.header.elligible.subtilte": "Está convidado(a) a aderir à nossa comunidade exclusiva de troca de casas.",
  "page.collectionhp.header.elligible.title": "A sua casa é elegível para a Collection",
  "page.collectionhp.header.external.subtitle": "Junte-se a uma comunidade exclusiva de viajantes com mentalidade semelhante, que trocam as suas casas notáveis em todo o mundo.",
  "page.collectionhp.header.external.title": "Casas que inspiram, viagens que ficam na memória",
  "page.collectionhp.home1.location": "",
  "page.collectionhp.home1.title": "",
  "page.collectionhp.home2.location": "",
  "page.collectionhp.home2.title": "",
  "page.collectionhp.home3.location": "",
  "page.collectionhp.home3.title": "",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "",
  "page.collectionhp.homessection.title": "",
  "page.collectionhp.howitwork.contact.cta": "",
  "page.collectionhp.howitwork.elligible": "",
  "page.collectionhp.howitwork.notelligible": "",
  "page.collectionhp.howitwork.step1.body": "",
  "page.collectionhp.howitwork.step1.title": "",
  "page.collectionhp.howitwork.step2.body": "",
  "page.collectionhp.howitwork.step2.title": "",
  "page.collectionhp.howitwork.step3.body": "",
  "page.collectionhp.howitwork.step3.title": "",
  "page.collectionhp.howitwork.title": "",
  "page.collectionhp.keybenefit1.body": "",
  "page.collectionhp.keybenefit1.title": "",
  "page.collectionhp.keybenefit2.body": "",
  "page.collectionhp.keybenefit2.title": "",
  "page.collectionhp.keybenefit3.body": "",
  "page.collectionhp.keybenefit3.title": "",
  "page.collectionhp.testimonie1.body": "",
  "page.collectionhp.testimonie1.label": "",
  "page.collectionhp.testimonie2.body": "",
  "page.collectionhp.testimonie2.label": "",
  "page.collectionhp.testimonie3.body": "",
  "page.collectionhp.testimonie3.label": "",
  "page.collectionhp.testimonies.cta": "",
  "page.collectionhp.testimonies.title": "",
  "page.collectionhp.whatis.body": "",
  "page.collectionhp.whatis.title": ""
}, zz = "Studio", Cz = "{{count}} sovrum", Oz = "{{count}} sovrum", Ez = "", Sz = "{{count}} säng", Dz = "{{count}} sängar", Nz = "Vuxna", Mz = "Småbarn", Pz = "Din kalender har uppdaterats.", Az = "En månad", Lz = "Exakta datum", Tz = "En vecka", qz = "En helg", Iz = "", Bz = "± {{count}} dag", Rz = "± {{count}} dagar", Fz = "Två veckor", Hz = "Avbryt", Wz = "Barn", Vz = "Datum", Gz = "Ta bort", Uz = "Beskrivning", Kz = "Resmål", Jz = "Klart!", Yz = "Ändra", Zz = "Alla typer av hembyten", Qz = "Badkar", Xz = "Grill", eC = "Cykel", tC = "Bil", oC = "Katt", lC = "Stad", aC = "Landsbygd", nC = "Diskmaskin", iC = "Hund", rC = "Torktumlare", sC = "Hiss", cC = "Favorithem", gC = "Eldstad", dC = "Lägenhet", uC = "Privat trädgård", bC = "Mindre än {{max}} GP", _C = "från {{min}} GP", hC = "Mellan {{min}} och {{max}} GuestPoints", fC = "Hemmagym", pC = "Hus", mC = "Ö", vC = "Isolerat", yC = "Jacuzzi", kC = "Sjö", wC = "Collection-hem", $C = "Berg", xC = "{{count}} badrum", jC = "Andra djur", zC = "Piano", CC = "Lekplats för barn", OC = "Primärt", EC = "Ömsesidigt hembyte", SC = "Omvänd sökning", DC = "Älv", NC = "Kustnära", MC = "Sekundärt", PC = "TV", AC = "By", LC = "WiFi", TC = "Filter", qC = "Fasta datum", IC = "En månad i {{date}}", BC = "En helg i {{date}}", RC = "En vecka i {{date}}", FC = "Två veckor i {{date}}", HC = "Flexibla datum", WC = "Gäster", VC = "hem", GC = "Sista minuten", UC = "Plats", KC = "Ändra", JC = "Namn", YC = "Nästa", ZC = "", QC = "{{count}} vuxen", XC = "{{count}} vuxna", eO = "", tO = "{{count}} bebis", oO = "{{count}} bebisar", lO = "", aO = "{{count}} barn", nO = "{{count}} barn", iO = "", rO = "{{count}} gäst", sO = "{{count}} gäster", cO = "Telefonnumrets format är inte giltigt.", gO = "Få e-postaviseringar", dO = "Spara", uO = "Inga resmål hittades", bO = "Se mer", _O = "Reselista", hO = "", fO = "valfritt", pO = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: zz,
  bedroomsNumbers_one: Cz,
  bedroomsNumbers_other: Oz,
  beds_zero: Ez,
  beds_one: Sz,
  beds_other: Dz,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: Nz,
  global_babies: Mz,
  global_calendarUpdated_toast: Pz,
  global_calendar_aMonth: Az,
  global_calendar_exactDates: Lz,
  global_calendar_oneWeek: Tz,
  global_calendar_oneWeekend: qz,
  global_calendar_plusMinusDay_zero: Iz,
  global_calendar_plusMinusDay_one: Bz,
  global_calendar_plusMinusDay_other: Rz,
  global_calendar_twoWeeks: Fz,
  global_cancel: Hz,
  global_children: Wz,
  global_dates: Vz,
  global_delete: Gz,
  global_description: Uz,
  global_destination: Kz,
  global_done: Jz,
  global_edit: Yz,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: Zz,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: Qz,
  global_filter_bbq: Xz,
  global_filter_bicycle: eC,
  global_filter_car: tC,
  global_filter_cat: oC,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: lC,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: aC,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: nC,
  global_filter_dog: iC,
  global_filter_dryer: rC,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: sC,
  global_filter_favorite: cC,
  global_filter_fireplace: gC,
  global_filter_flat: dC,
  global_filter_garden: uC,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: bC,
  global_filter_guestPointsMin: _C,
  global_filter_guestPointsMinMax: hC,
  global_filter_gym: fC,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: pC,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: mC,
  global_filter_isolated: vC,
  global_filter_jacuzzi: yC,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: kC,
  global_filter_luxury: wC,
  global_filter_mountains: $C,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: xC,
  global_filter_other: jC,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: zC,
  global_filter_playground: CC,
  global_filter_primary: OC,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: EC,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: SC,
  global_filter_river: DC,
  global_filter_seaside: NC,
  global_filter_secondary: MC,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: PC,
  global_filter_villages: AC,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: LC,
  global_filters: TC,
  global_fixDates: qC,
  global_flexDates_aMonth: IC,
  global_flexDates_aWeekend: BC,
  global_flexDates_oneWeek: RC,
  global_flexDates_twoWeek: FC,
  global_flexibleDates: HC,
  global_guests: WC,
  global_homes: VC,
  global_lastMinute: GC,
  global_location: UC,
  global_modify: KC,
  global_name: JC,
  global_next: YC,
  global_numberOfAdults_zero: ZC,
  global_numberOfAdults_one: QC,
  global_numberOfAdults_other: XC,
  global_numberOfBabies_zero: eO,
  global_numberOfBabies_one: tO,
  global_numberOfBabies_other: oO,
  global_numberOfChildren_zero: lO,
  global_numberOfChildren_one: aO,
  global_numberOfChildren_other: nO,
  global_numberOfGuests_zero: iO,
  global_numberOfGuests_one: rO,
  global_numberOfGuests_other: sO,
  global_phoneNumber_notValid: cO,
  global_receiveEmailAlerts: gO,
  global_save: dO,
  global_searchBar_noLocationFound: uO,
  global_seeMore_link: bO,
  global_travelWishlist: _O,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: hO,
  optional: fO,
  "privacy-policy": "Sekretesspolicy"
}, mO = {
  "global.collection.ishomeeligible": "Är mitt hem kvalificerat?",
  "global.collection.joinnow": "Gå med nu",
  "global.collection.startfreetrial": "Starta en 14-dagars gratis provperiod",
  "modal.collectionhp.eligibilitycheck.body": "Vårt team kommer att granska ditt hems uppgifter noggrant, inklusive foton och faciliteter för att avgöra om det är kvalificerat för HomeExchange Collection.",
  "modal.collectionhp.eligibilitycheck.callout.body": "För att maximera dina chanser att lyckas rekommenderar vi att du listar alla faciliteter i ditt hem och laddar upp högkvalitativa foton som belyser de bästa egenskaperna.",
  "modal.collectionhp.eligibilitycheck.callout.link": "Uppdatera min hemprofil",
  "modal.collectionhp.eligibilitycheck.title": "Är ditt hem redo för granskning?",
  "page.collectionhp.benefitssection.body": "Gå med i vår hembytesklubb för {{price}} per år och gör ett obegränsat antal hembyten med Collection-medlemmar.<br/><br/>Känn sinnesro med vårt avbokningsskydd och försäkringar mot skador i hemmet under hembyten.<br/><br/>Om du dessutom inte hittar ett hembyte under det första året får du andra året gratis.",
  "page.collectionhp.benefitssection.body.fallback": "Gå med i vår hembytesklubb och gör ett obegränsat antal hembyten med Collection-medlemmar.<br/><br/>Känn sinnesro med vårt avbokningsskydd och försäkringar mot skador i hemmet under hembyten.<br/><br/>Om du dessutom inte hittar ett hembyte under det första året får du andra året gratis.",
  "page.collectionhp.benefitssection.cta": "Se alla fördelar",
  "page.collectionhp.benefitssection.home.location": "Peters hem i Dollar, Skottland",
  "page.collectionhp.benefitssection.title": "Hembytesgemenskap – Endast för medlemmar",
  "page.collectionhp.contact.subtitle": "Våra medlemsrådgivare finns tillgängliga att svara på alla frågor du kan tänkas ha.",
  "page.collectionhp.contact.title": "Behöver du mer information?",
  "page.collectionhp.eligibilitycheck.label": "Din begäran om kvalificering granskas.",
  "page.collectionhp.faq.question1.body": 'Åtkomst till HomeExchange Collection-communityn är reserverad för medlemmar för att säkerställa att deras integritet respekteras fullt ut. Varje fastighet har omsorgsfullt valts ut enligt specifika kriterier som design, plats och faciliteter. Med ett Collection-medlemskap har du tillgång till tusentals lyxhem i över 85 länder (främst i USA, Europa och Asien) </br></br>\u2028Du kan se ett urval av våra vackraste fastigheter runt om i världen på <a href="https://www.homeexchange.com/p/browse-collection-homes" target="_blank">denna sida</a>.',
  "page.collectionhp.faq.question1.title": "Var kan jag se alla tillgängliga hem?",
  "page.collectionhp.faq.question2.content": 'Medlemskapet hos HomeExchange Collection kostar {{price}}  per år. Det ger dig möjlighet att göra ett obegränsat antal hembyten med medlemmar i HomeExchange Collection-communityn under tolv månader, samtidigt som du kan byta hem med medlemmar i den klassiska HomeExchange-communityn om du vill det. Vårt löfte är: Om du inte lyckas bekräfta ett hembyte under det första årets medlemskap ger vi dig andra året gratis, <a href="https://homeexchangecollection.zendesk.com/hc/en-us/articles/4711780983709-Our-guarantee-for-the-first-year-of-your-membership" target="_blank">se villkoren här.</a> Du kan också använda våra garantier vid skador eller avbokningar, samt alla våra exklusiva tjänster. Se alla <a href="https://www.homeexchange.com/p/collection-membership-benefits-price" target="_blank">fördelar med medlemskapet</a> i detalj.',
  "page.collectionhp.faq.question2.title": "Hur mycket kostar det att gå med i HomeExchange Collection?",
  "page.collectionhp.faq.question3.content": 'Collection-medlemskapet täcker fastighetsskador upp till 2 000 000 $. </br></br> För att få reda på mer om garantierna som du kan nyttja när du blir medlem och hur de fungerar – ta en titt på <a href="https://homeexchangecollection.zendesk.com/hc/en-us/categories/11995839753757-HomeExchange-Collection-Guarantees" target="_blank">den här sidan</a>.',
  "page.collectionhp.faq.question3.title": "Vad händer om mina gäster eller jag orsakar skada?",
  "page.collectionhp.faq.question4.content": 'För att ansöka till HomeExchange Collection, fyll i ansökningsformuläret, så att vi kan utvärdera ditt hus eller lägenhet. Vi kommer att svara dig inom tre dagar. Medlemsavgiften kommer endast att debiteras om din ansökan godkänns. <a href="https://www.homeexchange.com/collection/propose-my-home" target="_blank">Starta din medlemsansökan.</a>',
  "page.collectionhp.faq.question4.title": "Hur går jag med?",
  "page.collectionhp.faq.question5.content": 'Logga in till HomeExchange Collection med samma inloggning och lösenord som för HomeExchange och klicka på "Bli medlem". Om vi redan har identifierat att din fastighet uppfyller urvalskriterierna för HomeExchange Collection så kommer du automatiskt att omdirigeras till betalningssidan. Om inte får du gärna maila oss på <a href="mailto:joincollection@homeexchange.com">joincollection@homeexchange.com</a> så att vi kan granska din ansökan och svara dig inom tre dagar.',
  "page.collectionhp.faq.question5.title": "Jag är redan en medlem hos HomeExchange. Hur går jag med i HomeExchange Collection?",
  "page.collectionhp.faq.subtitle": "Om du har några frågor som inte finns här, besök vår <linkFAQCollection> <b><u>FAQ-sida</u></b></linkFAQCollection><b> </b>.",
  "page.collectionhp.faq.title": "Vanliga frågor",
  "page.collectionhp.header.elligible.subtilte": "Du har bjudits in till vår exklusiva hembytesgemenskap.",
  "page.collectionhp.header.elligible.title": "Ditt hem är kvalificerat för Collection",
  "page.collectionhp.header.external.subtitle": "Gå med i en exklusiv community med likasinnade resenärer som byter sina otroliga hem världen över.",
  "page.collectionhp.header.external.title": "Hem som inspirerar, resor du aldrig glömmer",
  "page.collectionhp.home1.location": "Paris, Frankrike",
  "page.collectionhp.home1.title": "Underbara designerlägenheter",
  "page.collectionhp.home2.location": "Altea, Spanien",
  "page.collectionhp.home2.title": "Medelhavsvilla",
  "page.collectionhp.home3.location": "Portland, Oregon",
  "page.collectionhp.home3.title": "Pärla vid stranden",
  "page.collectionhp.homessection.browse-home.link": "/p/view-collection-homes",
  "page.collectionhp.homessection.subtitle": "Från enastående arkitektur till oslagbara platser, varje hem är handplockat för dess exceptionella kvaliteter.",
  "page.collectionhp.homessection.title": "Tusentals hembytesmöjligheter med lyxiga fastigheter",
  "page.collectionhp.howitwork.contact.cta": "Kontakta medlemssupporten om du har några frågor",
  "page.collectionhp.howitwork.elligible": "Ditt hem är kvalificerat att gå med i vår Collection-community.",
  "page.collectionhp.howitwork.notelligible": "Tyvärr är inte ditt hem kvalificerat.",
  "page.collectionhp.howitwork.step1.body": "Se till att din hemprofil är komplett, med foton av ditt hem, så att vårt team kan ge ett snabbt svar.",
  "page.collectionhp.howitwork.step1.title": "Se om du är kvalificerad",
  "page.collectionhp.howitwork.step2.body": "Om ditt hem är kvalificerat kommer du att få en inbjudan att gå med. För att aktivera ditt medlemskap, klicka bara på länken i din inbjudan eller besök medlemssidan på ditt konto.",
  "page.collectionhp.howitwork.step2.title": "Bli Collection-medlem",
  "page.collectionhp.howitwork.step3.body": "När du aktiverar ditt medlemskap kan du anordna ett obegränsat antal hembyten med Collection-hem och ta del av de extra förmånerna som ditt medlemskap innehåller.",
  "page.collectionhp.howitwork.step3.title": "Få medlemskapets fördelar",
  "page.collectionhp.howitwork.title": "Hur det fungerar",
  "page.collectionhp.keybenefit1.body": "Alla våra hem har valts ut noggrant av vårt team baserat på deras design, plats och faciliteter. Alla hem och medlemmar är verifierade för att säkerställa en trygg och pålitlig community.",
  "page.collectionhp.keybenefit1.title": "Verifierat urval av hem",
  "page.collectionhp.keybenefit2.body": "Du får ett skydd mot egendomsskada upp till 2 000 000 $ och försäkring på upp till 350 $ per natt vid avbokningar eller oförutsedda händelser.",
  "page.collectionhp.keybenefit2.title": "Omatchade garantier",
  "page.collectionhp.keybenefit3.body": "Du får personlig support, vilket gör dina hembyten smidiga. Medlemskapet innehåller även gratis professionell bildförbättring för din hemprofil.",
  "page.collectionhp.keybenefit3.title": "Personlig support",
  "page.collectionhp.testimonie1.body": "Vi har fyra barn, så varje gång vi reser och bor på hotell har vi behövt boka tre rum. Sedan hittade vi HomeExchange och efter att vi gick med har vi kunnat besöka fantastiska platser. Vi har åkt till Dubai, varit på tre skidresor i Big Sky, Tahoe och Colorado.",
  "page.collectionhp.testimonie1.label": "Familjen Miglino - Kalifornien",
  "page.collectionhp.testimonie2.body": "HomeExchange är en unik typ av resande då det både ger dig chansen att uppleva ett resmål och skapa nya vänskaper och hålla kontakten med andra familjer efter hembytet.",
  "page.collectionhp.testimonie2.label": "Familjen Eggleton - Florida",
  "page.collectionhp.testimonie3.body": "Jag minns en gång i New York, barnen var fortfarande väldigt små, och det fanns en rutschkana i vår hembyteslägenhet, samt en massa leksaker från den andra familjens två pojkar. Våra pojkar var överlyckliga! Vår värd delade namnet på en barnvakt som de använde regelbundet, vilket gjorde att vi kunde gå ut i New York.",
  "page.collectionhp.testimonie3.label": "Laetitia - Paris, Frankrike",
  "page.collectionhp.testimonies.cta": "Möt våra medlemmar",
  "page.collectionhp.testimonies.title": "Medlemsberättelser",
  "page.collectionhp.whatis.body": "<Text>Vi anser att lyx är något djupt personligt. För en del handlar det om ett avskilt paradis omgivet av enastående naturmiljöer. För andra är det ett arkitektoniskt mästerverk i centrum av någon av världens mest pulserande städer.</Text><Text>Vår Collection fångar denna fantastiska mångfald. Det är lika unikt som vår community, men ändå delar alla våra hem en utmärkande kvalitet: de får dig att tappa hakan i det ögonblick du kliver in i dem.</Text>",
  "page.collectionhp.whatis.title": "Vad är ett Collection-hem?"
}, vO = "en", ra = Ms({
  fallbackLng: vO,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      landingPage: zg,
      common: jg
    },
    de: {
      landingPage: vu,
      common: mu
    },
    en: {
      common: d_,
      landingPage: u_
    },
    es: {
      common: af,
      landingPage: nf
    },
    fr: {
      common: Qp,
      landingPage: Xp
    },
    hr: {
      common: Qv,
      landingPage: Xv
    },
    it: {
      common: Vk,
      landingPage: Gk
    },
    nb: {
      common: q$,
      landingPage: I$
    },
    nl: {
      common: D1,
      landingPage: N1
    },
    pt: {
      common: xz,
      landingPage: jz
    },
    sv: {
      common: pO,
      landingPage: mO
    }
  }
});
ra.init();
const Vo = ra, sa = Yo(void 0), Go = (t) => {
  let e;
  const o = /* @__PURE__ */ new Set(), l = (s, d) => {
    const u = typeof s == "function" ? s(e) : s;
    if (!Object.is(u, e)) {
      const b = e;
      e = d ?? (typeof u != "object" || u === null) ? u : Object.assign({}, e, u), o.forEach((f) => f(e, b));
    }
  }, a = () => e, i = { setState: l, getState: a, getInitialState: () => c, subscribe: (s) => (o.add(s), () => o.delete(s)) }, c = e = t(l, a, i);
  return i;
}, yO = (t) => t ? Go(t) : Go, kO = (t) => t;
function wO(t, e = kO) {
  const o = S.useSyncExternalStore(
    t.subscribe,
    S.useCallback(() => e(t.getState()), [t, e]),
    S.useCallback(() => e(t.getInitialState()), [t, e])
  );
  return S.useDebugValue(o), o;
}
function $O(t) {
  const e = {
    config: {
      apiUrl: "",
      assetsUrl: "",
      locale: "fr",
      currency: "EUR"
    }
  };
  return yO((o) => ({
    ...e,
    ...t,
    setConfig: (l) => o({ config: l })
  }));
}
function xO({ children: t, ...e }) {
  const { config: o } = e, { apiUrl: l, locale: a, tokens: n } = o, { accessToken: r, refreshToken: i } = n || {};
  ca(l), Vo.changeLanguage(a), r && (document.cookie = `access_token=${r}; path=/; secure; samesite=strict`), i && (document.cookie = `refresh_token=${i}; path=/; secure; samesite=strict`);
  const c = Ge(null);
  return c.current || (c.current = $O(e)), /* @__PURE__ */ g(sa.Provider, { value: c.current, children: /* @__PURE__ */ g(Ha, { i18n: Vo, children: t }) });
}
const Uo = (t) => Symbol.iterator in t, Ko = (t) => (
  // HACK: avoid checking entries type
  "entries" in t
), Jo = (t, e) => {
  const o = t instanceof Map ? t : new Map(t.entries()), l = e instanceof Map ? e : new Map(e.entries());
  if (o.size !== l.size)
    return !1;
  for (const [a, n] of o)
    if (!l.has(a) || !Object.is(n, l.get(a)))
      return !1;
  return !0;
}, jO = (t, e) => {
  const o = t[Symbol.iterator](), l = e[Symbol.iterator]();
  let a = o.next(), n = l.next();
  for (; !a.done && !n.done; ) {
    if (!Object.is(a.value, n.value))
      return !1;
    a = o.next(), n = l.next();
  }
  return !!a.done && !!n.done;
};
function zO(t, e) {
  return Object.is(t, e) ? !0 : typeof t != "object" || t === null || typeof e != "object" || e === null || Object.getPrototypeOf(t) !== Object.getPrototypeOf(e) ? !1 : Uo(t) && Uo(e) ? Ko(t) && Ko(e) ? Jo(t, e) : jO(t, e) : Jo(
    { entries: () => Object.entries(t) },
    { entries: () => Object.entries(e) }
  );
}
function CO(t) {
  const e = S.useRef(void 0);
  return (o) => {
    const l = t(o);
    return zO(e.current, l) ? e.current : e.current = l;
  };
}
function ie(t) {
  const e = Wt(sa);
  if (!e) throw new Error("Missing LandingPageContext.Provider in the tree");
  return wO(e, CO(t));
}
function OO(t) {
  return "user" in t;
}
const at = {
  CHECKED_MAYBE: "CHECKED_MAYBE",
  CHECKED_ELIGIBLE: "CHECKED_ELIGIBLE",
  CHECKED_NOT_ELIGIBLE: "CHECKED_NOT_ELIGIBLE",
  NOT_CHECKED: "NOT_CHECKED"
}, L = {
  ELIGIBLE_DONE_TRIAL: "ELIGIBLE_DONE_TRIAL",
  ELIGIBLE_NOT_DONE_TRIAL: "ELIGIBLE_NOT_DONE_TRIAL",
  NOT_CHECKED_OR_MAYBE: "NOT_CHECKED_OR_MAYBE",
  NO_HOME: "NO_HOME",
  NOT_ELIGIBLE: "NOT_ELIGIBLE",
  UNLOGGED: "UNLOGGED"
}, EO = ({ landingPageData: t, isButtonDisabled: e, setIsButtonDisabled: o }) => {
  const { t: l } = ae(["landingPage", "common"]), [a, n] = F(!1), { isMobile: r } = ue(), {
    config: { assetsUrl: i }
  } = ie((k) => ({ config: k.config })), { refetch: c, loading: s } = lo({
    promiseFn: la,
    enabled: !1
  }), d = () => {
    H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "start_free_trial"
    }, {
      eventCallback: () => window.location.href = "/collection/subscription/payment?start-trial=true",
      eventTimeout: 2e3
    });
  }, u = () => {
    H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "join_now"
    }, {
      eventCallback: () => window.location.href = "/collection/subscription/payment",
      eventTimeout: 2e3
    });
  }, b = () => {
    H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "create_home"
    }, {
      eventCallback: () => window.location.href = "/homes/create",
      eventTimeout: 2e3
    });
  }, f = () => {
    H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "propose_home"
    }, {
      eventCallback: () => window.location.href = "/collection/propose-my-home",
      eventTimeout: 2e3
    });
  }, p = () => {
    n(!0);
  }, h = async () => {
    t.home?.id && (await c(t.home.id), H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "check_eligibility"
    }), o(!0));
  }, m = [
    {
      status: L.ELIGIBLE_DONE_TRIAL,
      subtitle: "page.collectionhp.header.elligible.subtilte",
      mainButton: {
        text: "global.collection.joinnow",
        onClick: u
      }
    },
    {
      status: L.ELIGIBLE_NOT_DONE_TRIAL,
      subtitle: "page.collectionhp.header.elligible.subtilte",
      freeTrialButton: { text: "global.collection.startfreetrial", onClick: d },
      mainButton: {
        text: "global.collection.joinnow",
        onClick: u
      }
    },
    {
      status: L.NOT_CHECKED_OR_MAYBE,
      subtitle: "page.collectionhp.header.external.subtitle",
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: p
      }
    },
    {
      status: L.NOT_ELIGIBLE,
      subtitle: "page.collectionhp.header.external.subtitle"
    },
    {
      status: L.NO_HOME,
      subtitle: "page.collectionhp.header.external.subtitle",
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: b
      }
    },
    {
      status: L.UNLOGGED,
      subtitle: "page.collectionhp.header.external.subtitle",
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: f
      }
    }
  ].find((k) => k.status === t.status), w = t.status === L.NOT_CHECKED_OR_MAYBE && e, y = t.home?.imgSrc ? `${t.home.imgSrc}?quality=100&width=1080` : `${i}/landing-page/landing-page-collection.jpg`;
  return m && /* @__PURE__ */ g(is, { imagePosition: "side", size: r ? "auto" : "large", imageSrc: y, children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ g(J, { level: 1, hasHeaderTag: !0, children: l(
      m.status === "ELIGIBLE_DONE_TRIAL" || m.status === "ELIGIBLE_NOT_DONE_TRIAL" ? "page.collectionhp.header.elligible.title" : "page.collectionhp.header.external.title"
    ) }),
    /* @__PURE__ */ g(P, { size: "xl", children: l(m.subtitle) }),
    /* @__PURE__ */ C(gn, { children: [
      m?.freeTrialButton && /* @__PURE__ */ g(
        Y,
        {
          size: "regular",
          text: l(m?.freeTrialButton.text),
          color: "primary",
          onClick: m?.freeTrialButton.onClick,
          isLoading: s
        }
      ),
      m.mainButton && /* @__PURE__ */ g(
        Y,
        {
          size: "regular",
          text: l(m?.mainButton.text),
          color: m?.freeTrialButton ? "tertiary" : "primary",
          onClick: m?.mainButton.onClick,
          disabled: w
        }
      )
    ] }),
    w && /* @__PURE__ */ g(P, { children: l("page.collectionhp.eligibilitycheck.label") }),
    /* @__PURE__ */ g(
      oa,
      {
        isModalOpen: a,
        setIsModalOpen: n,
        isLoading: s,
        onConfirmIsMyHomeEligible: h,
        homeId: t.home?.id
      }
    )
  ] }) });
}, SO = () => {
  const {
    config: { assetsUrl: t }
  } = ie((n) => ({ config: n.config })), { isTablet: e, isMobile: o } = ue(), l = [
    {
      imgSrc: `${t}/landing-page/bazaar.svg`,
      imgAlt: "Bazaar"
    },
    {
      imgSrc: `${t}/landing-page/vogue.svg`,
      imgAlt: "Vogue"
    },
    {
      imgSrc: `${t}/landing-page/haute-living.svg`,
      imgAlt: "Haute living"
    },
    {
      imgSrc: `${t}/landing-page/robbreport.svg`,
      imgAlt: "Robb report"
    },
    {
      imgSrc: `${t}/landing-page/travel-and-leisure.svg`,
      imgAlt: "travel and leisure"
    },
    {
      imgSrc: `${t}/landing-page/conde-nast-traveler.svg`,
      imgAlt: "Traveler"
    }
  ];
  return /* @__PURE__ */ g(le, { color: "primary", border: "topAndBottom", padding: "small", children: /* @__PURE__ */ g(ne, { children: /* @__PURE__ */ g(I, { gap: "3", isFullWidth: !0, justifyContent: o ? "space-around" : e ? "center" : "space-between", alignItems: "center", children: l.map((n) => /* @__PURE__ */ g($e, { src: n.imgSrc, alt: n.imgAlt }, n.imgSrc)) }) }) });
}, DO = () => {
  const { t } = ae(["landingPage", "common"]), {
    config: { assetsUrl: e }
  } = ie((r) => ({ config: r.config })), o = `${e}/landing-page`, l = [
    {
      title: t("page.collectionhp.home1.title"),
      location: t("page.collectionhp.home1.location"),
      imgSrc: `${o}/lovely-designer-apartment.png`,
      imgSrcMobile: `${o}/lovely-designer-apartment-mobile.png`
    },
    {
      title: t("page.collectionhp.home2.title"),
      location: t("page.collectionhp.home2.location"),
      imgSrc: `${o}/mediterranean-house.png`,
      imgSrcMobile: `${o}/mediterranean-house-mobile.png`
    },
    {
      title: t("page.collectionhp.home3.title"),
      location: t("page.collectionhp.home3.location"),
      imgSrc: `${o}/riverfront-retreat.png`,
      imgSrcMobile: `${o}/riverfront-retreat-mobile.png`
    }
  ], { isDesktop: a } = ue(), n = () => {
    H("button", {
      area: "homepage_collection",
      action: "click",
      text: "view_more_homes"
    }, {
      eventCallback: () => window.location.href = t("page.collectionhp.homessection.browse-home.link"),
      eventTimeout: 2e3
    });
  };
  return /* @__PURE__ */ g(le, { color: "primary", padding: a ? "large" : "small", children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ C(I, { gap: "10", children: [
      /* @__PURE__ */ g(J, { level: 2, hasHeaderTag: !0, children: t("page.collectionhp.homessection.title") }),
      /* @__PURE__ */ g(P, { size: "lg", children: t("page.collectionhp.homessection.subtitle") }),
      /* @__PURE__ */ g(Ke, { children: l.map((r) => /* @__PURE__ */ C(Me, { children: [
        /* @__PURE__ */ g($e, { src: r.imgSrc, alt: r.title, srcMobile: r.imgSrcMobile }),
        /* @__PURE__ */ g(J, { level: 3, hasHeaderTag: !0, children: r.title }),
        /* @__PURE__ */ g(P, { size: "lg", children: r.location })
      ] }, r.title)) })
    ] }),
    /* @__PURE__ */ g(I, { justifyContent: "center", children: /* @__PURE__ */ g(
      Y,
      {
        size: "regular",
        color: "tertiary",
        text: t("common:global.collection.browsehomes"),
        onClick: n
      }
    ) })
  ] }) });
}, NO = ({ product: t }) => {
  const { t: e } = ae(["landingPage"]), {
    config: { assetsUrl: o },
    config: { locale: l }
  } = ie((c) => ({ config: c.config })), n = `${`${o}/landing-page`}/membership-peters-home.png`, { isDesktop: r } = ue(), i = () => {
    window.location.href = "/p/collection-membership-benefits-price", H("button", {
      area: "homepage_collection",
      action: "click",
      text: "book_call"
    });
  };
  return /* @__PURE__ */ g(le, { color: "primary", border: "top", padding: r ? "large" : "small", children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ g(J, { level: 2, hasHeaderTag: !0, children: e("page.collectionhp.benefitssection.title") }),
    /* @__PURE__ */ C(Ke, { children: [
      /* @__PURE__ */ g(Me, { children: /* @__PURE__ */ C(le, { color: "secondary", padding: "small", children: [
        /* @__PURE__ */ g(
          P,
          {
            dangerouslySetInnerHTML: {
              __html: t ? e("page.collectionhp.benefitssection.body", {
                price: t.price.toLocaleString(l, {
                  style: "currency",
                  currency: t.currency,
                  maximumFractionDigits: 0
                })
              }) : e("page.collectionhp.benefitssection.body.fallback")
            }
          }
        ),
        /* @__PURE__ */ g("br", {}),
        /* @__PURE__ */ g(Y, { color: "secondary", onClick: i, children: e("page.collectionhp.benefitssection.cta") })
      ] }) }),
      /* @__PURE__ */ C(Me, { gap: "2", children: [
        /* @__PURE__ */ g($e, { width: "large", alt: e("page.collectionhp.benefitssection.home.location"), src: n }),
        /* @__PURE__ */ g(I, { justifyContent: "end", children: /* @__PURE__ */ g(P, { children: e("page.collectionhp.benefitssection.home.location") }) })
      ] })
    ] })
  ] }) });
}, MO = () => {
  const { t } = ae("landingPage"), {
    config: { assetsUrl: e }
  } = ie((i) => ({ config: i.config })), o = `${e}/landing-page`, { isDesktop: l } = ue(), a = [
    {
      body: t("page.collectionhp.testimonie1.body"),
      label: t("page.collectionhp.testimonie1.label"),
      imgSrc: `${o}/testimonie-miglino.svg`,
      imgAlt: t("page.collectionhp.testimonie1.label")
    },
    {
      body: t("page.collectionhp.testimonie2.body"),
      label: t("page.collectionhp.testimonie2.label"),
      imgSrc: `${o}/testimonie-eggleton.svg`,
      imgAlt: t("page.collectionhp.testimonie2.label")
    },
    {
      body: t("page.collectionhp.testimonie3.body"),
      label: t("page.collectionhp.testimonie3.label"),
      imgSrc: `${o}/testimonie-laetitia.svg`,
      imgAlt: t("page.collectionhp.testimonie3.label")
    }
  ], n = () => {
    H("button", {
      area: "homepage_collection",
      action: "click",
      text: "meet_members"
    }, {
      eventCallback: () => window.location.href = "/p/member-portrait",
      eventTimeout: 2e3
    });
  }, r = new Array(5).fill(null).map((i, c) => /* @__PURE__ */ g(me, { name: "star-full" }, `star-${c}`));
  return /* @__PURE__ */ g(
    le,
    {
      color: "tertiary",
      padding: l ? "large" : "small",
      bgImage: `${o}/collection-logo-bg.svg`,
      children: /* @__PURE__ */ C(ne, { children: [
        /* @__PURE__ */ g(J, { level: 2, hasHeaderTag: !0, children: t("page.collectionhp.testimonies.title") }),
        /* @__PURE__ */ g(Ke, { children: a.map((i) => /* @__PURE__ */ g(Me, { children: /* @__PURE__ */ g(Nr, { color: "primary", border: !1, children: /* @__PURE__ */ C(I, { direction: "column", children: [
          /* @__PURE__ */ g(I, { gap: "0", children: r }),
          /* @__PURE__ */ g(P, { children: i.body }),
          /* @__PURE__ */ g(P, { isBold: !0, children: i.label }),
          /* @__PURE__ */ g($e, { src: i.imgSrc, alt: i.imgAlt })
        ] }) }) }, i.label)) }),
        /* @__PURE__ */ g(I, { justifyContent: "center", children: /* @__PURE__ */ g(Y, { onClick: n, size: "regular", color: "tertiary", isContrasted: !0, children: t("page.collectionhp.testimonies.cta") }) })
      ] })
    }
  );
}, PO = ({ product: t }) => {
  const { t: e } = ae(["landingPage", "common"]), { isDesktop: o } = ue(), {
    config: { locale: l }
  } = ie((n) => ({ config: n.config })), a = [
    {
      title: e("page.collectionhp.faq.question1.title"),
      content: /* @__PURE__ */ g(P, { dangerouslySetInnerHTML: { __html: e("page.collectionhp.faq.question1.body") } }),
      value: e("page.collectionhp.faq.question1.title")
    },
    ...t ? [
      {
        title: e("page.collectionhp.faq.question2.title"),
        content: /* @__PURE__ */ g(
          P,
          {
            dangerouslySetInnerHTML: {
              __html: e("page.collectionhp.faq.question2.content", {
                price: t.price.toLocaleString(l, {
                  style: "currency",
                  currency: t.currency,
                  maximumFractionDigits: 0
                })
              })
            }
          }
        ),
        value: e("page.collectionhp.faq.question2.title")
      }
    ] : [],
    {
      title: e("page.collectionhp.faq.question3.title"),
      content: /* @__PURE__ */ g(P, { dangerouslySetInnerHTML: { __html: e("page.collectionhp.faq.question3.content") } }),
      value: e("page.collectionhp.faq.question3.title")
    },
    {
      title: e("page.collectionhp.faq.question4.title"),
      content: /* @__PURE__ */ g(P, { dangerouslySetInnerHTML: { __html: e("page.collectionhp.faq.question4.content") } }),
      value: e("page.collectionhp.faq.question4.title")
    },
    {
      title: e("page.collectionhp.faq.question5.title"),
      content: /* @__PURE__ */ g(P, { dangerouslySetInnerHTML: { __html: e("page.collectionhp.faq.question5.content") } }),
      value: e("page.collectionhp.faq.question5.title")
    }
  ];
  return /* @__PURE__ */ g(le, { color: "primary", padding: o ? "large" : "small", children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ g(J, { level: 2, hasHeaderTag: !0, children: e("page.collectionhp.faq.title") }),
    /* @__PURE__ */ g(P, { dangerouslySetInnerHTML: { __html: e("page.collectionhp.faq.subtitle") } }),
    /* @__PURE__ */ g(Or, { items: a })
  ] }) });
}, AO = ({ landingPageData: t, isButtonDisabled: e, setIsButtonDisabled: o }) => {
  const { t: l } = ae(["landingPage", "common"]), {
    config: { assetsUrl: a }
  } = ie((x) => ({ config: x.config })), n = `${a}/landing-page`, [r, i] = F(!1), { isDesktop: c } = ue(), { refetch: s, loading: d } = lo({
    promiseFn: la,
    enabled: !1
  }), u = [
    {
      imgSrc: `${n}/check-your-eligibility.jpg`,
      imgAlt: "check your eligibility",
      title: l("page.collectionhp.howitwork.step1.title"),
      text: l("page.collectionhp.howitwork.step1.body")
    },
    {
      imgSrc: `${n}/become-a-collection-member.jpg`,
      imgAlt: "become a collection member",
      title: l("page.collectionhp.howitwork.step2.title"),
      text: l("page.collectionhp.howitwork.step2.body")
    },
    {
      imgSrc: `${n}/enjoy-your-membership.jpg`,
      imgAlt: "enjoy your membership",
      title: l("page.collectionhp.howitwork.step3.title"),
      text: l("page.collectionhp.howitwork.step3.body")
    }
  ], b = () => {
    H("button", {
      area: "homepage_collection_how_it_works",
      action: "click",
      text: "start_free_trial"
    }, {
      eventCallback: () => window.location.href = "/collection/subscription/payment?start-trial=true",
      eventTimeout: 2e3
    });
  }, f = () => {
    H("button", {
      area: "homepage_collection_how_it_works",
      action: "click",
      text: "join_now"
    }, {
      eventCallback: () => window.location.href = "/collection/subscription/payment",
      eventTimeout: 2e3
    });
  }, p = () => {
    H("button", {
      area: "homepage_collection_how_it_works",
      action: "click",
      text: "create_home"
    }, {
      eventCallback: () => window.location.href = "/homes/create",
      eventTimeout: 2e3
    });
  }, h = () => {
    H("button", {
      area: "homepage_collection_how_it_works",
      action: "click",
      text: "propose_home"
    }, {
      eventCallback: () => window.location.href = "/collection/propose-my-home",
      eventTimeout: 2e3
    });
  }, v = () => {
    i(!0);
  }, m = async () => {
    t.home?.id && (await s(t.home.id), o(!0), H("button", {
      area: "homepage_collection_hero",
      action: "click",
      text: "check_eligibility"
    }));
  }, y = [
    {
      status: L.ELIGIBLE_DONE_TRIAL,
      mainButton: {
        text: "global.collection.joinnow",
        onClick: f
      },
      homeInfo: {
        text: "page.collectionhp.howitwork.elligible",
        imgSrc: `${n}/how-it-works-eligible.png`
      }
    },
    {
      status: L.ELIGIBLE_NOT_DONE_TRIAL,
      freeTrialButton: {
        key: "startFreeTrial",
        text: "global.collection.startfreetrial",
        onClick: b
      },
      mainButton: {
        text: "global.collection.joinnow",
        onClick: f
      },
      homeInfo: {
        text: "page.collectionhp.howitwork.elligible",
        imgSrc: `${n}/how-it-works-eligible.png`
      }
    },
    {
      status: L.NOT_CHECKED_OR_MAYBE,
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: v
      }
    },
    {
      status: L.NOT_ELIGIBLE,
      homeInfo: {
        text: "page.collectionhp.howitwork.notelligible",
        imgSrc: `${n}/how-it-works-not-eligible.png`,
        linkSrc: "/p/contact-us-homeexchange-collection",
        linkText: "page.collectionhp.howitwork.contact.cta"
      }
    },
    {
      status: L.NO_HOME,
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: p
      }
    },
    {
      status: L.UNLOGGED,
      mainButton: {
        text: "global.collection.ishomeeligible",
        onClick: h
      }
    }
  ].find((x) => x.status === t.status), k = t.status === L.NOT_CHECKED_OR_MAYBE && e;
  return y && /* @__PURE__ */ g("div", { id: "how-it-works", children: /* @__PURE__ */ g(le, { color: "secondary", padding: c ? "large" : "small", children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ g(J, { level: 2, hasHeaderTag: !0, children: l("page.collectionhp.howitwork.title") }),
    /* @__PURE__ */ g(Ke, { children: u.map((x, j) => /* @__PURE__ */ C(Me, { children: [
      /* @__PURE__ */ g($e, { src: x.imgSrc, alt: x.imgAlt }),
      /* @__PURE__ */ C(I, { flexWrap: "nowrap", children: [
        /* @__PURE__ */ g(J, { children: j + 1 }),
        /* @__PURE__ */ C(I, { gap: "3", children: [
          /* @__PURE__ */ g(J, { hasHeaderTag: !0, children: l(x.title) }),
          /* @__PURE__ */ g(P, { children: l(x.text) }),
          j === 0 && y.homeInfo && /* @__PURE__ */ C(Re, { children: [
            /* @__PURE__ */ C(I, { flexWrap: "nowrap", children: [
              /* @__PURE__ */ g($e, { src: y.homeInfo.imgSrc, alt: x.title }),
              /* @__PURE__ */ g(P, { isBold: !0, children: l(y.homeInfo.text) })
            ] }),
            y.homeInfo.linkText && /* @__PURE__ */ g(ql, { href: y.homeInfo.linkSrc, children: l(y.homeInfo.linkText) })
          ] })
        ] })
      ] })
    ] }, x.title)) }),
    /* @__PURE__ */ C(I, { justifyContent: "center", children: [
      y.freeTrialButton && /* @__PURE__ */ g(
        Y,
        {
          size: "regular",
          text: l(y.freeTrialButton.text),
          color: "primary",
          onClick: y.freeTrialButton.onClick
        }
      ),
      y.mainButton && /* @__PURE__ */ g(
        Y,
        {
          size: "regular",
          text: l(y.mainButton.text),
          color: y.freeTrialButton ? "tertiary" : "primary",
          onClick: y.mainButton.onClick,
          disabled: k
        }
      )
    ] }),
    k && /* @__PURE__ */ g(I, { justifyContent: "center", children: /* @__PURE__ */ g(P, { children: l("page.collectionhp.eligibilitycheck.label") }) }),
    /* @__PURE__ */ g(
      oa,
      {
        isModalOpen: r,
        setIsModalOpen: i,
        isLoading: d,
        onConfirmIsMyHomeEligible: m
      }
    )
  ] }) }) });
}, LO = () => {
  const { t } = ae(["landingPage", "common"]), { isMobile: e } = ue(), o = () => {
    H("button", {
      area: "homepage_collection_contact",
      action: "click",
      text: "contact_us"
    }, {
      eventCallback: () => window.location.href = "/p/contact-us-homeexchange-collection",
      eventTimeout: 2e3
    });
  };
  return /* @__PURE__ */ g(le, { color: "secondary", children: /* @__PURE__ */ g(ne, { children: /* @__PURE__ */ C(I, { direction: "column", alignItems: "center", justifyContent: "center", gap: "12", children: [
    /* @__PURE__ */ C(I, { direction: "column", alignItems: "center", gap: "4", children: [
      /* @__PURE__ */ g(J, { hasHeaderTag: !0, level: 2, children: t("page.collectionhp.contact.title") }),
      /* @__PURE__ */ g(P, { center: e, children: t("page.collectionhp.contact.subtitle") })
    ] }),
    /* @__PURE__ */ g(
      Y,
      {
        size: "regular",
        onClick: o,
        color: "secondary",
        text: t("common:global.collection.contactus")
      }
    )
  ] }) }) });
}, TO = () => {
  const { t } = ae(["landingPage", "common"]), {
    config: { assetsUrl: e }
  } = ie((n) => ({ config: n.config })), o = `${e}/landing-page/selection-criteria.png`, l = `${e}/landing-page/selection-criteria-mobile.png`, { isMobile: a } = ue();
  return /* @__PURE__ */ g(le, { imageSrc: a ? l : o, imageAlt: "selection criteria", color: "tertiary", children: /* @__PURE__ */ C(ne, { children: [
    /* @__PURE__ */ g(J, { hasHeaderTag: !0, "data-theme": "collection", level: 2, children: t("page.collectionhp.whatis.title") }),
    /* @__PURE__ */ g(
      Ba,
      {
        t,
        i18nKey: "page.collectionhp.whatis.body",
        components: {
          Text: /* @__PURE__ */ g(P, { color: "inverted" })
        }
      }
    )
  ] }) });
}, qO = () => {
  const { t } = ae("landingPage"), {
    config: { assetsUrl: e }
  } = ie((a) => ({ config: a.config })), o = `${e}/landing-page`, l = [
    {
      imageSrc: `${o}/diamond.svg`,
      imageAlt: "verifies homes",
      title: t("page.collectionhp.keybenefit1.title"),
      text: t("page.collectionhp.keybenefit1.body")
    },
    {
      imageSrc: `${o}/guarantees.svg`,
      imageAlt: "Unmatched guarantees",
      title: t("page.collectionhp.keybenefit2.title"),
      text: t("page.collectionhp.keybenefit2.body")
    },
    {
      imageSrc: `${o}/support.svg`,
      imageAlt: "premium support",
      title: t("page.collectionhp.keybenefit3.title"),
      text: t("page.collectionhp.keybenefit3.body")
    }
  ];
  return /* @__PURE__ */ g(le, { centerContent: !0, color: "primary", border: "top", children: /* @__PURE__ */ g(ne, { children: /* @__PURE__ */ g(Ke, { children: l.map((a) => /* @__PURE__ */ C(Me, { gap: "1", children: [
    /* @__PURE__ */ g($e, { src: a.imageSrc, alt: a.imageAlt, height: 45, widthInPx: 43 }),
    /* @__PURE__ */ g(J, { hasHeaderTag: !0, level: 3, children: a.title }),
    /* @__PURE__ */ g(P, { children: a.text })
  ] }, a.title)) }) }) });
}, IO = (t) => {
  let e, o;
  const l = t?.product;
  if (t && OO(t)) {
    const { freeTrialAllowed: a } = t.user, n = t.home?.eligibilityStatus === at.CHECKED_ELIGIBLE, r = t.home && {
      imgSrc: t.home.picture ?? "",
      hasAlreadySentEligibilityCheck: t.home.hasAlreadySentEligibilityCheck ?? !1,
      id: t.home.id ?? ""
    };
    n && !a ? (e = L.ELIGIBLE_DONE_TRIAL, o = r) : n && a ? (e = L.ELIGIBLE_NOT_DONE_TRIAL, o = r) : t.home?.eligibilityStatus === at.CHECKED_MAYBE || t.home?.eligibilityStatus === at.NOT_CHECKED ? (e = L.NOT_CHECKED_OR_MAYBE, o = r) : t.home?.eligibilityStatus ? t.home?.eligibilityStatus === at.CHECKED_NOT_ELIGIBLE ? e = L.NOT_ELIGIBLE : e = L.UNLOGGED : e = L.NO_HOME;
  } else
    e = L.UNLOGGED, o = void 0;
  return {
    status: e,
    home: o,
    product: l
  };
};
function BO({ defaultData: t }) {
  const [e, o] = F(t?.home?.hasAlreadySentEligibilityCheck || !1), {
    config: { locale: l, currency: a },
    config: n
  } = ie((d) => ({ config: d.config })), { data: r, loading: i } = lo({
    promiseFn: n.tokens?.accessToken ? () => ds(a, l) : () => us(a, l),
    initialData: t,
    enabled: !t
  }), c = IO(r), s = e || c.home?.hasAlreadySentEligibilityCheck || !1;
  return {
    landingPageData: c,
    isButtonDisabled: s,
    setIsButtonDisabled: o,
    loading: i
  };
}
const RO = ({ defaultData: t }) => {
  const { landingPageData: e, isButtonDisabled: o, setIsButtonDisabled: l, loading: a } = BO({
    defaultData: t
  });
  return e && !a && /* @__PURE__ */ C(Re, { children: [
    /* @__PURE__ */ g(
      EO,
      {
        landingPageData: e,
        isButtonDisabled: o,
        setIsButtonDisabled: l
      }
    ),
    /* @__PURE__ */ g(SO, {}),
    /* @__PURE__ */ g(DO, {}),
    /* @__PURE__ */ g(NO, { product: e.product }),
    /* @__PURE__ */ g(qO, {}),
    /* @__PURE__ */ g(TO, {}),
    /* @__PURE__ */ g(
      AO,
      {
        landingPageData: e,
        isButtonDisabled: o,
        setIsButtonDisabled: l
      }
    ),
    /* @__PURE__ */ g(MO, {}),
    /* @__PURE__ */ g(PO, { product: e.product }),
    /* @__PURE__ */ g(LO, {})
  ] });
};
function JO({ config: t, defaultData: e }) {
  return /* @__PURE__ */ g(xO, { config: t, children: /* @__PURE__ */ g(RO, { defaultData: e }) });
}
export {
  JO as LandingPage,
  sa as LandingPageContext,
  xO as LandingPageProvider,
  $O as createLandingPageStore,
  Ft as heFetch,
  ca as setLandingPageFetchConfig,
  ie as useLandingPageContext
};
